msgid ""
msgstr ""
"POT-Creation-Date: 2025-11-03 22:42-0700\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: en\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#: src/routes/_authenticated/trade/withdraw/products/index.tsx:174
msgid " unit"
msgstr " unit"

#: src/routes/_authenticated/trade/withdraw/products/index.tsx:174
msgid " units"
msgstr " units"

#: src/routes/_authenticated/settings/-components/payment-methods/PlaidFinalizeForm.tsx:77
#~ msgid "{0, plural, one {{1}} other {{2}}}"
#~ msgstr "{0, plural, one {{1}} other {{2}}}"

#. placeholder {0}: plaidAccounts.length
#: src/shared/components/payment-methods/PlaidFinalizeForm.tsx:93
msgid "{0, plural, one {We just need a few more details to connect this account to our platform.} other {We just need a few more details to connect these accounts to our platform.}}"
msgstr "{0, plural, one {We just need a few more details to connect this account to our platform.} other {We just need a few more details to connect these accounts to our platform.}}"

#. placeholder {0}: values.size
#. placeholder {1}: import { CalendarIcon } from "@heroicons/react/24/solid"; import { plural, t } from "@lingui/core/macro"; import { type ComponentProps, type ForwardRefRenderFunction, forwardRef } from "react"; import { cn } from "@/lib/utils"; import { Multiselect, MultiselectContent, MultiselectGroup, MultiselectItem, MultiselectTrigger, } from "@/shared/components/ui/multiselect"; interface DateMultiselectProps extends ComponentProps<typeof Multiselect> { dates: string[]; values: Set<string>; onValuesChange: (values: Set<string>) => void; } const DateMultiselect: ForwardRefRenderFunction<HTMLButtonElement, DateMultiselectProps> = ( { dates, values, onValuesChange, ...rest }, ref, ) => { return ( <Multiselect {...rest}> <MultiselectTrigger ref={ref} className={cn(values.size > 0 && "text-charcoal")}> <span className="flex items-center gap-2"> <CalendarIcon className="h-4 w-4 shrink-0" /> {plural(values.size, { zero: t`No dates selected`, one: t`${values.size} date selected`, other: t`${values.size} dates selected`, })} </span> </MultiselectTrigger> <MultiselectContent> <MultiselectGroup> {dates.map((date) => ( <MultiselectItem key={date} value={date} isSelected={values.has(date)} onSelect={(currentValue) => { const next = new Set(values); if (next.has(currentValue)) { next.delete(currentValue); } else { next.add(currentValue); } onValuesChange(next); }} > <span>{date}</span> </MultiselectItem> ))} </MultiselectGroup> </MultiselectContent> </Multiselect> ); }; export default forwardRef(DateMultiselect); 
#. placeholder {2}: import { CalendarIcon } from "@heroicons/react/24/solid"; import { plural, t } from "@lingui/core/macro"; import { type ComponentProps, type ForwardRefRenderFunction, forwardRef } from "react"; import { cn } from "@/lib/utils"; import { Multiselect, MultiselectContent, MultiselectGroup, MultiselectItem, MultiselectTrigger, } from "@/shared/components/ui/multiselect"; interface DateMultiselectProps extends ComponentProps<typeof Multiselect> { dates: string[]; values: Set<string>; onValuesChange: (values: Set<string>) => void; } const DateMultiselect: ForwardRefRenderFunction<HTMLButtonElement, DateMultiselectProps> = ( { dates, values, onValuesChange, ...rest }, ref, ) => { return ( <Multiselect {...rest}> <MultiselectTrigger ref={ref} className={cn(values.size > 0 && "text-charcoal")}> <span className="flex items-center gap-2"> <CalendarIcon className="h-4 w-4 shrink-0" /> {plural(values.size, { zero: t`No dates selected`, one: t`${values.size} date selected`, other: t`${values.size} dates selected`, })} </span> </MultiselectTrigger> <MultiselectContent> <MultiselectGroup> {dates.map((date) => ( <MultiselectItem key={date} value={date} isSelected={values.has(date)} onSelect={(currentValue) => { const next = new Set(values); if (next.has(currentValue)) { next.delete(currentValue); } else { next.add(currentValue); } onValuesChange(next); }} > <span>{date}</span> </MultiselectItem> ))} </MultiselectGroup> </MultiselectContent> </Multiselect> ); }; export default forwardRef(DateMultiselect); 
#. placeholder {3}: import { CalendarIcon } from "@heroicons/react/24/solid"; import { plural, t } from "@lingui/core/macro"; import { type ComponentProps, type ForwardRefRenderFunction, forwardRef } from "react"; import { cn } from "@/lib/utils"; import { Multiselect, MultiselectContent, MultiselectGroup, MultiselectItem, MultiselectTrigger, } from "@/shared/components/ui/multiselect"; interface DateMultiselectProps extends ComponentProps<typeof Multiselect> { dates: string[]; values: Set<string>; onValuesChange: (values: Set<string>) => void; } const DateMultiselect: ForwardRefRenderFunction<HTMLButtonElement, DateMultiselectProps> = ( { dates, values, onValuesChange, ...rest }, ref, ) => { return ( <Multiselect {...rest}> <MultiselectTrigger ref={ref} className={cn(values.size > 0 && "text-charcoal")}> <span className="flex items-center gap-2"> <CalendarIcon className="h-4 w-4 shrink-0" /> {plural(values.size, { zero: t`No dates selected`, one: t`${values.size} date selected`, other: t`${values.size} dates selected`, })} </span> </MultiselectTrigger> <MultiselectContent> <MultiselectGroup> {dates.map((date) => ( <MultiselectItem key={date} value={date} isSelected={values.has(date)} onSelect={(currentValue) => { const next = new Set(values); if (next.has(currentValue)) { next.delete(currentValue); } else { next.add(currentValue); } onValuesChange(next); }} > <span>{date}</span> </MultiselectItem> ))} </MultiselectGroup> </MultiselectContent> </Multiselect> ); }; export default forwardRef(DateMultiselect); 
#: src/routes/_authenticated/trade/-components/DateMultiselect.tsx:29
msgid "{0, plural, zero {{1}} one {{2}} other {{3}}}"
msgstr "{0, plural, zero {{1}} one {{2}} other {{3}}}"

#. placeholder {0}: formatCurrency(totalUsd ?? 0)
#. placeholder {0}: formatOz(totalOz ?? 0)
#: src/routes/_authenticated/balance/-components/PremiumSummaryCard.tsx:90
#: src/routes/_authenticated/balance/-components/PremiumSummaryCard.tsx:91
msgid "{0}"
msgstr "{0}"

#. placeholder {0}: formatOz(holding.availableOz)
#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:496
msgid "{0} available"
msgstr "{0} available"

#. placeholder {0}: values.size
#: src/routes/_authenticated/trade/-components/DateMultiselect.tsx:31
msgid "{0} date selected"
msgstr "{0} date selected"

#. placeholder {0}: values.size
#: src/routes/_authenticated/trade/-components/DateMultiselect.tsx:32
msgid "{0} dates selected"
msgstr "{0} dates selected"

#: src/routes/_authenticated/trade/withdraw/products/index.tsx:208
#~ msgid "{0} each"
#~ msgstr "{0} each"

#. placeholder {0}: formatCurrency(selected * holding.pricePerOz)
#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:519
msgid "{0} est."
msgstr "{0} est."

#. placeholder {0}: formatOz(overBy)
#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:517
#: src/routes/_authenticated/trade/withdraw/products/index.tsx:87
msgid "{0} over available"
msgstr "{0} over available"

#: src/routes/_authenticated/trade/withdraw/products/signature.tsx:187
#~ msgid "{0} product {1}"
#~ msgstr "{0} product {1}"

#. placeholder {0}: premiums.length
#: src/routes/_authenticated/balance/premiums.tsx:171
msgid "{0} product on account"
msgstr "{0} product on account"

#. placeholder {0}: formatOz(remaining)
#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:517
#: src/routes/_authenticated/trade/withdraw/products/index.tsx:87
msgid "{0} remaining"
msgstr "{0} remaining"

#. placeholder {0}: formatOz(selected)
#. placeholder {0}: metalLabel(holding.metal)
#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:494
#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:501
#: src/routes/_authenticated/trade/withdraw/products/index.tsx:72
msgid "{0} selected"
msgstr "{0} selected"

#. placeholder {0}: formatOz(required)
#. placeholder {0}: formatOz(selected)
#. placeholder {1}: formatOz(holding.availableOz)
#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:505
#: src/routes/_authenticated/trade/withdraw/products/index.tsx:76
msgid "{0} selected of {1} available"
msgstr "{0} selected of {1} available"

#. placeholder {0}: formatOz(resolved.unitOz * resolved.quantity)
#: src/routes/_authenticated/trade/withdraw/products/index.tsx:186
msgid "{0} total"
msgstr "{0} total"

#. placeholder {0}: term.percentage
#. placeholder {1}: term.percentage * 100
#: src/routes/_authenticated/referrals.tsx:175
msgid "{0}% on leased metal ({1} oz on 100 oz deployed into leases)"
msgstr "{0}% on leased metal ({1} oz on 100 oz deployed into leases)"

#. placeholder {0}: term.percentage
#. placeholder {1}: term.percentage * 100
#. placeholder {2}: term.lowerBound
#. placeholder {3}: term.upperBound || "∞"
#: src/routes/_authenticated/referrals.tsx:160
msgid "{0}% on purchases made by referred users ({1} oz on 100 oz purchased) from {2} oz to {3} oz"
msgstr "{0}% on purchases made by referred users ({1} oz on 100 oz purchased) from {2} oz to {3} oz"

#: src/shared/components/InterestEarnedChartContainer.tsx:108
#: src/shared/components/InterestEarnedChartContainer.tsx:115
msgid "{commodityName}: {formattedCount}"
msgstr "{commodityName}: {formattedCount}"

#: src/util/numberUtils.ts:64
msgid "{formatted} au oz"
msgstr "{formatted} au oz"

#: src/routes/_authenticated/spreads.tsx:52
msgid "{formattedMinAmount} minimum for all purchases"
msgstr "{formattedMinAmount} minimum for all purchases"

#: src/routes/_authenticated/yield/-components/YieldTable.tsx:210
msgid "{formattedOz} on {typeLabel}"
msgstr "{formattedOz} on {typeLabel}"

#: src/shared/components/payment-methods/UpgradePaymentMethodDialog.tsx:214
msgid "{newAccountCount, plural, one {Add this account instead} other {Add these accounts instead}}"
msgstr "{newAccountCount, plural, one {Add this account instead} other {Add these accounts instead}}"

#: src/routes/_authenticated/opportunities/-components/ReviewPeriodAlert.tsx:26
msgid "{numDays} day"
msgstr "{numDays} day"

#: src/routes/_authenticated/opportunities/-components/ReviewPeriodAlert.tsx:26
msgid "{numDays} days"
msgstr "{numDays} days"

#: src/routes/_authenticated/opportunities/-components/ReviewPeriodAlert.tsx:30
msgid "{numHoursRemaining} hr"
msgstr "{numHoursRemaining} hr"

#: src/routes/_authenticated/opportunities/-components/ReviewPeriodAlert.tsx:30
msgid "{numHoursRemaining} hrs"
msgstr "{numHoursRemaining} hrs"

#: src/routes/_authenticated/balance/-components/PremiumSummaryCard.tsx:83
msgid "{productCount} product on account"
msgstr "{productCount} product on account"

#: src/util/dateUtils.ts:93
msgid "{total} mo"
msgstr "{total} mo"

#: src/util/dateUtils.ts:93
msgid "{total} yr"
msgstr "{total} yr"

#: src/routes/_authenticated/balance/-components/BalanceOverviewCard.tsx:40
msgid "*Select Metal For More Info"
msgstr "*Select Metal For More Info"

#: src/shared/components/Footer.tsx:17
msgid "© {currentYear} Monetary Metals & Co."
msgstr "© {currentYear} Monetary Metals & Co."

#: src/routes/_authenticated/trade/-components/MetalTypeComboBox.tsx:55
msgid "+ Add Custom Metal"
msgstr "+ Add Custom Metal"

#: src/routes/_authenticated/trade/-components/VaultLocationComboBox.tsx:40
msgid "+ Add Custom Vault"
msgstr "+ Add Custom Vault"

#: src/util/feeSchedule.ts:36
msgid "+/- 0.40%"
msgstr "+/- 0.40%"

#: src/util/feeSchedule.ts:26
msgid "+/- 0.55%"
msgstr "+/- 0.55%"

#: src/util/feeSchedule.ts:16
msgid "+/- 0.75%"
msgstr "+/- 0.75%"

#: src/shared/components/Footer.tsx:26
msgid "+1 (480) 867-2100"
msgstr "+1 (480) 867-2100"

#: src/shared/components/Footer.tsx:25
#~ msgid "+1 (646) 653-9729"
#~ msgstr "+1 (646) 653-9729"

#: src/routes/_authenticated/opportunities/-components/ReviewPeriodAlert.tsx:33
msgid "<"
msgstr "<"

#: src/routes/_authenticated/balance/premiums.tsx:103
msgid "<0>Brand <1>{brand}</1></0>"
msgstr "<0>Brand <1>{brand}</1></0>"

#: src/routes/_authenticated/balance/premiums.tsx:111
msgid "<0>Serial <1>{serial}</1></0>"
msgstr "<0>Serial <1>{serial}</1></0>"

#: src/util/feeSchedule.ts:31
msgid "$1 Million or more"
msgstr "$1 Million or more"

#: src/util/feeSchedule.ts:21
msgid "$250K - $1 Million"
msgstr "$250K - $1 Million"

#: src/routes/_authenticated/spreads.tsx:55
#~ msgid "$5K minimum for all purchases"
#~ msgstr "$5K minimum for all purchases"

#: src/routes/_authenticated/trade/withdraw/products/index.tsx:173
msgid "0 units"
msgstr "0 units"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/foreignCorpDocs.ts:82
msgid "1"
msgstr "1"

#: src/routes/_authenticated/opportunities/-components/ReviewPeriodAlert.tsx:33
msgid "1 hr"
msgstr "1 hr"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/NewScheduleForm.tsx:42
#: src/routes/_authenticated/trade/-components/Purchase/Recurring/RecurringPurchases.tsx:355
msgid "16th"
msgstr "16th"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/NewScheduleForm.tsx:41
#: src/routes/_authenticated/trade/-components/Purchase/Recurring/RecurringPurchases.tsx:354
msgid "1st"
msgstr "1st"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/NewScheduleForm.tsx:43
#: src/routes/_authenticated/trade/-components/Purchase/Recurring/RecurringPurchases.tsx:356
msgid "1st and 16th"
msgstr "1st and 16th"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/foreignCorpDocs.ts:83
msgid "2"
msgstr "2"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/foreignCorpDocs.ts:84
msgid "3"
msgstr "3"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/foreignCorpDocs.ts:85
msgid "4"
msgstr "4"

#: src/shared/components/Footer.tsx:18
msgid "4343 N Scottsdale Road Suite 150 Scottsdale, AZ 85251"
msgstr "4343 N Scottsdale Road Suite 150 Scottsdale, AZ 85251"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:581
msgid "A copy of its articles of incorporation or operating agreement"
msgstr "A copy of its articles of incorporation or operating agreement"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:520
msgid "A copy of the LLC's certificate of formation or registration"
msgstr "A copy of the LLC's certificate of formation or registration"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:530
msgid "A copy of the signed operating agreement (or foreign equivalent) identifying the managing member(s) and authorized signatories"
msgstr "A copy of the signed operating agreement (or foreign equivalent) identifying the managing member(s) and authorized signatories"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:554
msgid "A copy of the signed partnership agreement identifying the general partner and/or the designate empowered to sign legal agreement"
msgstr "A copy of the signed partnership agreement identifying the general partner and/or the designate empowered to sign legal agreement"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:571
msgid "A copy of the state registration of the corporation"
msgstr "A copy of the state registration of the corporation"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:546
msgid "A copy of the state registration of the partnership"
msgstr "A copy of the state registration of the partnership"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:599
msgid "A list of individuals or entities who own over 25% of the corporation with their names and country of citizenship"
msgstr "A list of individuals or entities who own over 25% of the corporation with their names and country of citizenship"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:591
msgid "A list of officer signatures, or signed, certified corporate resolutions identifying the corporate officer(s) empowered to sign legal documents (if applicable)"
msgstr "A list of officer signatures, or signed, certified corporate resolutions identifying the corporate officer(s) empowered to sign legal documents (if applicable)"

#: src/routes/_unauthenticated/-components/EmailVerification.tsx:71
msgid "A verification code has been sent to {email}. Please enter the code below to verify your account."
msgstr "A verification code has been sent to {email}. Please enter the code below to verify your account."

#: src/routes/_authenticated/settings/-components/ManageCookiesForm.tsx:38
#: src/shared/components/CookiesConsentBanner.tsx:62
msgid "Accept Cookies"
msgstr "Accept Cookies"

#: src/routes/_authenticated/balance/-components/BalanceTable.tsx:26
#: src/routes/_authenticated/trade/withdraw/cash/review.tsx:123
msgid "Account"
msgstr "Account"

#: src/routes/_authenticated/onboarding/-components/Signatory2ReviewAndSign.tsx:46
msgid "Account Address"
msgstr "Account Address"

#: src/shared/components/payment-methods/UpgradePaymentMethodDialog.tsx:123
msgid "Account connected"
msgstr "Account connected"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/accountType.ts:38
msgid "Account held in the name of a revocable or irrevocable trust."
msgstr "Account held in the name of a revocable or irrevocable trust."

#: src/shared/components/AchFormSection.tsx:51
msgid "Account Holder Name"
msgstr "Account Holder Name"

#: src/routes/_authenticated/opportunities/-components/ReviewPeriodAlert.tsx:84
msgid "Account in Review"
msgstr "Account in Review"

#: src/shared/components/AchFormSection.tsx:66
msgid "Account Number"
msgstr "Account Number"

#: src/routes/_authenticated/settings/-components/StartOnboarding.tsx:30
msgid "Account Onboarding"
msgstr "Account Onboarding"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfoJointOwnerInfo.ts:69
msgid "Account owner #2 email (cannot be the same as owner's email)"
msgstr "Account owner #2 email (cannot be the same as owner's email)"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfoJointOwnerInfo.ts:56
msgid "Account owner #2 first name"
msgstr "Account owner #2 first name"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfoJointOwnerInfo.ts:62
msgid "Account owner #2 last name"
msgstr "Account owner #2 last name"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfoJointOwnerInfo.ts:81
msgid "Account owner #2 phone"
msgstr "Account owner #2 phone"

#: src/shared/components/AchFormSection.tsx:39
msgid "Account Ownership"
msgstr "Account Ownership"

#: src/routes/_authenticated/trade/-components/LockoutAlert.tsx:13
msgid "Account Restricted"
msgstr "Account Restricted"

#: src/shared/components/MainNavContainer.tsx:20
#: src/shared/components/MainNavContainer.tsx:22
msgid "Account Setup"
msgstr "Account Setup"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:304
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfoJointOwnerInfo.ts:24
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:187
msgid "Account Signatory #1"
msgstr "Account Signatory #1"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:330
msgid "Account signatory #2 email (cannot be the same as signatory #1's email)"
msgstr "Account signatory #2 email (cannot be the same as signatory #1's email)"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:314
msgid "Account signatory #2 first name"
msgstr "Account signatory #2 first name"

#: src/routes/_authenticated/onboarding/-components/config/secondarySignatory/sections/signatory2Details.ts:19
msgid "Account signatory #2 information"
msgstr "Account signatory #2 information"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:322
msgid "Account signatory #2 last name"
msgstr "Account signatory #2 last name"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:344
msgid "Account signatory #2 phone"
msgstr "Account signatory #2 phone"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/accountType.ts:15
msgid "Account type"
msgstr "Account type"

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:32
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/clientInfo.ts:27
#: src/shared/components/AchFormSection.tsx:29
msgid "Account Type"
msgstr "Account Type"

#: src/components/Trade/RequestStatus.tsx:89
#~ msgid "Accounting is preparing your ACH payment."
#~ msgstr "Accounting is preparing your ACH payment."

#: src/components/Trade/RequestStatus.tsx:90
#~ msgid "Accounting is preparing your payment."
#~ msgstr "Accounting is preparing your payment."

#: src/components/Trade/RequestStatus.tsx:88
#~ msgid "Accounting is preparing your wire."
#~ msgstr "Accounting is preparing your wire."

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:114
#: src/routes/_authenticated/onboarding/-components/Signatory2ReviewAndSign.tsx:33
msgid "Accredited Investor"
msgstr "Accredited Investor"

#: src/routes/_authenticated/onboarding/-components/config/accreditedInvestorDescription.tsx:23
msgid "Accredited investors are notified whenever private placements — including gold or silver bonds — are available."
msgstr "Accredited investors are notified whenever private placements — including gold or silver bonds — are available."

#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:528
#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:683
#: src/routes/_authenticated/trade/-components/RequestStatus.tsx:230
#: src/routes/_authenticated/trade/withdraw/cash/payout.tsx:114
#: src/routes/_authenticated/trade/withdraw/cash/review.tsx:109
#: src/shared/components/payment-methods/ManagePaymentMethods.tsx:68
#: src/shared/components/payment-methods/PlaidFinalizeForm.tsx:127
msgid "ACH"
msgstr "ACH"

#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:539
msgid "ACH Payment Details"
msgstr "ACH Payment Details"

#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:387
msgid "ACH purchase exceeds limit"
msgstr "ACH purchase exceeds limit"

#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:381
msgid "ACH purchases are collected from a saved payment method. Select one, or choose wire as your payment method."
msgstr "ACH purchases are collected from a saved payment method. Select one, or choose wire as your payment method."

#. placeholder {0}: formatCurrency(achMaxAllowed)
#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:388
msgid "ACH purchases cannot exceed {0} under our risk policy. If you would like to purchase more than this limit, please select wire as your payment method."
msgstr "ACH purchases cannot exceed {0} under our risk policy. If you would like to purchase more than this limit, please select wire as your payment method."

#: src/routes/_authenticated/opportunities/-components/LeasesPageControls.tsx:35
msgid "Active"
msgstr "Active"

#: src/routes/_authenticated/documents.tsx:17
#: src/shared/components/ActivityView.tsx:281
msgid "Activity"
msgstr "Activity"

#: src/shared/components/ActivityView.tsx:307
msgid "Activity lookback"
msgstr "Activity lookback"

#: src/routes/_authenticated/trade/-components/MetalTypeComboBox.tsx:142
#: src/routes/_authenticated/trade/-components/VaultLocationComboBox.tsx:140
msgid "Add"
msgstr "Add"

#: src/routes/_authenticated/trade/withdraw/cash/payout.tsx:83
msgid "Add a bank account"
msgstr "Add a bank account"

#: src/shared/components/payment-methods/AddPaymentMethodDialog.tsx:64
#: src/shared/components/payment-methods/ManagePaymentMethods.tsx:184
#: src/shared/components/payment-methods/NewPaymentMethod.tsx:56
msgid "Add a payment method"
msgstr "Add a payment method"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/RecurringPurchases.tsx:453
#: src/routes/_authenticated/trade/-components/Purchase/Recurring/RecurringPurchases.tsx:471
msgid "Add a Recurring Purchase"
msgstr "Add a Recurring Purchase"

#: src/routes/_authenticated/trade/-components/ShipMetal/ShipMetalForm.tsx:137
#: src/routes/_authenticated/trade/-components/ShipMetal/ShipMetalForm.tsx:194
msgid "Add Item"
msgstr "Add Item"

#: src/routes/_authenticated/trade/-components/VaultTransfer.tsx:318
msgid "Add Metal"
msgstr "Add Metal"

#: src/routes/_authenticated/trade/-components/VaultTransfer.tsx:258
msgid "Add Metal to Transfer"
msgstr "Add Metal to Transfer"

#: src/routes/_authenticated/trade/-components/PaymentMethodPicker.tsx:101
msgid "Add Payment Method"
msgstr "Add Payment Method"

#: src/routes/_authenticated/trade/withdraw/products/index.tsx:196
msgid "Add product"
msgstr "Add product"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:428
msgid "Additional trustee #1 information"
msgstr "Additional trustee #1 information"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:549
msgid "Additional trustee #2 information"
msgstr "Additional trustee #2 information"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:670
msgid "Additional trustee #3 information"
msgstr "Additional trustee #3 information"

#: src/routes/_authenticated/onboarding/-components/config/secondarySignatory/sections/signatory2Details.ts:54
msgid "Address"
msgstr "Address"

#: src/routes/_authenticated/onboarding/-components/Signatory2ReviewAndSign.tsx:45
msgid "Address Information"
msgstr "Address Information"

#: src/routes/_authenticated/onboarding/-components/Signatory2ReviewAndSign.tsx:48
msgid "Address is Account Address"
msgstr "Address is Account Address"

#: src/routes/_authenticated/referrals/-components/ReferralTermsOfService.tsx:31
msgid "Agreement confirmed"
msgstr "Agreement confirmed"

#: src/routes/_authenticated/opportunities/index.tsx:137
msgid "Agreement Submitted"
msgstr "Agreement Submitted"

#: src/routes/_authenticated/opportunities/unsecured/$leaseInstance.tsx:150
msgid "Agreement Template Missing"
msgstr "Agreement Template Missing"

#: src/routes/_authenticated/referrals/-components/ReferralTermsOfService.tsx:37
msgid "Agreement was unable to be confirmed, please try again later"
msgstr "Agreement was unable to be confirmed, please try again later"

#: src/shared/components/ActivityView.tsx:41
msgid "All activity"
msgstr "All activity"

#: src/routes/_authenticated/trade/-components/PendingTransaction.tsx:43
#: src/routes/_authenticated/trade/-components/PendingTransaction.tsx:59
msgid "All Recent Transactions"
msgstr "All Recent Transactions"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/EditScheduleForm.tsx:220
msgid "All skipped dates will be removed"
msgstr "All skipped dates will be removed"

#: src/routes/_authenticated/trade/-components/RequestStatus.tsx:245
msgid "Amount"
msgstr "Amount"

#: src/routes/_unauthenticated/-components/SignUp.tsx:167
msgid "An email verification code has been sent to your email address"
msgstr "An email verification code has been sent to your email address"

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:555
msgid "and we will follow up with next steps."
msgstr "and we will follow up with next steps."

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:42
msgid "Annual Income"
msgstr "Annual Income"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:72
msgid "Annual income (approximate)"
msgstr "Annual income (approximate)"

#: src/routes/_authenticated/referrals/-components/ReferralMetrics.tsx:101
msgid "Annual Run Rate"
msgstr "Annual Run Rate"

#: src/routes/_authenticated/trade/-components/Withdrawal/ShippingScreen.tsx:153
msgid "Apartment, suite, etc. (optional)"
msgstr "Apartment, suite, etc. (optional)"

#: src/routes/_authenticated/opportunities/-components/LeasesPageControls.tsx:105
msgid "Apply Filters"
msgstr "Apply Filters"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/clientFunding.tsx:70
msgid "Approximate amount of metals"
msgstr "Approximate amount of metals"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/foreignCorpDocs.ts:79
msgid "Are there additional individuals who have authority to act on behalf of the company or who exercise control over its activities?"
msgstr "Are there additional individuals who have authority to act on behalf of the company or who exercise control over its activities?"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:389
msgid "Are there additional trustees not signing for the Monetary Metals account?"
msgstr "Are there additional trustees not signing for the Monetary Metals account?"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:624
msgid "Are there beneficial owners (25% or more ownership) of the company who are not also signatories on the account?"
msgstr "Are there beneficial owners (25% or more ownership) of the company who are not also signatories on the account?"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:157
msgid "Are you a single-member LLC?"
msgstr "Are you a single-member LLC?"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:153
#: src/routes/_authenticated/onboarding/-components/config/secondarySignatory/sections/signatory2Details.ts:86
msgid "Are you a US citizen, permanent resident, or tax resident?"
msgstr "Are you a US citizen, permanent resident, or tax resident?"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/clientFunding.tsx:93
#: src/routes/_authenticated/onboarding/-components/config/secondarySignatory/sections/signatory2Details.ts:151
msgid "Are you an accredited investor?"
msgstr "Are you an accredited investor?"

#: src/shared/components/payment-methods/FinalizePlaidPaymentMethod.tsx:81
msgid "Are you sure you want to cancel the account connection?"
msgstr "Are you sure you want to cancel the account connection?"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/RecurringPurchases.tsx:297
msgid "Are you sure you want to delete this recurring purchase schedule? We will no longer process future purchases. Any in progress purchases will not be canceled."
msgstr "Are you sure you want to delete this recurring purchase schedule? We will no longer process future purchases. Any in progress purchases will not be canceled."

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/EditScheduleForm.tsx:279
msgid "Are you sure you want to leave?"
msgstr "Are you sure you want to leave?"

#: src/routes/_authenticated/opportunities/-components/Opportunity.tsx:176
msgid "Are you sure you want to opt into this lease? A portion of your ounces will go into the lease and will be committed until the lease ends."
msgstr "Are you sure you want to opt into this lease? A portion of your ounces will go into the lease and will be committed until the lease ends."

#: src/routes/_authenticated/opportunities/-components/Opportunity.tsx:177
msgid "Are you sure you want to opt into this lease? A portion of your ounces will go into the lease."
msgstr "Are you sure you want to opt into this lease? A portion of your ounces will go into the lease."

#: src/routes/_authenticated/opportunities/-components/Opportunity.tsx:170
#: src/routes/_authenticated/opportunities/-components/Opportunity.tsx:171
msgid "Are you sure you want to opt out of this lease? Your ounces will NOT go into the lease."
msgstr "Are you sure you want to opt out of this lease? Your ounces will NOT go into the lease."

#: src/routes/_authenticated/trade/-components/MetalTransfer.tsx:210
msgid "Are you sure you want to proceed with the transfer?"
msgstr "Are you sure you want to proceed with the transfer?"

#: src/shared/components/payment-methods/ManagePaymentMethods.tsx:106
msgid "Are you sure you want to remove this payment method? You will not be able to use it for future transactions."
msgstr "Are you sure you want to remove this payment method? You will not be able to use it for future transactions."

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:252
msgid "As an LLC, how do you file?"
msgstr "As an LLC, how do you file?"

#: src/shared/components/PasswordValidationTooltip.tsx:22
msgid "At least 1 lowercase letter"
msgstr "At least 1 lowercase letter"

#: src/shared/components/PasswordValidationTooltip.tsx:26
msgid "At least 1 number"
msgstr "At least 1 number"

#: src/shared/components/PasswordValidationTooltip.tsx:30
msgid "At least 1 special character"
msgstr "At least 1 special character"

#: src/shared/components/PasswordValidationTooltip.tsx:18
msgid "At least 1 uppercase letter"
msgstr "At least 1 uppercase letter"

#: src/shared/components/PasswordValidationTooltip.tsx:14
msgid "At least 8 characters"
msgstr "At least 8 characters"

#: src/routes/_authenticated/settings/-components/PasswordForm.tsx:60
msgid "Attempt limit exceeded, please try after some time."
msgstr "Attempt limit exceeded, please try after some time."

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalReview.tsx:143
msgid "Authenticator code"
msgstr "Authenticator code"

#: src/routes/_authenticated/trade/withdraw/products/index.tsx:65
msgid "Available"
msgstr "Available"

#: src/routes/_authenticated/trade/-components/MetalTransfer.tsx:193
msgid "Available balance: {availableBalanceString}"
msgstr "Available balance: {availableBalanceString}"

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:471
#: src/routes/_authenticated/trade/withdraw/products/index.tsx:45
msgid "Available metal"
msgstr "Available metal"

#: src/routes/_authenticated/trade/withdraw/index.tsx:28
msgid "Available metal and next steps will be shown after you make a selection."
msgstr "Available metal and next steps will be shown after you make a selection."

#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:198
#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:681
msgid "Available USD Balance"
msgstr "Available USD Balance"

#: src/routes/_authenticated/trade/-components/requestView.ts:160
msgid "Awaiting Funds"
msgstr "Awaiting Funds"

#: src/routes/_authenticated/onboarding/-components/StepShell.tsx:54
#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:314
#: src/shared/components/payment-methods/AddPaymentMethodDialog.tsx:78
msgid "Back"
msgstr "Back"

#: src/routes/_authenticated/balance/premiums.tsx:54
#: src/routes/_authenticated/balance/premiums.tsx:278
msgid "Back to Balance"
msgstr "Back to Balance"

#: src/routes/_authenticated/opportunities/unsecured/$leaseInstance.tsx:140
#: src/routes/_authenticated/opportunities/unsecured/$leaseInstance.tsx:154
#: src/routes/_authenticated/opportunities/unsecured/$leaseInstance.tsx:168
msgid "Back to Opportunities"
msgstr "Back to Opportunities"

#: src/shared/components/payment-methods/FinalizePlaidPaymentMethod.tsx:39
#: src/shared/components/payment-methods/FinalizePlaidPaymentMethod.tsx:58
#: src/shared/components/payment-methods/FinalizePlaidPaymentMethod.tsx:74
#: src/shared/components/payment-methods/NewPaymentMethod.tsx:30
#: src/shared/components/payment-methods/NewPaymentMethod.tsx:45
#: src/shared/components/payment-methods/PlaidOAuthCallback.tsx:86
msgid "Back to Payment Methods"
msgstr "Back to Payment Methods"

#: src/routes/_authenticated/trade/-components/ShipMetal/PackingSlipReview.tsx:66
msgid "Back to Product List"
msgstr "Back to Product List"

#: src/routes/_unauthenticated/-components/ConfirmSignIn.tsx:74
#: src/routes/_unauthenticated/-components/EmailVerification.tsx:62
#: src/routes/_unauthenticated/-components/EmailVerification.tsx:91
#: src/routes/_unauthenticated/-components/ForgotPassword.tsx:49
#: src/routes/_unauthenticated/-components/NewPassword.tsx:85
#: src/routes/_unauthenticated/-components/RecoveryCode.tsx:64
#: src/routes/_unauthenticated/-components/ResetPassword.tsx:111
#: src/routes/_unauthenticated/-components/SignUp.tsx:369
msgid "Back to Sign In"
msgstr "Back to Sign In"

#: src/routes/_authenticated/balance/-components/balancePayloadGenerators.tsx:53
msgid "Balance"
msgstr "Balance"

#: src/routes/_authenticated/balance/-components/BalanceTable.tsx:62
msgid "Balance (oz)"
msgstr "Balance (oz)"

#: src/routes/_authenticated/balance/-components/BalanceTable.tsx:85
msgid "Balance (USD)"
msgstr "Balance (USD)"

#: src/shared/components/MainNavContainer.tsx:25
msgid "Balances"
msgstr "Balances"

#: src/shared/components/MainNavContainer.tsx:27
msgid "Balances: See your account balances"
msgstr "Balances: See your account balances"

#: src/components/Trade/RequestStatus.tsx:302
#~ msgid "Bank account"
#~ msgstr "Bank account"

#: src/routes/_authenticated/trade/-components/RequestStatus.tsx:117
msgid "Bank Account Number"
msgstr "Bank Account Number"

#: src/routes/_authenticated/trade/-components/RequestStatus.tsx:101
msgid "Bank Name"
msgstr "Bank Name"

#: src/routes/_authenticated/trade/withdraw/products/index.tsx:226
#~ msgid "Based on product metal value"
#~ msgstr "Based on product metal value"

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:200
msgid "Based on total sale value"
msgstr "Based on total sale value"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:192
msgid "Because your country of incorporation does not have a tax treaty with the US, the tax withholding rate on your interest income will likely be 30%. We are not tax experts, please consult a tax expert for a better understanding of how your interest income is taxed in your country of residence. Below, please select the applicable non-treaty country of incorporation."
msgstr "Because your country of incorporation does not have a tax treaty with the US, the tax withholding rate on your interest income will likely be 30%. We are not tax experts, please consult a tax expert for a better understanding of how your interest income is taxed in your country of residence. Below, please select the applicable non-treaty country of incorporation."

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:196
msgid "Because your country of residence does not have a tax treaty signed with the US, the tax withholding rate on your interest income will likely be 30%. We are not tax experts, please consult a tax expert for a better understanding of how your interest income is taxed in your country of residence. Below, please select which non-treaty country you are a resident of for tax purposes."
msgstr "Because your country of residence does not have a tax treaty signed with the US, the tax withholding rate on your interest income will likely be 30%. We are not tax experts, please consult a tax expert for a better understanding of how your interest income is taxed in your country of residence. Below, please select which non-treaty country you are a resident of for tax purposes."

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:667
msgid "Beneficial owner #1"
msgstr "Beneficial owner #1"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:698
msgid "Beneficial owner #1 business/trust name"
msgstr "Beneficial owner #1 business/trust name"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:706
msgid "Beneficial owner #1 email"
msgstr "Beneficial owner #1 email"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:682
msgid "Beneficial owner #1 first name"
msgstr "Beneficial owner #1 first name"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:714
msgid "Beneficial owner #1 government-issued photo ID"
msgstr "Beneficial owner #1 government-issued photo ID"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:690
msgid "Beneficial owner #1 last name"
msgstr "Beneficial owner #1 last name"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:673
msgid "Beneficial owner #1 type"
msgstr "Beneficial owner #1 type"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:742
msgid "Beneficial owner #2"
msgstr "Beneficial owner #2"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:773
msgid "Beneficial owner #2 business/trust name"
msgstr "Beneficial owner #2 business/trust name"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:781
msgid "Beneficial owner #2 email"
msgstr "Beneficial owner #2 email"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:757
msgid "Beneficial owner #2 first name"
msgstr "Beneficial owner #2 first name"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:789
msgid "Beneficial owner #2 government-issued photo ID"
msgstr "Beneficial owner #2 government-issued photo ID"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:765
msgid "Beneficial owner #2 last name"
msgstr "Beneficial owner #2 last name"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:748
msgid "Beneficial owner #2 type"
msgstr "Beneficial owner #2 type"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:817
msgid "Beneficial owner #3"
msgstr "Beneficial owner #3"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:849
msgid "Beneficial owner #3 business/trust name"
msgstr "Beneficial owner #3 business/trust name"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:857
msgid "Beneficial owner #3 email"
msgstr "Beneficial owner #3 email"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:833
msgid "Beneficial owner #3 first name"
msgstr "Beneficial owner #3 first name"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:865
msgid "Beneficial owner #3 government-issued photo ID"
msgstr "Beneficial owner #3 government-issued photo ID"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:841
msgid "Beneficial owner #3 last name"
msgstr "Beneficial owner #3 last name"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:824
msgid "Beneficial owner #3 type"
msgstr "Beneficial owner #3 type"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:893
msgid "Beneficial owner #4"
msgstr "Beneficial owner #4"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:925
msgid "Beneficial owner #4 business/trust name"
msgstr "Beneficial owner #4 business/trust name"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:933
msgid "Beneficial owner #4 email"
msgstr "Beneficial owner #4 email"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:909
msgid "Beneficial owner #4 first name"
msgstr "Beneficial owner #4 first name"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:941
msgid "Beneficial owner #4 government-issued photo ID"
msgstr "Beneficial owner #4 government-issued photo ID"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:917
msgid "Beneficial owner #4 last name"
msgstr "Beneficial owner #4 last name"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:900
msgid "Beneficial owner #4 type"
msgstr "Beneficial owner #4 type"

#: src/routes/_authenticated/trade/-components/RequestStatus.tsx:125
msgid "Beneficiary Name"
msgstr "Beneficiary Name"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:609
msgid "Board resolution showing authorization of the individual(s) designated to sign documents (if the signatory on the Monetary Metals account is not a corporate officer)"
msgstr "Board resolution showing authorization of the individual(s) designated to sign documents (if the signatory on the Monetary Metals account is not a corporate officer)"

#: src/routes/_authenticated/yield/-components/YieldTable.tsx:55
#: src/routes/_authenticated/yield/-components/YieldTable.tsx:177
msgid "bond"
msgstr "bond"

#: src/routes/_authenticated/yield/-components/YieldTable.tsx:87
msgid "Bond"
msgstr "Bond"

#: src/routes/_authenticated/balance/-components/balancePayloadGenerators.tsx:30
msgid "Bond Yield Account"
msgstr "Bond Yield Account"

#: src/routes/_authenticated/balance/-components/balancePayloadGenerators.tsx:31
#: src/routes/_authenticated/yield/-components/YieldTable.tsx:163
msgid "Bonds"
msgstr "Bonds"

#: src/routes/_authenticated/referrals/-components/ReferralMetrics.tsx:80
msgid "Bonuses Earned"
msgstr "Bonuses Earned"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/NewScheduleForm.tsx:49
msgid "Both 1st and 16th"
msgstr "Both 1st and 16th"

#: src/routes/_authenticated/trade/-components/RequestStatus.tsx:105
msgid "Branch Location"
msgstr "Branch Location"

#: src/shared/components/AchFormSection.tsx:43
#: src/shared/components/payment-methods/PlaidFinalizeForm.tsx:117
msgid "Business"
msgstr "Business"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/accountType.ts:44
msgid "Business or corporate account owned by a legal entity."
msgstr "Business or corporate account owned by a legal entity."

#: src/routes/_authenticated/trade/-components/requestView.ts:185
msgid "Buy {lines}"
msgstr "Buy {lines}"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/NewScheduleForm.tsx:209
msgid "By creating this purchase schedule, you authorize Monetary Metals to debit your account in the amount of <0>{formattedAmount}</0> every {daysLabel} of the month. Your first purchase date will be on <1>{formattedDate}</1>."
msgstr "By creating this purchase schedule, you authorize Monetary Metals to debit your account in the amount of <0>{formattedAmount}</0> every {daysLabel} of the month. Your first purchase date will be on <1>{formattedDate}</1>."

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/RecurringPurchases.tsx:254
msgid "By resuming, recurring purchases will be re-activated and executed according to your schedule."
msgstr "By resuming, recurring purchases will be re-activated and executed according to your schedule."

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/NewScheduleForm.tsx:215
msgid "By submitting these changes, you authorize Monetary Metals to debit your account in the amount of <0>{formattedAmount}</0> every {daysLabel} of the month. Your first purchase date will be on <1>{formattedDate}</1>."
msgstr "By submitting these changes, you authorize Monetary Metals to debit your account in the amount of <0>{formattedAmount}</0> every {daysLabel} of the month. Your first purchase date will be on <1>{formattedDate}</1>."

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalReview.tsx:61
msgid "By submitting, you authorize Monetary Metals to process this withdrawal request."
msgstr "By submitting, you authorize Monetary Metals to process this withdrawal request."

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:98
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:72
msgid "C Corporation"
msgstr "C Corporation"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:236
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:260
msgid "C-Corp"
msgstr "C-Corp"

#: src/routes/_authenticated/opportunities/-components/Opportunity.tsx:154
#: src/routes/_authenticated/opportunities/-components/Opportunity.tsx:185
#: src/routes/_authenticated/opportunities/-components/Opportunity.tsx:507
#: src/routes/_authenticated/trade/-components/MetalTypeComboBox.tsx:139
#: src/routes/_authenticated/trade/-components/Purchase/PendingTransactionDiaog.tsx:33
#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:692
#: src/routes/_authenticated/trade/-components/Purchase/Recurring/EditScheduleForm.tsx:256
#: src/routes/_authenticated/trade/-components/Purchase/Recurring/EditScheduleForm.tsx:283
#: src/routes/_authenticated/trade/-components/Purchase/Recurring/NewScheduleForm.tsx:63
#: src/routes/_authenticated/trade/-components/Purchase/Recurring/NewScheduleForm.tsx:64
#: src/routes/_authenticated/trade/-components/Purchase/Recurring/NewScheduleForm.tsx:368
#: src/routes/_authenticated/trade/-components/Purchase/Recurring/RecurringPurchases.tsx:152
#: src/routes/_authenticated/trade/-components/Purchase/Recurring/RecurringPurchases.tsx:210
#: src/routes/_authenticated/trade/-components/Purchase/Recurring/RecurringPurchases.tsx:258
#: src/routes/_authenticated/trade/-components/Purchase/Recurring/RecurringPurchases.tsx:301
#: src/routes/_authenticated/trade/-components/VaultLocationComboBox.tsx:137
#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalReview.tsx:166
#: src/shared/components/payment-methods/AddPaymentMethodDialog.tsx:90
#: src/shared/components/payment-methods/ManagePaymentMethods.tsx:111
#: src/shared/components/payment-methods/PaymentMethodVerification.tsx:71
#: src/shared/components/payment-methods/UpgradePaymentMethod.tsx:160
#: src/shared/components/payment-methods/UpgradePaymentMethodDialog.tsx:220
msgid "Cancel"
msgstr "Cancel"

#: src/routes/_authenticated/trade/-components/PendingTransaction.tsx:164
#: src/routes/_authenticated/trade/-components/RequestStatus.tsx:177
msgid "Canceled"
msgstr "Canceled"

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:332
#: src/routes/_authenticated/trade/withdraw/index.tsx:15
msgid "Cash"
msgstr "Cash"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:241
msgid "Certificate of trust:"
msgstr "Certificate of trust:"

#: src/routes/_authenticated/balance/-components/BalanceOverviewCard.tsx:87
msgid "Chart displays equivalent gold ounces"
msgstr "Chart displays equivalent gold ounces"

#: src/routes/_authenticated/trade/-components/Withdrawal/ShippingScreen.tsx:220
#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:100
#~ msgid "Cheapest method (up to 5 business days)"
#~ msgstr "Cheapest method (up to 5 business days)"

#: src/shared/components/AchFormSection.tsx:32
#: src/shared/components/payment-methods/ManualAchForm.tsx:43
msgid "Checking"
msgstr "Checking"

#: src/shared/components/payment-methods/UpgradePaymentMethodDialog.tsx:235
msgid "Checking account…"
msgstr "Checking account…"

#: src/routes/_authenticated/trade/-components/Withdrawal/ShippingScreen.tsx:68
msgid "Choose an address for this withdrawal."
msgstr "Choose an address for this withdrawal."

#: src/routes/_authenticated/trade/withdraw/index.tsx:12
#~ msgid "Choose how you would like to receive the value of your metal."
#~ msgstr "Choose how you would like to receive the value of your metal."

#: src/routes/_authenticated/trade/withdraw/products/index.tsx:119
#~ msgid "Choose products"
#~ msgstr "Choose products"

#: src/routes/_authenticated/trade/withdraw/cash/index.tsx:28
msgid "Choose what you want to sell"
msgstr "Choose what you want to sell"

#: src/shared/components/payment-methods/UpgradePaymentMethodDialog.tsx:130
msgid "Choose who owns each account."
msgstr "Choose who owns each account."

#: src/routes/_authenticated/trade/withdraw/index.tsx:13
#~ msgid "Choose withdrawal type"
#~ msgstr "Choose withdrawal type"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:169
msgid "Citizenship"
msgstr "Citizenship"

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:56
#: src/routes/_authenticated/onboarding/-components/Signatory2ReviewAndSign.tsx:63
msgid "Citizenship & Tax Info"
msgstr "Citizenship & Tax Info"

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:58
#: src/routes/_authenticated/onboarding/-components/Signatory2ReviewAndSign.tsx:65
msgid "Citizenship Country"
msgstr "Citizenship Country"

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:80
#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:90
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:387
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:461
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:237
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:301
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:283
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:354
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:508
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:630
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:751
#: src/routes/_authenticated/onboarding/-components/config/secondarySignatory/sections/signatory2Details.ts:65
#: src/routes/_authenticated/onboarding/-components/Signatory2ReviewAndSign.tsx:54
#: src/routes/_authenticated/trade/-components/Withdrawal/ShippingScreen.tsx:164
msgid "City"
msgstr "City"

#: src/routes/_authenticated/settings/-components/PasswordForm.tsx:111
msgid "Clear"
msgstr "Clear"

#: src/shared/components/MFASetup.tsx:117
msgid "Click the eye icon to reveal the QR code"
msgstr "Click the eye icon to reveal the QR code"

#: src/routes/_authenticated/trade/withdraw/products/review.tsx:52
msgid "Client Relations emails you a quote for the products you selected."
msgstr "Client Relations emails you a quote for the products you selected."

#: src/routes/_authenticated/trade/withdraw/products/review.tsx:53
#~ msgid "Client Relations verifies your shipping details and documents."
#~ msgstr "Client Relations verifies your shipping details and documents."

#: src/routes/_authenticated/trade/withdraw/products/signature.tsx:216
#~ msgid "Client Relations will contact you with shipping details and next steps."
#~ msgstr "Client Relations will contact you with shipping details and next steps."

#: src/routes/_authenticated/opportunities/index.tsx:141
#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:601
#: src/routes/_authenticated/trade/-components/Purchase/TimedOutTransactionsDialog.tsx:128
#: src/shared/components/EmulateUserDialog.tsx:169
#: src/shared/components/payment-methods/AddPaymentMethodDialog.tsx:110
msgid "Close"
msgstr "Close"

#: src/routes/_unauthenticated/-components/EmailVerification.tsx:45
msgid "Code resent successfully!"
msgstr "Code resent successfully!"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/accountType.ts:43
msgid "Company"
msgstr "Company"

#: src/routes/_authenticated/trade/-components/RequestStatus.tsx:129
msgid "Company Address"
msgstr "Company Address"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/clientInfo.ts:48
msgid "Company Details"
msgstr "Company Details"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/clientInfo.ts:62
msgid "Company Docs"
msgstr "Company Docs"

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:63
msgid "Company EIN"
msgstr "Company EIN"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:439
msgid "Company mailing address"
msgstr "Company mailing address"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:368
msgid "Company place of business"
msgstr "Company place of business"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:296
msgid "Company signatories"
msgstr "Company signatories"

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:65
msgid "Company Tax ID (non-US)"
msgstr "Company Tax ID (non-US)"

#: src/routes/_authenticated/trade/-components/PendingTransaction.tsx:66
#: src/routes/_authenticated/trade/-components/PendingTransaction.tsx:187
msgid "Complete"
msgstr "Complete"

#: src/routes/_authenticated/settings/-components/PasswordForm.tsx:113
#: src/shared/components/EmulateUserDialog.tsx:172
#: src/shared/components/MFASetup.tsx:162
msgid "Confirm"
msgstr "Confirm"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/EditScheduleForm.tsx:258
msgid "Confirm Changes"
msgstr "Confirm Changes"

#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:695
msgid "Confirm Order"
msgstr "Confirm Order"

#: src/routes/_unauthenticated/-components/SignUp.tsx:334
msgid "Confirm password"
msgstr "Confirm password"

#: src/routes/_authenticated/trade/-components/Withdrawal/ShippingScreen.tsx:213
msgid "Confirm shipping address"
msgstr "Confirm shipping address"

#: src/routes/_authenticated/trade/-components/MetalTransfer.tsx:209
msgid "Confirm Transfer"
msgstr "Confirm Transfer"

#: src/shared/components/payment-methods/UpgradePaymentMethodDialog.tsx:228
msgid "Confirm upgrade"
msgstr "Confirm upgrade"

#: src/routes/_authenticated/trade/-components/Withdrawal/ShippingScreen.tsx:64
msgid "Confirm where we should ship your products."
msgstr "Confirm where we should ship your products."

#: src/shared/components/payment-methods/UpgradePaymentMethodDialog.tsx:121
msgid "Confirm your account upgrade"
msgstr "Confirm your account upgrade"

#: src/routes/_unauthenticated/-components/NewPassword.tsx:70
#: src/routes/_unauthenticated/-components/ResetPassword.tsx:93
msgid "Confirm your New Password"
msgstr "Confirm your New Password"

#: src/routes/_unauthenticated/-components/SignUp.tsx:337
msgid "Confirm your password"
msgstr "Confirm your password"

#: src/routes/_authenticated/trade/-components/ShipMetal/PackingSlipReview.tsx:24
msgid "Confirm your shipment items below. Once confirmed, a metal packing slip will be generated for digital signature. You will not be able to make changes after this step."
msgstr "Confirm your shipment items below. Once confirmed, a metal packing slip will be generated for digital signature. You will not be able to make changes after this step."

#: src/routes/_authenticated/trade/withdraw/cash/payout.tsx:56
#~ msgid "Connect a bank account through Plaid to receive your funds."
#~ msgstr "Connect a bank account through Plaid to receive your funds."

#: src/routes/_authenticated/trade/withdraw/cash/payout.tsx:56
msgid "Connect a bank account through Plaid to receive your funds. If you do not want to use Plaid, contact your Relationship Manager."
msgstr "Connect a bank account through Plaid to receive your funds. If you do not want to use Plaid, contact your Relationship Manager."

#: src/shared/components/payment-methods/PlaidFinalizeForm.tsx:136
msgid "Connect Accounts"
msgstr "Connect Accounts"

#: src/shared/components/payment-methods/UpgradePaymentMethodDialog.tsx:128
msgid "Connect with Plaid"
msgstr "Connect with Plaid"

#: src/shared/components/payment-methods/UpgradePaymentMethodDialog.tsx:139
msgid "Connect your saved bank account to use it for withdrawals."
msgstr "Connect your saved bank account to use it for withdrawals."

#: src/shared/components/payment-methods/UpgradePaymentMethodDialog.tsx:167
#: src/shared/components/payment-methods/UpgradePaymentMethodDialog.tsx:194
msgid "Connected through Plaid"
msgstr "Connected through Plaid"

#: src/routes/_authenticated/settings/-components/UserAttributesChangeForm.tsx:65
msgid "Contact Information"
msgstr "Contact Information"

#: src/routes/_authenticated/onboarding.tsx:22
#: src/routes/_authenticated/onboarding/-components/OnboardingLayout.tsx:80
msgid "Contact Support"
msgstr "Contact Support"

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:302
#: src/shared/components/IdleTimer.tsx:52
msgid "Continue"
msgstr "Continue"

#: src/routes/_authenticated/trade/withdraw/products/review.tsx:62
msgid "Continue to signature"
msgstr "Continue to signature"

#: src/routes/_authenticated/trade/-components/ShipMetal/PackingSlipReview.tsx:69
msgid "Continue to Signature"
msgstr "Continue to Signature"

#: src/shared/components/payment-methods/UpgradePaymentMethodDialog.tsx:239
msgid "Continue with Plaid"
msgstr "Continue with Plaid"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/foreignCorpDocs.ts:110
msgid "Control person #1"
msgstr "Control person #1"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/foreignCorpDocs.ts:146
msgid "Control person #2"
msgstr "Control person #2"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/foreignCorpDocs.ts:182
msgid "Control person #3"
msgstr "Control person #3"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/foreignCorpDocs.ts:218
msgid "Control person #4"
msgstr "Control person #4"

#: src/routes/_authenticated/referrals/-components/ReferralMetrics.tsx:68
msgid "Conversion Rate"
msgstr "Conversion Rate"

#: src/routes/_authenticated/settings.tsx:34
msgid "Cookies"
msgstr "Cookies"

#: src/routes/_authenticated/referrals.tsx:119
#: src/routes/_authenticated/referrals.tsx:132
msgid "Copy"
msgstr "Copy"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:562
msgid "Corporation information"
msgstr "Corporation information"

#: src/routes/_authenticated/settings/-components/MFAManageForm.tsx:25
msgid "Could not disable two-factor authentication. Please try again later."
msgstr "Could not disable two-factor authentication. Please try again later."

#: src/shared/components/MFASetup.tsx:73
msgid "Could not start two-factor setup. Please try again."
msgstr "Could not start two-factor setup. Please try again."

#: src/shared/components/MFASetup.tsx:97
msgid "Could not verify code. Please try again."
msgstr "Could not verify code. Please try again."

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:83
#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:93
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:412
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:494
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:258
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:324
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:308
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:379
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:531
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:653
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:774
#: src/routes/_authenticated/onboarding/-components/config/secondarySignatory/sections/signatory2Details.ts:77
#: src/routes/_authenticated/onboarding/-components/Signatory2ReviewAndSign.tsx:57
#: src/routes/_authenticated/trade/-components/Withdrawal/ShippingScreen.tsx:190
msgid "Country"
msgstr "Country"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:173
msgid "Country of incorporation"
msgstr "Country of incorporation"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/NewScheduleForm.tsx:68
msgid "Create Purchase Schedule"
msgstr "Create Purchase Schedule"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/NewScheduleForm.tsx:58
msgid "Create Recurring Purchase Schedule"
msgstr "Create Recurring Purchase Schedule"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/NewScheduleForm.tsx:371
msgid "Create Schedule"
msgstr "Create Schedule"

#: src/shared/components/payment-methods/ManagePaymentMethods.tsx:68
msgid "Created {relativeTime}"
msgstr "Created {relativeTime}"

#: src/routes/_authenticated/trade/-components/RequestStatus.tsx:200
msgid "Current"
msgstr "Current"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:60
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:484
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:606
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:727
#: src/routes/_authenticated/onboarding/-components/config/secondarySignatory/sections/signatory2Details.ts:32
msgid "Date of birth"
msgstr "Date of birth"

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:40
#: src/routes/_authenticated/onboarding/-components/Signatory2ReviewAndSign.tsx:31
msgid "Date of Birth"
msgstr "Date of Birth"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/RecurringPurchases.tsx:195
msgid "Date to Resume"
msgstr "Date to Resume"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/RecurringPurchases.tsx:147
msgid "Dates to Skip"
msgstr "Dates to Skip"

#: src/shared/components/CookiesConsentBanner.tsx:65
msgid "Decline"
msgstr "Decline"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/RecurringPurchases.tsx:309
msgid "Delete Recurring Purchase"
msgstr "Delete Recurring Purchase"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/RecurringPurchases.tsx:296
msgid "Delete Recurring Purchase Schedule"
msgstr "Delete Recurring Purchase Schedule"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/RecurringPurchases.tsx:407
msgid "Delete Schedule"
msgstr "Delete Schedule"

#: src/routes/_authenticated/trade/-components/RequestStatus.tsx:142
msgid "Deposit"
msgstr "Deposit"

#: src/routes/_authenticated/trade/-components/RequestStatus.tsx:234
#: src/routes/_authenticated/trade/withdraw/cash/review.tsx:108
msgid "Deposit account"
msgstr "Deposit account"

#: src/routes/_authenticated/trade/withdraw/cash/payout.tsx:52
msgid "Deposit Account"
msgstr "Deposit Account"

#: src/routes/_authenticated/opportunities/-components/Opportunity.tsx:474
msgid "Desired Allocation"
msgstr "Desired Allocation"

#: src/routes/_authenticated/opportunities/-components/Opportunity.tsx:484
msgid "Desired Allocation (oz)"
msgstr "Desired Allocation (oz)"

#. placeholder {0}: ouncesFormatter.format(opportunity.maxDesiredAllocation)
#: src/routes/_authenticated/opportunities/-components/Opportunity.tsx:210
msgid "Desired allocation cannot exceed {0} oz."
msgstr "Desired allocation cannot exceed {0} oz."

#: src/routes/_authenticated/opportunities/-components/Opportunity.tsx:227
msgid "Desired allocation submitted successfully."
msgstr "Desired allocation submitted successfully."

#: src/routes/_authenticated/balance/premiums.tsx:179
msgid "Details"
msgstr "Details"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/foreignCorpDocs.ts:73
msgid "Directors and control persons"
msgstr "Directors and control persons"

#: src/routes/_authenticated/settings/-components/MFAManageForm.tsx:56
msgid "Disable"
msgstr "Disable"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/EditScheduleForm.tsx:286
msgid "Discard Changes"
msgstr "Discard Changes"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:106
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:80
msgid "Disregarded entity"
msgstr "Disregarded entity"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfoJointOwnerInfo.ts:32
msgid "Do both account owners share the same last name?"
msgstr "Do both account owners share the same last name?"

#: src/routes/_authenticated/onboarding/-components/config/secondarySignatory/sections/signatory2Details.ts:44
msgid "Do you live at the above address given for the account?"
msgstr "Do you live at the above address given for the account?"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:116
msgid "Do you work in the following areas?"
msgstr "Do you work in the following areas?"

#: src/routes/_authenticated/trade/withdraw/products/signature.tsx:103
msgid "Document signed. Complete the final check below to submit your request."
msgstr "Document signed. Complete the final check below to submit your request."

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/foreignCorpDocs.ts:94
msgid "Documentation for additional control persons"
msgstr "Documentation for additional control persons"

#: src/shared/components/MainNavContainer.tsx:35
msgid "Documents"
msgstr "Documents"

#: src/shared/components/MainNavContainer.tsx:37
msgid "Documents: See your documents"
msgstr "Documents: See your documents"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:375
#: src/routes/_authenticated/onboarding/-components/config/secondarySignatory/sections/signatory2Details.ts:133
msgid "Does the address on the uploaded ID contain your current address?"
msgstr "Does the address on the uploaded ID contain your current address?"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:722
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:797
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:873
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:949
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/foreignCorpDocs.ts:124
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/foreignCorpDocs.ts:160
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/foreignCorpDocs.ts:196
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/foreignCorpDocs.ts:232
msgid "Does the uploaded ID include the individual's current address?"
msgstr "Does the uploaded ID include the individual's current address?"

#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:110
msgid "Dollar"
msgstr "Dollar"

#: src/routes/_authenticated/settings/-components/payment-methods/AddPaymentMethodDialog.tsx:99
#~ msgid "Done"
#~ msgstr "Done"

#: src/shared/components/MFASetup.tsx:116
msgid "Download any authenticator app, such as Authy, on your phone or desktop if you don't have one"
msgstr "Download any authenticator app, such as Authy, on your phone or desktop if you don't have one"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/EditScheduleForm.tsx:133
#: src/routes/_authenticated/trade/-components/Purchase/Recurring/NewScheduleForm.tsx:311
msgid "Duplicate payment method detected"
msgstr "Duplicate payment method detected"

#: src/routes/_authenticated/referrals/-components/ReferralMetrics.tsx:77
msgid "Earnings Breakdown"
msgstr "Earnings Breakdown"

#: src/routes/_authenticated/referrals/-components/ReferralMetrics.tsx:90
msgid "Earnings from purchases made by your referrals."
msgstr "Earnings from purchases made by your referrals."

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/EditScheduleForm.tsx:183
msgid "Edit Recurring Purchase"
msgstr "Edit Recurring Purchase"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/RecurringPurchases.tsx:398
msgid "Edit Schedule"
msgstr "Edit Schedule"

#: src/routes/_authenticated/referrals/-components/ReferralTermsOfService.tsx:49
msgid ""
"Effective Date: {date}\n"
"\n"
"Eligibility:\n"
"• You must be a new user and not have previously held a Monetary Metals account.\n"
"• You must sign up through a valid referral link provided by an existing user.\n"
"• Only individuals who complete full onboarding (including identity verification) and fund their account are eligible.\n"
"\n"
"Referral Bonus:\n"
"• Upon successful onboarding and account funding, both the inviter and the invitee will receive a bonus of {amount} oz of gold.\n"
"• Gold bonuses are credited to your account and may be subject to vesting or clawback if the account is closed shortly after funding.\n"
"\n"
"Timing:\n"
"• Referral bonuses are typically processed within {processingDays} business days of account funding.\n"
"• Referral links may expire or be subject to program changes at any time.\n"
"\n"
"Limitations:\n"
"• Self-referrals are not permitted.\n"
"• Monetary Metals reserves the right to withhold or reverse bonus payments if fraudulent activity or abuse is detected.\n"
"• There is no cap on the number of friends you may refer, unless otherwise specified in a referral agreement.\n"
"\n"
"Other Terms:\n"
"• This program is offered at Monetary Metals' sole discretion and may be modified or terminated at any time.\n"
"• Participation in this program constitutes agreement to these terms and any other applicable policies.\n"
"• For any questions, contact support@monetary-metals.com."
msgstr ""
"Effective Date: {date}\n"
"\n"
"Eligibility:\n"
"• You must be a new user and not have previously held a Monetary Metals account.\n"
"• You must sign up through a valid referral link provided by an existing user.\n"
"• Only individuals who complete full onboarding (including identity verification) and fund their account are eligible.\n"
"\n"
"Referral Bonus:\n"
"• Upon successful onboarding and account funding, both the inviter and the invitee will receive a bonus of {amount} oz of gold.\n"
"• Gold bonuses are credited to your account and may be subject to vesting or clawback if the account is closed shortly after funding.\n"
"\n"
"Timing:\n"
"• Referral bonuses are typically processed within {processingDays} business days of account funding.\n"
"• Referral links may expire or be subject to program changes at any time.\n"
"\n"
"Limitations:\n"
"• Self-referrals are not permitted.\n"
"• Monetary Metals reserves the right to withhold or reverse bonus payments if fraudulent activity or abuse is detected.\n"
"• There is no cap on the number of friends you may refer, unless otherwise specified in a referral agreement.\n"
"\n"
"Other Terms:\n"
"• This program is offered at Monetary Metals' sole discretion and may be modified or terminated at any time.\n"
"• Participation in this program constitutes agreement to these terms and any other applicable policies.\n"
"• For any questions, contact support@monetary-metals.com."

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:215
msgid "EIN of the company"
msgstr "EIN of the company"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:155
msgid "EIN of the trust"
msgstr "EIN of the trust"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:300
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfoJointOwnerInfo.ts:20
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:183
msgid "Either Signatory"
msgstr "Either Signatory"

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:101
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:476
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:598
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:719
#: src/routes/_authenticated/trade/-components/RequestStatus.tsx:137
#: src/routes/_unauthenticated/-components/SignUp.tsx:209
#: src/routes/_unauthenticated/-components/SignUp.tsx:210
msgid "Email"
msgstr "Email"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:336
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfoJointOwnerInfo.ts:73
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:219
msgid "Email cannot be the same as owner's email"
msgstr "Email cannot be the same as owner's email"

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:98
msgid "Emergency Contact"
msgstr "Emergency Contact"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:351
msgid "Emergency contact email"
msgstr "Emergency contact email"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:333
msgid "Emergency contact for account"
msgstr "Emergency contact for account"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:339
msgid "Emergency contact name"
msgstr "Emergency contact name"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:357
msgid "Emergency contact phone"
msgstr "Emergency contact phone"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:345
msgid "Emergency contact relation"
msgstr "Emergency contact relation"

#: src/routes/_authenticated/opportunities/-components/LeasesPageControls.tsx:41
msgid "Enrolled"
msgstr "Enrolled"

#: src/routes/_authenticated/opportunities/-components/LeasesPageControls.tsx:29
msgid "Enrollment"
msgstr "Enrollment"

#: src/shared/components/AchFormSection.tsx:76
#: src/shared/components/payment-methods/WireFormSection.tsx:43
msgid "Enter a nickname"
msgstr "Enter a nickname"

#: src/routes/_unauthenticated/-components/SignUp.tsx:320
msgid "Enter a password"
msgstr "Enter a password"

#: src/routes/_authenticated/trade/withdraw/products/index.tsx:184
msgid "Enter a quantity for weight"
msgstr "Enter a quantity for weight"

#: src/shared/components/AchFormSection.tsx:52
msgid "Enter Account Holder Name"
msgstr "Enter Account Holder Name"

#: src/shared/components/AchFormSection.tsx:67
msgid "Enter Account Number"
msgstr "Enter Account Number"

#: src/routes/_unauthenticated/-components/ConfirmSignIn.tsx:41
msgid "Enter Authenticator Code"
msgstr "Enter Authenticator Code"

#: src/routes/_authenticated/settings/-components/PasswordForm.tsx:84
msgid "Enter Current Password"
msgstr "Enter Current Password"

#: src/routes/_authenticated/settings/-components/PasswordForm.tsx:95
msgid "Enter New Password"
msgstr "Enter New Password"

#: src/routes/_unauthenticated/-components/RecoveryCode.tsx:48
msgid "Enter Recovery Code"
msgstr "Enter Recovery Code"

#: src/shared/components/AchFormSection.tsx:59
msgid "Enter Routing Number"
msgstr "Enter Routing Number"

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalReview.tsx:139
msgid "Enter the code from your authenticator app. We will submit the withdrawal after verification."
msgstr "Enter the code from your authenticator app. We will submit the withdrawal after verification."

#: src/shared/components/MFASetup.tsx:119
msgid "Enter the confirmation code from the app"
msgstr "Enter the confirmation code from the app"

#: src/routes/_unauthenticated/-components/EmailVerification.tsx:75
msgid "Enter verification code"
msgstr "Enter verification code"

#: src/routes/_unauthenticated/-components/ConfirmSignIn.tsx:46
msgid "Enter your Authenticator Code"
msgstr "Enter your Authenticator Code"

#: src/shared/components/MFASetup.tsx:155
msgid "Enter your confirmation code"
msgstr "Enter your confirmation code"

#: src/routes/_unauthenticated/-components/ForgotPassword.tsx:40
#: src/routes/_unauthenticated/-components/SignIn.tsx:123
msgid "Enter your Email"
msgstr "Enter your Email"

#: src/routes/_unauthenticated/-components/NewPassword.tsx:61
#: src/routes/_unauthenticated/-components/ResetPassword.tsx:84
msgid "Enter your New Password"
msgstr "Enter your New Password"

#: src/routes/_unauthenticated/-components/SignIn.tsx:130
msgid "Enter your Password"
msgstr "Enter your Password"

#: src/routes/_unauthenticated/-components/RecoveryCode.tsx:50
#: src/routes/_unauthenticated/-components/ResetPassword.tsx:77
msgid "Enter your Recovery Code"
msgstr "Enter your Recovery Code"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/foreignCorpDocs.ts:47
msgid "Entity Existence"
msgstr "Entity Existence"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:460
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:582
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:703
msgid "Entity name"
msgstr "Entity name"

#: src/shared/components/FeedbackDialogResponse.tsx:14
msgid "Error"
msgstr "Error"

#: src/routes/_authenticated/trade/-components/ShipMetal/PackingSlipSignature.tsx:80
msgid "Error generating packing slip. Please try again later."
msgstr "Error generating packing slip. Please try again later."

#: src/routes/_unauthenticated/-components/EmailVerification.tsx:48
msgid "Error resending code: {errorMessage}"
msgstr "Error resending code: {errorMessage}"

#: src/routes/_authenticated/referrals.tsx:78
msgid "Error Retrieving Referral Code"
msgstr "Error Retrieving Referral Code"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:105
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:79
msgid "Estate"
msgstr "Estate"

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:96
#~ msgid "Estimated dollar value is based on yesterday's PM fix price."
#~ msgstr "Estimated dollar value is based on yesterday's PM fix price."

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:150
#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:191
#: src/routes/_authenticated/trade/withdraw/cash/review.tsx:104
msgid "Estimated fee"
msgstr "Estimated fee"

#: src/routes/_unauthenticated/-components/SignUp.tsx:226
msgid "Estimated Investment amount"
msgstr "Estimated Investment amount"

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:547
#: src/routes/_authenticated/trade/withdraw/cash/review.tsx:107
msgid "Estimated proceeds"
msgstr "Estimated proceeds"

#: src/routes/_authenticated/trade/withdraw/cash/payout.tsx:126
#: src/routes/_authenticated/trade/withdraw/cash/review.tsx:121
msgid "Estimated Proceeds"
msgstr "Estimated Proceeds"

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:529
#: src/routes/_authenticated/trade/withdraw/cash/payout.tsx:98
#: src/routes/_authenticated/trade/withdraw/cash/review.tsx:124
#: src/routes/_authenticated/trade/withdraw/cash/review.tsx:140
#~ msgid "Estimated proceeds are based on yesterday's PM Fix price. The final sale amount will be determined by the spot price at the time of trade execution, with any applicable Monetary Metals fees."
#~ msgstr "Estimated proceeds are based on yesterday's PM Fix price. The final sale amount will be determined by the spot price at the time of trade execution, with any applicable Monetary Metals fees."

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:529
#: src/routes/_authenticated/trade/withdraw/cash/payout.tsx:98
#: src/routes/_authenticated/trade/withdraw/cash/review.tsx:124
#: src/routes/_authenticated/trade/withdraw/cash/review.tsx:140
#~ msgid "Estimated proceeds are based on yesterday’s PM Fix. The final sale amount is determined by the spot price at execution and Monetary Metals fees."
#~ msgstr "Estimated proceeds are based on yesterday’s PM Fix. The final sale amount is determined by the spot price at execution and Monetary Metals fees."

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:95
#~ msgid "Estimated proceeds are based on yesterday's PM fix. The final sale amount is determined by the spot price at execution."
#~ msgstr "Estimated proceeds are based on yesterday's PM fix. The final sale amount is determined by the spot price at execution."

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:95
msgid "Estimated proceeds are based on yesterday's PM fix. The final sale amount will be determined by the spot price at execution."
msgstr "Estimated proceeds are based on yesterday's PM fix. The final sale amount will be determined by the spot price at execution."

#: src/routes/_authenticated/trade/withdraw/products/index.tsx:224
#: src/routes/_authenticated/trade/withdraw/products/review.tsx:45
#~ msgid "Estimated product value"
#~ msgstr "Estimated product value"

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:546
msgid "Estimated sale"
msgstr "Estimated sale"

#: src/routes/_authenticated/trade/withdraw/products/index.tsx:224
#: src/routes/_authenticated/trade/withdraw/products/review.tsx:62
#: src/routes/_authenticated/trade/withdraw/products/signature.tsx:196
#~ msgid "Estimated total"
#~ msgstr "Estimated total"

#: src/routes/_authenticated/trade/withdraw/products/index.tsx:202
#: src/routes/_authenticated/trade/withdraw/products/signature.tsx:190
#~ msgid "Estimated value"
#~ msgstr "Estimated value"

#: src/routes/_authenticated/referrals/-components/ReferralMetrics.tsx:104
msgid "Estimated yearly earnings if your current referral activity continues at the same pace."
msgstr "Estimated yearly earnings if your current referral activity continues at the same pace."

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/RecurringPurchases.tsx:371
msgid "Every {daysLabel} of the month"
msgstr "Every {daysLabel} of the month"

#: src/routes/_authenticated/trade/-components/ShipMetal/PackingSlipReview.tsx:38
msgid "Extended Weight (Oz)"
msgstr "Extended Weight (Oz)"

#: src/shared/components/Footer.tsx:37
msgid "F.A.Q."
msgstr "F.A.Q."

#: src/routes/_authenticated/referrals.tsx:79
msgid "Failed to retrieve your referral code. Please try again later."
msgstr "Failed to retrieve your referral code. Please try again later."

#: src/routes/_authenticated/settings/-components/StartOnboarding.tsx:25
msgid "Failed to start onboarding session. Please try again."
msgstr "Failed to start onboarding session. Please try again."

#: src/routes/_authenticated/opportunities/-components/Opportunity.tsx:236
msgid "Failed to submit desired allocation. Please try again."
msgstr "Failed to submit desired allocation. Please try again."

#: src/components/Trade/RequestStatus.tsx:293
#~ msgid "Fee"
#~ msgstr "Fee"

#: src/shared/components/Footer.tsx:34
msgid "Feedback"
msgstr "Feedback"

#: src/routes/_authenticated/opportunities/-components/Opportunity.tsx:451
msgid "Feedback (optional)"
msgstr "Feedback (optional)"

#: src/shared/components/FeedbackDialogResponse.tsx:14
msgid "Feedback Submitted"
msgstr "Feedback Submitted"

#: src/routes/_authenticated/opportunities/-components/LeasesPageControls.tsx:64
#: src/routes/_authenticated/opportunities/-components/LeasesPageControls.tsx:138
msgid "Filter Leases"
msgstr "Filter Leases"

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalReview.tsx:223
msgid "Final review"
msgstr "Final review"

#: src/routes/_authenticated/opportunities/-components/ReviewPeriodAlert.tsx:130
msgid "Finalize My Choices"
msgstr "Finalize My Choices"

#: src/routes/_authenticated/opportunities/unsecured/$leaseInstance.tsx:184
msgid "Finalizing your unallocated lease enrollment..."
msgstr "Finalizing your unallocated lease enrollment..."

#: src/shared/components/payment-methods/FinalizePlaidPaymentMethod.tsx:67
#: src/shared/components/payment-methods/UpgradePaymentMethodDialog.tsx:119
msgid "Finish payment method"
msgstr "Finish payment method"

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:48
msgid "Firm Disclosure"
msgstr "Firm Disclosure"

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:51
msgid "Firm Name"
msgstr "Firm Name"

#: src/shared/components/payment-methods/PaymentMethodVerification.tsx:62
msgid "First Deposit Amount"
msgstr "First Deposit Amount"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:23
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:444
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:566
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:687
#: src/routes/_unauthenticated/-components/SignUp.tsx:191
#: src/routes/_unauthenticated/-components/SignUp.tsx:192
msgid "First name"
msgstr "First name"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:186
msgid "For tax purposes, please declare your country of residence (if not listed, please select 'Not applicable'):"
msgstr "For tax purposes, please declare your country of residence (if not listed, please select 'Not applicable'):"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:182
msgid "For tax purposes, please select the tax jurisdiction of the company (if not listed, please select 'Not applicable'):"
msgstr "For tax purposes, please select the tax jurisdiction of the company (if not listed, please select 'Not applicable'):"

#: src/routes/_authenticated/trade/-components/Withdrawal/ShippingScreen.tsx:119
#: src/routes/_authenticated/trade/withdraw/products/review.tsx:45
msgid "For this withdrawal only."
msgstr "For this withdrawal only."

#. placeholder {0}: Math.floor(inactiveTimeVal / 1000)
#: src/shared/components/IdleTimer.tsx:48
msgid "For your security, we will sign you out in {0} seconds."
msgstr "For your security, we will sign you out in {0} seconds."

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:104
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:78
msgid "Foreign Corporation"
msgstr "Foreign Corporation"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:135
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:125
msgid "Foreign-Based"
msgstr "Foreign-Based"

#: src/routes/_unauthenticated/-components/ForgotPassword.tsx:34
msgid "Forgot Password"
msgstr "Forgot Password"

#: src/routes/_unauthenticated/-components/SignIn.tsx:155
msgid "Forgot your password?"
msgstr "Forgot your password?"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:657
msgid "Four additional beneficial owners to declare"
msgstr "Four additional beneficial owners to declare"

#: src/routes/_authenticated/referrals/-components/ReferralInviteModal.tsx:102
msgid "Friend's Email"
msgstr "Friend's Email"

#: src/routes/_authenticated/referrals/-components/ReferralMetrics.tsx:94
msgid "From Leasing"
msgstr "From Leasing"

#: src/routes/_authenticated/referrals/-components/ReferralMetrics.tsx:87
msgid "From Metal Purchases"
msgstr "From Metal Purchases"

#: src/routes/_authenticated/trade/withdraw/products/review.tsx:36
msgid "Fulfillment review required"
msgstr "Fulfillment review required"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:121
msgid "Full name of the company"
msgstr "Full name of the company"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:95
msgid "Full name of the trust:"
msgstr "Full name of the trust:"

#: src/routes/_authenticated/referrals/-components/ReferralMetrics.tsx:71
msgid "Funded referrals divided by total referrals sent, expressed as a percentage."
msgstr "Funded referrals divided by total referrals sent, expressed as a percentage."

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/clientInfo.ts:69
msgid "Funding"
msgstr "Funding"

#: src/routes/_authenticated/trade/-components/RequestStatus.tsx:94
msgid "Funding Instructions"
msgstr "Funding Instructions"

#: src/routes/_authenticated/trade/-components/RequestStatus.tsx:229
msgid "Funding method"
msgstr "Funding method"

#: src/shared/components/payment-methods/NewPaymentMethod.tsx:51
msgid "FYI"
msgstr "FYI"

#: src/routes/_authenticated/trade/-components/ShipMetal/PackingSlipSignature.tsx:88
msgid "Generating packing slip for signature..."
msgstr "Generating packing slip for signature..."

#: src/shared/components/FeedbackDialogPrompt.tsx:25
msgid "Give feedback"
msgstr "Give feedback"

#: src/routes/_authenticated/balance/-components/BalanceOverviewCard.tsx:27
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/clientFunding.tsx:53
#: src/routes/_authenticated/opportunities/-components/LeasesPageControls.tsx:37
#: src/routes/_authenticated/yield/-components/YieldCard.tsx:25
#: src/shared/components/Header.tsx:37
#: src/shared/components/MetalPageControls.tsx:24
#: src/util/assetLabels.ts:17
msgid "Gold"
msgstr "Gold"

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:124
#: src/routes/_authenticated/trade/-components/Purchase/Recurring/NewScheduleForm.tsx:96
msgid "Gold Amount"
msgstr "Gold Amount"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/clientFunding.tsx:61
msgid "Gold and Silver"
msgstr "Gold and Silver"

#: src/routes/_authenticated/referrals/-components/ReferralMetrics.tsx:83
msgid "Gold bonuses earned from referrals funding their accounts."
msgstr "Gold bonuses earned from referrals funding their accounts."

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/foreignCorpDocs.ts:60
msgid "Governance Documentation"
msgstr "Governance Documentation"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/foreignCorpDocs.ts:116
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/foreignCorpDocs.ts:152
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/foreignCorpDocs.ts:188
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/foreignCorpDocs.ts:224
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:540
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:662
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:783
msgid "Government-issued photo ID"
msgstr "Government-issued photo ID"

#: src/routes/_authenticated/onboarding/-components/config/secondarySignatory/sections/signatory2Details.ts:127
msgid "Government-issued photo ID for account owner / signatory #2:"
msgstr "Government-issued photo ID for account owner / signatory #2:"

#: src/shared/components/AuthenticatedLayout.tsx:15
msgid "Hang on!"
msgstr "Hang on!"

#: src/routes/_unauthenticated/-components/ConfirmSignIn.tsx:65
msgid "Have recovery code?"
msgstr "Have recovery code?"

#: src/shared/components/payment-methods/AddPaymentMethodChooser.tsx:76
msgid "Having issues? Check out our <0>guide</0> to connecting your accounts."
msgstr "Having issues? Check out our <0>guide</0> to connecting your accounts."

#: src/routes/_authenticated/referrals.tsx:150
msgid "Here's how your referral rewards are calculated and paid out."
msgstr "Here's how your referral rewards are calculated and paid out."

#: src/routes/_authenticated/referrals/-components/ReferralEarningsChartContainer.tsx:63
msgid "Hide Chart"
msgstr "Hide Chart"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/clientFunding.tsx:21
msgid "How are you funding your account?"
msgstr "How are you funding your account?"

#: src/routes/_unauthenticated/-components/SignUp.tsx:259
#: src/routes/_unauthenticated/-components/SignUp.tsx:271
msgid "How did you hear about us?"
msgstr "How did you hear about us?"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:641
msgid "How many >25% beneficial owners of the company are not also signatories?"
msgstr "How many >25% beneficial owners of the company are not also signatories?"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:405
msgid "How many additional trustees are there?"
msgstr "How many additional trustees are there?"

#: src/routes/_authenticated/referrals/-components/ReferralTermsOfService.tsx:85
msgid "I agree to the Referral Program Terms above"
msgstr "I agree to the Referral Program Terms above"

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalReview.tsx:58
msgid "I have read and reviewed all withdrawal information and confirm that it is accurate."
msgstr "I have read and reviewed all withdrawal information and confirm that it is accurate."

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:617
msgid "Identify non-signatory beneficial owners"
msgstr "Identify non-signatory beneficial owners"

#: src/shared/components/payment-methods/AddPaymentMethodChooser.tsx:68
msgid "If you enter your details manually, verification can take up to 3 business days, and the account cannot be used for trading until it is verified."
msgstr "If you enter your details manually, verification can take up to 3 business days, and the account cannot be used for trading until it is verified."

#: src/shared/components/payment-methods/FinalizePlaidPaymentMethod.tsx:82
msgid "If you leave this page, you will need to start over to connect your account."
msgstr "If you leave this page, you will need to start over to connect your account."

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/RecurringPurchases.tsx:450
msgid "If you want to purchase gold or silver on an automated cycle, you can create a schedule here."
msgstr "If you want to purchase gold or silver on an automated cycle, you can create a schedule here."

#: src/routes/_authenticated/opportunities/-components/Opportunity.tsx:152
msgid "If you would like to opt in to this lease, please review and sign the unallocated lease agreement. Be advised, all silver available in your Lease Yield Account may be drawn into this lease. If you would like to move some metal into storage, please contact your Relationship Manager."
msgstr "If you would like to opt in to this lease, please review and sign the unallocated lease agreement. Be advised, all silver available in your Lease Yield Account may be drawn into this lease. If you would like to move some metal into storage, please contact your Relationship Manager."

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:551
msgid "If you would like to sell enough metal for a specific dollar amount, please contact"
msgstr "If you would like to sell enough metal for a specific dollar amount, please contact"

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:552
#~ msgid "If you would like to sell enough metal for a specific dollar amount, please contact <0>{HELP_EMAIL}</0> and we will follow up with next steps."
#~ msgstr "If you would like to sell enough metal for a specific dollar amount, please contact <0>{HELP_EMAIL}</0> and we will follow up with next steps."

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/accountType.ts:19
#: src/shared/components/AchFormSection.tsx:42
#: src/shared/components/payment-methods/PlaidFinalizeForm.tsx:116
msgid "Individual"
msgstr "Individual"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/foreignCorpDocs.ts:74
msgid "Individuals with authority or control who aren't already documented in this application."
msgstr "Individuals with authority or control who aren't already documented in this application."

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:49
msgid "Industry"
msgstr "Industry"

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:118
msgid "Initial Deposit"
msgstr "Initial Deposit"

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:111
msgid "Initial Funding"
msgstr "Initial Funding"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/clientFunding.tsx:42
msgid "Initial investment amount"
msgstr "Initial investment amount"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:109
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:83
msgid "International organization"
msgstr "International organization"

#: src/routes/_authenticated/referrals/-components/ReferralInviteModal.tsx:84
msgid "Invite a Friend & Earn Rewards"
msgstr "Invite a Friend & Earn Rewards"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:109
msgid "Irrevocable"
msgstr "Irrevocable"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:96
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:70
msgid "Irrevocable Trust"
msgstr "Irrevocable Trust"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:247
msgid "Is the address of the trust different from your address?"
msgstr "Is the address of the trust different from your address?"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:421
msgid "Is the company's mailing address different from the company's place of business above?"
msgstr "Is the company's mailing address different from the company's place of business above?"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:352
msgid "Is the company's place of business different from your address?"
msgstr "Is the company's place of business different from your address?"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:117
msgid "Is the trust US-based or foreign-based?"
msgstr "Is the trust US-based or foreign-based?"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:317
msgid "Is the trust's mailing address different from the trust address above?"
msgstr "Is the trust's mailing address different from the trust address above?"

#: src/shared/components/payment-methods/PlaidFinalizeForm.tsx:114
msgid "Is this account owned by an individual or a business?"
msgstr "Is this account owned by an individual or a business?"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:265
msgid "Is your mailing address different from your legal / residential address above?"
msgstr "Is your mailing address different from your legal / residential address above?"

#: src/shared/components/FeedbackDialogResponse.tsx:14
msgid "Issue Reported"
msgstr "Issue Reported"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/accountType.ts:32
msgid "Joint account where ownership is split and may pass to separate heirs."
msgstr "Joint account where ownership is split and may pass to separate heirs."

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/accountType.ts:26
msgid "Joint account where ownership passes to the surviving account holder."
msgstr "Joint account where ownership passes to the surviving account holder."

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/clientInfo.ts:40
msgid "Joint Owner"
msgstr "Joint Owner"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/accountType.ts:31
msgid "Joint Tenants in Common (TIC)"
msgstr "Joint Tenants in Common (TIC)"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/accountType.ts:25
msgid "Joint with Rights of Survivorship (JWROS)"
msgstr "Joint with Rights of Survivorship (JWROS)"

#: src/shared/components/route-state/ApiErrorBoundary.tsx:85
msgid "Just a Moment"
msgstr "Just a Moment"

#: src/shared/components/ActivityView.tsx:33
msgid "Last 3 months"
msgstr "Last 3 months"

#: src/shared/components/ActivityView.tsx:37
msgid "Last 3 years"
msgstr "Last 3 years"

#: src/shared/components/ActivityView.tsx:39
msgid "Last 5 years"
msgstr "Last 5 years"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:37
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:452
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:574
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:695
#: src/routes/_unauthenticated/-components/SignUp.tsx:201
#: src/routes/_unauthenticated/-components/SignUp.tsx:202
msgid "Last name"
msgstr "Last name"

#: src/shared/components/ActivityView.tsx:35
msgid "Last year"
msgstr "Last year"

#: src/routes/_authenticated/opportunities/-components/ReviewPeriodAlert.tsx:91
msgid "Learn more"
msgstr "Learn more"

#: src/routes/_authenticated/yield/-components/YieldTable.tsx:55
#: src/routes/_authenticated/yield/-components/YieldTable.tsx:177
msgid "lease"
msgstr "lease"

#: src/routes/_authenticated/yield/-components/YieldTable.tsx:87
msgid "Lease"
msgstr "Lease"

#: src/routes/_authenticated/opportunities/unsecured/$leaseInstance.tsx:136
msgid "Lease Not Found"
msgstr "Lease Not Found"

#: src/routes/_authenticated/balance/-components/balancePayloadGenerators.tsx:28
msgid "Lease Yield Account"
msgstr "Lease Yield Account"

#: src/routes/_authenticated/balance/-components/balancePayloadGenerators.tsx:29
#: src/routes/_authenticated/referrals.tsx:169
#: src/routes/_authenticated/referrals/-components/ReferralEarningsChart.tsx:36
#: src/routes/_authenticated/referrals/-components/ReferralEarningsChart.tsx:88
#: src/routes/_authenticated/yield/-components/YieldTable.tsx:163
#: src/shared/components/MainNavContainer.tsx:40
msgid "Leases"
msgstr "Leases"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:221
msgid "Legal address"
msgstr "Legal address"

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:78
msgid "Legal Address"
msgstr "Legal Address"

#: src/routes/_authenticated/trade/-components/ShipMetal/ShipMetalForm.tsx:133
msgid "List the metal products you will ship to Monetary Metals. This information will generate a packing slip for review and digital signature."
msgstr "List the metal products you will ship to Monetary Metals. This information will generate a packing slip for review and digital signature."

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:228
msgid "LLC"
msgstr "LLC"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:101
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:75
msgid "LLC - C Corporation"
msgstr "LLC - C Corporation"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:103
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:77
msgid "LLC - Partnership"
msgstr "LLC - Partnership"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:102
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:76
msgid "LLC - S Corporation"
msgstr "LLC - S Corporation"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:513
msgid "LLC information"
msgstr "LLC information"

#: src/shared/components/ActivityView.tsx:176
msgid "Loading account activity"
msgstr "Loading account activity"

#: src/routes/_authenticated/trade/withdraw/products/signature.tsx:44
msgid "Loading secure signing"
msgstr "Loading secure signing"

#: src/routes/_authenticated/trade/-components/Withdrawal/ShippingScreen.tsx:74
msgid "Loading your address…"
msgstr "Loading your address…"

#: src/routes/_authenticated/onboarding/-components/StepShell.tsx:62
msgid "Loading..."
msgstr "Loading..."

#: src/shared/components/EmulateUserDialog.tsx:136
msgid "Loading…"
msgstr "Loading…"

#: src/routes/_authenticated/trade/-components/VaultLocationComboBox.tsx:127
msgid "Location"
msgstr "Location"

#: src/shared/components/payment-methods/AddPaymentMethodChooser.tsx:92
msgid "Login with Plaid"
msgstr "Login with Plaid"

#: src/shared/components/IdleTimer.tsx:55
#: src/shared/components/route-state/AuthenticatedErrorBoundary.tsx:54
msgid "Logout"
msgstr "Logout"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:281
msgid "Mailing address"
msgstr "Mailing address"

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:88
msgid "Mailing Address"
msgstr "Mailing Address"

#: src/routes/_authenticated/settings/-components/ManageCookiesForm.tsx:29
msgid "Manage Cookies Preferences"
msgstr "Manage Cookies Preferences"

#: src/shared/components/MFASetup.tsx:140
msgid "Manual code:"
msgstr "Manual code:"

#: src/shared/components/payment-methods/AddPaymentMethodChooser.tsx:102
msgid "Manually enter and verify account"
msgstr "Manually enter and verify account"

#: src/routes/_authenticated/yield/-components/YieldTable.tsx:211
msgid "Matures on {formattedDate}"
msgstr "Matures on {formattedDate}"

#: src/routes/_authenticated/yield/-components/YieldTable.tsx:155
msgid "Maturity"
msgstr "Maturity"

#. placeholder {0}: opportunity.maxDesiredAllocation ? ouncesFormatter.format(opportunity.maxDesiredAllocation) : "N/A"
#: src/routes/_authenticated/opportunities/-components/Opportunity.tsx:478
msgid "Maximum allocation: {0} oz."
msgstr "Maximum allocation: {0} oz."

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/EditScheduleForm.tsx:120
#: src/routes/_authenticated/trade/-components/Purchase/Recurring/NewScheduleForm.tsx:300
msgid "Maximum Purchase Amount Exceeded"
msgstr "Maximum Purchase Amount Exceeded"

#: src/routes/_authenticated/trade/-components/RequestStatus.tsx:145
msgid "Memo"
msgstr "Memo"

#: src/routes/_authenticated/opportunities/-components/LeasesPageControls.tsx:26
#: src/routes/_authenticated/trade/-components/ShipMetal/PackingSlipReview.tsx:34
#: src/routes/_authenticated/trade/-components/ShipMetal/ShipMetalForm.tsx:204
#: src/routes/_authenticated/trade/withdraw/products/index.tsx:132
msgid "Metal"
msgstr "Metal"

#: src/routes/_authenticated/trade/withdraw/products/index.tsx:50
#~ msgid "Metal availability"
#~ msgstr "Metal availability"

#: src/routes/_authenticated/balance/-components/balancePayloadGenerators.tsx:39
msgid "Metal available for bonds."
msgstr "Metal available for bonds."

#: src/routes/_authenticated/balance/-components/balancePayloadGenerators.tsx:37
msgid "Metal available to invest."
msgstr "Metal available to invest."

#: src/routes/_authenticated/balance/-components/balancePayloadGenerators.tsx:38
msgid "Metal currently on a Lease."
msgstr "Metal currently on a Lease."

#: src/routes/_authenticated/balance/-components/balancePayloadGenerators.tsx:40
msgid "Metal currently on a Loan."
msgstr "Metal currently on a Loan."

#: src/routes/_authenticated/balance/-components/balancePayloadGenerators.tsx:36
msgid "Metal held in storage."
msgstr "Metal held in storage."

#: src/routes/_authenticated/trade/-components/requestView.ts:171
msgid "Metal in Account"
msgstr "Metal in Account"

#: src/routes/_authenticated/referrals.tsx:154
#: src/routes/_authenticated/referrals/-components/ReferralEarningsChart.tsx:31
#: src/routes/_authenticated/referrals/-components/ReferralEarningsChart.tsx:79
msgid "Metal Purchases"
msgstr "Metal Purchases"

#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:615
msgid "Metal to Purchase"
msgstr "Metal to Purchase"

#: src/routes/_authenticated/trade.tsx:45
#: src/routes/_authenticated/trade/-components/MetalTransfer.tsx:141
#: src/routes/_authenticated/trade/-components/PendingTransaction.tsx:51
#: src/routes/_authenticated/trade/-components/PendingTransaction.tsx:183
msgid "Metal Transfer"
msgstr "Metal Transfer"

#: src/routes/_authenticated/trade/-components/MetalTransfer.tsx:116
#: src/routes/_authenticated/trade/-components/MetalTransfer.tsx:207
#: src/routes/_authenticated/trade/-components/MetalTransfer.tsx:211
msgid "Metal transfer successful."
msgstr "Metal transfer successful."

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:121
#: src/routes/_authenticated/trade/-components/MetalTransfer.tsx:175
#: src/routes/_authenticated/trade/-components/MetalTypeComboBox.tsx:125
#: src/routes/_authenticated/trade/-components/ShipMetal/ShipMetalForm.tsx:148
#: src/routes/_authenticated/trade/-components/VaultTransfer.tsx:267
msgid "Metal Type"
msgstr "Metal Type"

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:112
msgid "Method"
msgstr "Method"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:30
msgid "Middle"
msgstr "Middle"

#: src/routes/_unauthenticated/-components/SignUp.tsx:195
#: src/routes/_unauthenticated/-components/SignUp.tsx:195
msgid "Middle name"
msgstr "Middle name"

#: src/routes/_authenticated/trade/-components/VaultTransfer.tsx:204
msgid "Minimum Amount Not Met"
msgstr "Minimum Amount Not Met"

#: src/routes/_authenticated/spreads.tsx:30
msgid "Monetary Metals buys and sells gold and silver at a spread to the London Fix price, or the spot price, depending on when the trade occurs."
msgstr "Monetary Metals buys and sells gold and silver at a spread to the London Fix price, or the spot price, depending on when the trade occurs."

#: src/shared/components/MFASetup.tsx:70
msgid "Monetary Metals Client Portal"
msgstr "Monetary Metals Client Portal"

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:209
#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:212
msgid "Monetary Metals fee schedule"
msgstr "Monetary Metals fee schedule"

#: src/routes/_authenticated/settings/-components/payment-methods/ManagePaymentMethods.tsx:211
#~ msgid "Monetary Metals uses Plaid to instantly verify access to your bank account. <0>Learn more</0>."
#~ msgstr "Monetary Metals uses Plaid to instantly verify access to your bank account. <0>Learn more</0>."

#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:346
#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:347
msgid "Must specify at least one metal amount"
msgstr "Must specify at least one metal amount"

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:37
#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:99
msgid "Name"
msgstr "Name"

#: src/routes/_authenticated/referrals/-components/ReferralInviteModal.tsx:107
msgid "name@email.com"
msgstr "name@email.com"

#: src/routes/_authenticated/onboarding.tsx:77
#: src/routes/_authenticated/onboarding/-components/OnboardingLayout.tsx:65
msgid "Need help?"
msgstr "Need help?"

#: src/shared/components/MFASetup.tsx:121
msgid "Need help? Check out our <0>guide</0>."
msgstr "Need help? Check out our <0>guide</0>."

#: src/routes/_authenticated/trade/-components/RequestStatus.tsx:78
#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:99
msgid "Need help? Contact Client Relations"
msgstr "Need help? Contact Client Relations"

#: src/routes/_authenticated/opportunities/-components/LeasesPageControls.tsx:34
msgid "Needs Review"
msgstr "Needs Review"

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:44
msgid "Net Worth"
msgstr "Net Worth"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:96
msgid "Net worth (approximate)"
msgstr "Net worth (approximate)"

#: src/routes/_authenticated/opportunities/-components/opportunityBanners.ts:46
msgid "New"
msgstr "New"

#: src/routes/_authenticated/onboarding/-components/StepShell.tsx:62
msgid "Next"
msgstr "Next"

#: src/routes/_authenticated/trade/-components/Withdrawal/ShippingScreen.tsx:221
#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:102
#~ msgid "Next day"
#~ msgstr "Next day"

#. placeholder {0}: formatDateLong(nextPurchaseDate)
#: src/routes/_authenticated/trade/-components/Purchase/Recurring/RecurringPurchases.tsx:375
msgid "Next purchase on {0}"
msgstr "Next purchase on {0}"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/clientFunding.tsx:103
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:165
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:360
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:425
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:632
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:725
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:800
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:876
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:952
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/foreignCorpDocs.ts:81
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/foreignCorpDocs.ts:127
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/foreignCorpDocs.ts:163
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/foreignCorpDocs.ts:199
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/foreignCorpDocs.ts:235
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:161
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:269
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:383
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfoJointOwnerInfo.ts:40
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:251
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:321
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:393
#: src/routes/_authenticated/onboarding/-components/config/secondarySignatory/sections/signatory2Details.ts:47
#: src/routes/_authenticated/onboarding/-components/config/secondarySignatory/sections/signatory2Details.ts:89
#: src/routes/_authenticated/onboarding/-components/config/secondarySignatory/sections/signatory2Details.ts:136
#: src/routes/_authenticated/onboarding/-components/config/secondarySignatory/sections/signatory2Details.ts:156
msgid "No"
msgstr "No"

#: src/routes/_authenticated/trade/-components/DateMultiselect.tsx:30
msgid "No dates selected"
msgstr "No dates selected"

#: src/shared/components/EmulateUserDialog.tsx:140
msgid "No matching users. You can still paste a Cognito ID above."
msgstr "No matching users. You can still paste a Cognito ID above."

#: src/shared/components/NotificationsDropdown.tsx:54
msgid "No new notifications!"
msgstr "No new notifications!"

#: src/routes/_authenticated/onboarding.tsx:19
#: src/routes/_authenticated/onboarding/-components/OnboardingLayout.tsx:77
msgid "No onboarding session found"
msgstr "No onboarding session found"

#: src/shared/components/payment-methods/ManagePaymentMethods.tsx:139
msgid "No payment methods found. Add one below to use for future trades."
msgstr "No payment methods found. Add one below to use for future trades."

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/RecurringPurchases.tsx:449
msgid "No Recurring Purchases"
msgstr "No Recurring Purchases"

#: src/routes/_authenticated/trade/-components/PaymentMethodPicker.tsx:99
msgid "No saved payment methods"
msgstr "No saved payment methods"

#: src/shared/components/PasswordValidationTooltip.tsx:34
msgid "No spaces"
msgstr "No spaces"

#: src/routes/_authenticated/documents/statement.tsx:25
msgid "No statements found. New clients can expect their first statement within one month of account opening."
msgstr "No statements found. New clients can expect their first statement within one month of account opening."

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:73
msgid "No Tax Treaty Country"
msgstr "No Tax Treaty Country"

#: src/shared/components/payment-methods/FinalizePlaidPaymentMethod.tsx:86
msgid "No, continue connecting account"
msgstr "No, continue connecting account"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:198
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:203
msgid "Non-treaty tax country"
msgstr "Non-treaty tax country"

#: src/shared/components/payment-methods/UpgradePaymentMethodDialog.tsx:136
msgid "None of the accounts selected through Plaid matched your saved account."
msgstr "None of the accounts selected through Plaid matched your saved account."

#: src/shared/components/MFASetup.tsx:181
msgid "Not now"
msgstr "Not now"

#: src/routes/_unauthenticated/-components/SignIn.tsx:160
msgid "Not yet a client?"
msgstr "Not yet a client?"

#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:187
msgid "Note"
msgstr "Note"

#: src/routes/_authenticated/documents.tsx:29
#: src/routes/_authenticated/documents/notification.tsx:69
msgid "Notifications"
msgstr "Notifications"

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:41
msgid "Occupation"
msgstr "Occupation"

#: src/routes/_authenticated/trade/-components/RequestStatus.tsx:234
msgid "On file"
msgstr "On file"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/NewScheduleForm.tsx:48
msgid "On the 16th"
msgstr "On the 16th"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/NewScheduleForm.tsx:47
msgid "On the 1st"
msgstr "On the 1st"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:645
msgid "One additional beneficial owner to declare"
msgstr "One additional beneficial owner to declare"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:409
msgid "One additional trustee"
msgstr "One additional trustee"

#: src/routes/_authenticated/trade/-components/Purchase/TimedOutTransactionsDialog.tsx:36
msgid "One or more of your purchase transactions timed out while we were waiting for confirmation. We're checking periodically for updates and will notify you when your transactions are confirmed."
msgstr "One or more of your purchase transactions timed out while we were waiting for confirmation. We're checking periodically for updates and will notify you when your transactions are confirmed."

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:278
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:167
msgid "One Signer"
msgstr "One Signer"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:274
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:163
msgid "One signer or two signers?"
msgstr "One signer or two signers?"

#: src/routes/_authenticated/trade/-components/Purchase/PurchaseLayout.tsx:55
msgid "One Time"
msgstr "One Time"

#: src/routes/_authenticated/trade/-components/Purchase/PurchaseLayout.tsx:54
msgid "One Time Purchase"
msgstr "One Time Purchase"

#: src/routes/_authenticated/trade/withdraw/cash/payout.tsx:55
msgid "Only bank accounts verified through Plaid are shown."
msgstr "Only bank accounts verified through Plaid are shown."

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:473
msgid "Only unleased metal is available to sell."
msgstr "Only unleased metal is available to sell."

#: src/shared/components/MFASetup.tsx:118
msgid "Open the app and scan the QR code, or enter the code manually"
msgstr "Open the app and scan the QR code, or enter the code manually"

#: src/routes/_unauthenticated/-components/SignUp.tsx:179
msgid "Open Your Account"
msgstr "Open Your Account"

#: src/shared/components/MainNavContainer.tsx:42
msgid "Opportunities: See your opportunities"
msgstr "Opportunities: See your opportunities"

#: src/routes/_authenticated/opportunities/-components/Opportunity.tsx:174
#: src/routes/_authenticated/opportunities/-components/Opportunity.tsx:178
msgid "Opt In"
msgstr "Opt In"

#: src/routes/_authenticated/opportunities/-components/Opportunity.tsx:168
#: src/routes/_authenticated/opportunities/-components/Opportunity.tsx:172
msgid "Opt Out"
msgstr "Opt Out"

#: src/routes/_authenticated/opportunities/-components/LeasesPageControls.tsx:39
#: src/routes/_authenticated/opportunities/-components/Opportunity.tsx:290
msgid "Opted In"
msgstr "Opted In"

#: src/routes/_authenticated/opportunities/-components/LeasesPageControls.tsx:40
#: src/routes/_authenticated/opportunities/-components/Opportunity.tsx:280
msgid "Opted Out"
msgstr "Opted Out"

#. placeholder {0}: view.id
#: src/routes/_authenticated/trade/-components/RequestStatus.tsx:174
msgid "Order number {0}"
msgstr "Order number {0}"

#: src/routes/_authenticated/trade/-components/requestView.ts:158
msgid "Order Submitted"
msgstr "Order Submitted"

#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:111
msgid "Ounce"
msgstr "Ounce"

#: src/routes/_authenticated/yield/-components/YieldTable.tsx:125
msgid "Ounces"
msgstr "Ounces"

#: src/routes/_authenticated/referrals/-components/ReferralEarningsChart.tsx:60
msgid "Ounces Earned"
msgstr "Ounces Earned"

#: src/routes/_authenticated/referrals/-components/ReferralMetrics.tsx:97
msgid "Ounces earned from leases initiated by your referrals."
msgstr "Ounces earned from leases initiated by your referrals."

#. placeholder {0}: metalLabel(metal)
#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:435
msgid "Ounces of {0} to sell"
msgstr "Ounces of {0} to sell"

#: src/routes/_authenticated/onboarding/-components/config/secondarySignatory/sections/signatory2Details.ts:96
msgid "Owner #2 citizenship"
msgstr "Owner #2 citizenship"

#: src/routes/_authenticated/onboarding/-components/config/secondarySignatory/sections/signatory2Details.ts:113
msgid "Owner #2 social security number"
msgstr "Owner #2 social security number"

#: src/routes/_authenticated/onboarding/-components/config/secondarySignatory/sections/signatory2Details.ts:105
msgid "Owner #2 tax identification number (non-US)"
msgstr "Owner #2 tax identification number (non-US)"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/foreignCorpDocs.ts:34
msgid "Ownership Documentation"
msgstr "Ownership Documentation"

#: src/shared/components/ConversionPicker.tsx:33
#: src/shared/components/ConversionPicker.tsx:42
#: src/shared/components/ConversionPicker.tsx:57
msgid "Oz"
msgstr "Oz"

#: src/routes/_authenticated/referrals.tsx:180
msgid "Paid on lease inception"
msgstr "Paid on lease inception"

#: src/routes/_authenticated/referrals.tsx:166
msgid "Paid quarterly on last year's deposits. Gold must remain in LYSA for 1 year to get reward."
msgstr "Paid quarterly on last year's deposits. Gold must remain in LYSA for 1 year to get reward."

#: src/routes/_authenticated/balance/-components/BalanceOverviewCard.tsx:31
#: src/routes/_authenticated/yield/-components/YieldCard.tsx:28
#: src/shared/components/MetalPageControls.tsx:39
#: src/util/assetLabels.ts:20
msgid "Palladium"
msgstr "Palladium"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:100
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:240
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:264
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:74
msgid "Partnership"
msgstr "Partnership"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:540
msgid "Partnership information"
msgstr "Partnership information"

#: src/routes/_authenticated/settings.tsx:19
#: src/routes/_unauthenticated/-components/SignUp.tsx:316
msgid "Password"
msgstr "Password"

#: src/routes/_authenticated/settings/-components/PasswordForm.tsx:58
#: src/routes/_unauthenticated/-components/SignIn.tsx:38
msgid "Password cannot contain spaces. Please try again."
msgstr "Password cannot contain spaces. Please try again."

#: src/routes/_authenticated/settings/-components/PasswordForm.tsx:48
msgid "Password changed successfully!"
msgstr "Password changed successfully!"

#: src/routes/_authenticated/settings/-components/PasswordForm.tsx:63
msgid "Password must be at least 8 characters long."
msgstr "Password must be at least 8 characters long."

#: src/shared/components/PasswordValidationTooltip.tsx:52
msgid "Password must contain:"
msgstr "Password must contain:"

#: src/routes/_authenticated/settings/-components/PasswordForm.tsx:65
msgid "Password must have at least 1 lowercase letter."
msgstr "Password must have at least 1 lowercase letter."

#: src/routes/_authenticated/settings/-components/PasswordForm.tsx:62
msgid "Password must have at least 1 number."
msgstr "Password must have at least 1 number."

#: src/routes/_authenticated/settings/-components/PasswordForm.tsx:61
msgid "Password must have at least 1 symbol character."
msgstr "Password must have at least 1 symbol character."

#: src/routes/_authenticated/settings/-components/PasswordForm.tsx:64
msgid "Password must have at least 1 uppercase letter."
msgstr "Password must have at least 1 uppercase letter."

#: src/routes/_authenticated/settings/-components/PasswordForm.tsx:59
#: src/routes/_unauthenticated/-components/NewPassword.tsx:31
#: src/routes/_unauthenticated/-components/ResetPassword.tsx:34
#: src/routes/_unauthenticated/-components/SignUp.tsx:134
msgid "Passwords do not match. Please try again."
msgstr "Passwords do not match. Please try again."

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/RecurringPurchases.tsx:191
msgid "Pause Purchases"
msgstr "Pause Purchases"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/RecurringPurchases.tsx:219
#: src/routes/_authenticated/trade/-components/Purchase/Recurring/RecurringPurchases.tsx:404
msgid "Pause Schedule"
msgstr "Pause Schedule"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/EditScheduleForm.tsx:230
msgid "Pause Until"
msgstr "Pause Until"

#. placeholder {0}: formatDateLong(fromStringToDate(schedule.pausedUntilDate!))
#: src/routes/_authenticated/trade/-components/Purchase/Recurring/RecurringPurchases.tsx:374
msgid "Paused until {0}"
msgstr "Paused until {0}"

#: src/routes/_authenticated/trade/withdraw/cash/payout.tsx:44
#~ msgid "Payment details"
#~ msgstr "Payment details"

#: src/shared/components/AchFormSection.tsx:75
#: src/shared/components/payment-methods/WireFormSection.tsx:42
msgid "Payment Method Nickname (optional)"
msgstr "Payment Method Nickname (optional)"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/NewScheduleForm.tsx:198
msgid "Payment Method:"
msgstr "Payment Method:"

#: src/routes/_authenticated/settings.tsx:39
#: src/shared/components/payment-methods/ManagePaymentMethods.tsx:179
msgid "Payment Methods"
msgstr "Payment Methods"

#: src/routes/_authenticated/trade/-components/RequestStatus.tsx:242
msgid "Payment sent"
msgstr "Payment sent"

#: src/routes/_authenticated/trade/-components/requestView.ts:171
msgid "Payment Sent"
msgstr "Payment Sent"

#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:524
#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:683
msgid "Payment Type"
msgstr "Payment Type"

#: src/routes/_authenticated/trade/-components/RequestStatus.tsx:229
#: src/routes/_authenticated/trade/withdraw/cash/payout.tsx:88
#: src/routes/_authenticated/trade/withdraw/cash/review.tsx:109
msgid "Payout method"
msgstr "Payout method"

#: src/routes/_authenticated/referrals/-components/ReferralMetrics.tsx:54
msgid "Pending Onboarding"
msgstr "Pending Onboarding"

#: src/routes/_authenticated/trade/-components/Purchase/PendingTransactionDiaog.tsx:28
msgid "Pending Purchase Detected"
msgstr "Pending Purchase Detected"

#: src/components/Trade/RequestStatus.tsx:288
#~ msgid "Pending trade"
#~ msgstr "Pending trade"

#: src/routes/_authenticated/trade/withdraw/cash/payout.tsx:76
msgid "Pending verification"
msgstr "Pending verification"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:94
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:68
msgid "Person"
msgstr "Person"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/accountType.ts:20
msgid "Personal account owned by one individual."
msgstr "Personal account owned by one individual."

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/clientInfo.ts:33
msgid "Personal Info"
msgstr "Personal Info"

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:36
#: src/routes/_authenticated/onboarding/-components/Signatory2ReviewAndSign.tsx:29
msgid "Personal Information"
msgstr "Personal Information"

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:39
#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:102
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:54
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:468
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:590
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:711
#: src/routes/_authenticated/trade/-components/RequestStatus.tsx:133
#: src/routes/_unauthenticated/-components/SignUp.tsx:217
msgid "Phone"
msgstr "Phone"

#: src/routes/_authenticated/onboarding/-components/Signatory2ReviewAndSign.tsx:72
msgid "Photo ID Matches Application"
msgstr "Photo ID Matches Application"

#: src/routes/_authenticated/onboarding/-components/config/secondarySignatory/sections/signatory2Details.ts:121
msgid "Photo identification"
msgstr "Photo identification"

#: src/routes/_authenticated/trade/withdraw/products/review.tsx:31
msgid "Physical products"
msgstr "Physical products"

#: src/routes/_authenticated/balance/-components/BalanceOverviewCard.tsx:30
#: src/routes/_authenticated/yield/-components/YieldCard.tsx:29
#: src/shared/components/MetalPageControls.tsx:34
#: src/util/assetLabels.ts:19
msgid "Platinum"
msgstr "Platinum"

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:26
#: src/routes/_authenticated/onboarding/-components/Signatory2ReviewAndSign.tsx:24
msgid "Please click Next on the bottom right of your screen to be taken to the signing step."
msgstr "Please click Next on the bottom right of your screen to be taken to the signing step."

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:144
msgid "Please disclose the name of your firm and any additional details:"
msgstr "Please disclose the name of your firm and any additional details:"

#: src/routes/_authenticated/opportunities/-components/Opportunity.tsx:200
msgid "Please enter a valid allocation amount."
msgstr "Please enter a valid allocation amount."

#: src/shared/components/MFASetup.tsx:89
msgid "Please enter a valid code."
msgstr "Please enter a valid code."

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/clientFunding.tsx:71
msgid "Please enter the approximate total number of ounces of gold with which you intend to fund your account. Later, you will be prompted for the exact number of ounces, product details, and location of the metals."
msgstr "Please enter the approximate total number of ounces of gold with which you intend to fund your account. Later, you will be prompted for the exact number of ounces, product details, and location of the metals."

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:618
msgid "Please identify below up to four entities / individuals below which hold 25% or greater ownership interest and have control over the company. The Client Services team will be in touch for additional information regarding these persons / entities."
msgstr "Please identify below up to four entities / individuals below which hold 25% or greater ownership interest and have control over the company. The Client Services team will be in touch for additional information regarding these persons / entities."

#: src/routes/_authenticated/opportunities/-components/Opportunity.tsx:456
msgid "Please let us know why you would like to opt out of this lease"
msgstr "Please let us know why you would like to opt out of this lease"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:195
msgid "Please note: country of residence does not have a tax treaty with the US"
msgstr "Please note: country of residence does not have a tax treaty with the US"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:191
msgid "Please note: tax country does not have a tax treaty with the US"
msgstr "Please note: tax country does not have a tax treaty with the US"

#: src/routes/_unauthenticated/-components/ConfirmSignIn.tsx:42
msgid "Please open your third-party authenticator app to receive the code."
msgstr "Please open your third-party authenticator app to receive the code."

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfoJointOwnerInfo.ts:11
msgid "Please provide some basic information about your joint owner. Once the documents are signed, the joint owner will receive an invitation to complete their information and sign the Account Agreement."
msgstr "Please provide some basic information about your joint owner. Once the documents are signed, the joint owner will receive an invitation to complete their information and sign the Account Agreement."

#: src/routes/_authenticated/onboarding/-components/config/secondarySignatory/sections/signatory2Details.ts:20
msgid "Please provide the following information to complete your account setup."
msgstr "Please provide the following information to complete your account setup."

#: src/GenericErrorPage.tsx:16
msgid "Please refresh your page to continue your session. If your problem persists, please report the issue by clicking the \"Report Issue\" button below."
msgstr "Please refresh your page to continue your session. If your problem persists, please report the issue by clicking the \"Report Issue\" button below."

#: src/routes/_authenticated/trade/-components/ShipMetal/PackingSlipSignature.tsx:95
msgid "Please review and sign your packing slip. Once signed, your Relationship Manager will reach out with detailed shipping instructions and next steps."
msgstr "Please review and sign your packing slip. Once signed, your Relationship Manager will reach out with detailed shipping instructions and next steps."

#: src/routes/_authenticated/opportunities/unsecured/$leaseInstance.tsx:185
msgid "Please review and sign your unallocated lease agreement to complete opt-in."
msgstr "Please review and sign your unallocated lease agreement to complete opt-in."

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/clientFunding.tsx:27
msgid "Please select a method for funding your Monetary Metals account"
msgstr "Please select a method for funding your Monetary Metals account"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/accountType.ts:10
msgid "Please select the type of account you would like to open"
msgstr "Please select the type of account you would like to open"

#: src/routes/_unauthenticated/-components/SignUp.tsx:272
#: src/routes/_unauthenticated/-components/SignUp.tsx:282
#: src/routes/_unauthenticated/-components/SignUp.tsx:284
#: src/routes/_unauthenticated/-components/SignUp.tsx:294
#: src/routes/_unauthenticated/-components/SignUp.tsx:296
msgid "Please specify"
msgstr "Please specify"

#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:372
msgid "Please submit a total greater than or equal to {formattedMinAmount} (minimum purchase limit)"
msgstr "Please submit a total greater than or equal to {formattedMinAmount} (minimum purchase limit)"

#. placeholder {0}: formatCurrency(maxPurchaseAmount)
#: src/routes/_authenticated/trade/-components/Purchase/Recurring/EditScheduleForm.tsx:121
msgid "Please submit a total less than or equal to {0}. If you would like to have an increased limit, please contact your Relationship Manager."
msgstr "Please submit a total less than or equal to {0}. If you would like to have an increased limit, please contact your Relationship Manager."

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/NewScheduleForm.tsx:301
msgid "Please submit a total less than or equal to {formattedMaxAmount}. If you would like to have an increased limit, please contact your Relationship Manager."
msgstr "Please submit a total less than or equal to {formattedMaxAmount}. If you would like to have an increased limit, please contact your Relationship Manager."

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:116
msgid "Please tell us about the company"
msgstr "Please tell us about the company"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfoJointOwnerInfo.ts:10
msgid "Please tell us about the joint owner"
msgstr "Please tell us about the joint owner"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:90
msgid "Please tell us about the trust"
msgstr "Please tell us about the trust"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:12
msgid "Please tell us about yourself"
msgstr "Please tell us about yourself"

#: src/routes/_authenticated/trade/-components/RequestStatus.tsx:98
msgid "Please transfer funds to the following account:"
msgstr "Please transfer funds to the following account:"

#: src/routes/_authenticated/opportunities/unsecured/$leaseInstance.tsx:165
msgid "Please try again later or contact support if this keeps happening."
msgstr "Please try again later or contact support if this keeps happening."

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:391
msgid "Please upload a current proof of address document showing your full name and residential address together."
msgstr "Please upload a current proof of address document showing your full name and residential address together."

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/foreignCorpDocs.ts:35
msgid "Please upload a document that identifies any individual or entity that owns 25% or more of the entity, directly or indirectly."
msgstr "Please upload a document that identifies any individual or entity that owns 25% or more of the entity, directly or indirectly."

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/foreignCorpDocs.ts:95
msgid "Please upload a document that identifies these individuals and describes their authority or role (for example, a board resolution, register of directors, or appointment records)."
msgstr "Please upload a document that identifies these individuals and describes their authority or role (for example, a board resolution, register of directors, or appointment records)."

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/foreignCorpDocs.ts:61
msgid "Please upload a document that shows the entity's control structure and authorized signatories (for example, articles of association, bylaws, or an operating agreement)."
msgstr "Please upload a document that shows the entity's control structure and authorized signatories (for example, articles of association, bylaws, or an operating agreement)."

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/foreignCorpDocs.ts:48
msgid "Please upload a government-issued document that confirms the legal existence and registration of the entity."
msgstr "Please upload a government-issued document that confirms the legal existence and registration of the entity."

#: src/routes/_authenticated/onboarding/-components/config/secondarySignatory/sections/signatory2Details.ts:122
msgid "Please upload a scan of your government-issued photo ID below."
msgstr "Please upload a scan of your government-issued photo ID below."

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/W8BenEDownload.tsx:10
msgid "Please upload a signed form <0>W8BEN-E</0>."
msgstr "Please upload a signed form <0>W8BEN-E</0>."

#: src/routes/_authenticated/onboarding/-components/config/secondarySignatory/sections/signatory2Details.ts:143
msgid "Please upload a utility bill, bank statement, or other document to verify your address:"
msgstr "Please upload a utility bill, bank statement, or other document to verify your address:"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:364
msgid "Please upload an image of your valid government-issued photo ID."
msgstr "Please upload an image of your valid government-issued photo ID."

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:236
msgid "Please upload trust documentation."
msgstr "Please upload trust documentation."

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:250
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:316
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:523
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:645
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:766
#: src/routes/_authenticated/trade/-components/Withdrawal/ShippingScreen.tsx:166
msgid "Postal or zip code"
msgstr "Postal or zip code"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:46
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:47
#: src/routes/_authenticated/onboarding/-components/config/secondarySignatory/sections/signatory2Details.ts:26
#: src/routes/_authenticated/onboarding/-components/config/secondarySignatory/sections/signatory2Details.ts:27
msgid "Preferred name"
msgstr "Preferred name"

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:38
#: src/routes/_authenticated/onboarding/-components/Signatory2ReviewAndSign.tsx:30
msgid "Preferred Name"
msgstr "Preferred Name"

#: src/routes/_authenticated/balance/-components/PremiumSummaryCard.tsx:82
msgid "Premiums"
msgstr "Premiums"

#: src/routes/_authenticated/trade/-components/requestView.ts:168
msgid "Preparing ACH Payment"
msgstr "Preparing ACH Payment"

#: src/routes/_authenticated/trade/-components/requestView.ts:169
msgid "Preparing Payment"
msgstr "Preparing Payment"

#: src/routes/_authenticated/trade/-components/requestView.ts:167
msgid "Preparing Wire Payment"
msgstr "Preparing Wire Payment"

#: src/routes/_authenticated/trade/withdraw/products/signature.tsx:44
msgid "Preparing your withdrawal document"
msgstr "Preparing your withdrawal document"

#: src/routes/_authenticated/trade/-components/ShipMetal/ShipMetalForm.tsx:259
msgid "Preview Packing Slip"
msgstr "Preview Packing Slip"

#: src/shared/components/Footer.tsx:50
#: src/shared/components/Footer.tsx:52
msgid "Prices displayed reflect latest PM London Fix"
msgstr "Prices displayed reflect latest PM London Fix"

#: src/routes/_authenticated/trade/-components/Withdrawal/ShippingScreen.tsx:222
#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:104
#~ msgid "Priority"
#~ msgstr "Priority"

#: src/routes/_authenticated/trade/-components/Withdrawal/ShippingScreen.tsx:222
#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:105
#~ msgid "Priority (next morning)"
#~ msgstr "Priority (next morning)"

#: src/shared/components/Footer.tsx:43
msgid "Privacy Policy"
msgstr "Privacy Policy"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:108
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:82
msgid "Private foundation"
msgstr "Private foundation"

#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:578
msgid "Proceed"
msgstr "Proceed"

#: src/components/Trade/RequestStatus.tsx:283
#~ msgid "Proceeds"
#~ msgstr "Proceeds"

#: src/routes/_authenticated/trade/-components/PendingTransaction.tsx:92
#~ msgid "Processing {eftType}"
#~ msgstr "Processing {eftType}"

#: src/routes/_authenticated/trade/-components/requestView.ts:161
msgid "Processing ACH"
msgstr "Processing ACH"

#: src/routes/_authenticated/trade/-components/requestView.ts:161
msgid "Processing Wire"
msgstr "Processing Wire"

#: src/routes/_authenticated/trade/withdraw/products/review.tsx:33
msgid "product"
msgstr "product"

#: src/routes/_authenticated/balance/premiums.tsx:178
#: src/routes/_authenticated/trade/-components/ShipMetal/PackingSlipReview.tsx:35
#: src/routes/_authenticated/trade/-components/ShipMetal/ShipMetalForm.tsx:165
#: src/routes/_authenticated/trade/-components/ShipMetal/ShipMetalForm.tsx:205
#: src/routes/_authenticated/trade/-components/VaultTransfer.tsx:186
#: src/routes/_authenticated/trade/-components/VaultTransfer.tsx:283
#: src/routes/_authenticated/trade/-components/Withdrawal/SelectedProductsTable.tsx:64
#: src/routes/_authenticated/trade/withdraw/products/index.tsx:154
msgid "Product"
msgstr "Product"

#: src/routes/_authenticated/trade/withdraw/products/review.tsx:33
msgid "products"
msgstr "products"

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:336
#: src/routes/_authenticated/trade/withdraw/index.tsx:21
msgid "Products"
msgstr "Products"

#: src/routes/_authenticated/trade/withdraw/products/index.tsx:116
msgid "Products to withdraw"
msgstr "Products to withdraw"

#: src/routes/_authenticated/settings.tsx:24
msgid "Profile"
msgstr "Profile"

#: src/routes/_authenticated/onboarding/-components/Signatory2ReviewAndSign.tsx:73
msgid "Proof of Address"
msgstr "Proof of Address"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:734
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:809
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:885
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:961
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/foreignCorpDocs.ts:136
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/foreignCorpDocs.ts:172
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/foreignCorpDocs.ts:208
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/foreignCorpDocs.ts:244
msgid "Proof of address (e.g., utility bill, bank statement)"
msgstr "Proof of address (e.g., utility bill, bank statement)"

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:637
msgid "Protect your metal before you withdraw"
msgstr "Protect your metal before you withdraw"

#: src/routes/_authenticated/trade.tsx:27
#: src/routes/_authenticated/trade/-components/Purchase/PurchaseLayout.tsx:47
msgid "Purchase"
msgstr "Purchase"

#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:497
msgid "Purchase Amount"
msgstr "Purchase Amount"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/NewScheduleForm.tsx:111
msgid "Purchase Days"
msgstr "Purchase Days"

#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:131
#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:153
msgid "Purchase Gold"
msgstr "Purchase Gold"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/clientFunding.tsx:31
msgid "Purchase metal"
msgstr "Purchase metal"

#: src/routes/_authenticated/balance/index.tsx:46
#: src/routes/_authenticated/trade/-components/PendingTransactions.tsx:52
msgid "Purchase Metal"
msgstr "Purchase Metal"

#: src/routes/_authenticated/trade/-components/PendingTransaction.tsx:160
msgid "Purchase Order"
msgstr "Purchase Order"

#: src/routes/_authenticated/trade/-components/RequestStatus.tsx:171
msgid "Purchase order status"
msgstr "Purchase order status"

#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:595
msgid "Purchase request submitted successfully."
msgstr "Purchase request submitted successfully."

#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:139
#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:161
msgid "Purchase Silver"
msgstr "Purchase Silver"

#: src/shared/components/payment-methods/ManagePaymentMethods.tsx:76
msgid "Purchases & withdrawals"
msgstr "Purchases & withdrawals"

#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:687
msgid "Purchases by ounce are processed manually. Our accounts team will contact you with your order confirmation and payment instructions."
msgstr "Purchases by ounce are processed manually. Our accounts team will contact you with your order confirmation and payment instructions."

#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:188
msgid "Purchases by ounce are processed manually. You will receive payment instructions after submitting your order."
msgstr "Purchases by ounce are processed manually. You will receive payment instructions after submitting your order."

#: src/shared/components/payment-methods/ManagePaymentMethods.tsx:81
msgid "Purchases only"
msgstr "Purchases only"

#: src/routes/_authenticated/trade/-components/requestView.ts:163
msgid "Purchasing Metal"
msgstr "Purchasing Metal"

#: src/routes/_authenticated/trade/-components/Withdrawal/SelectedProductsTable.tsx:65
msgid "Qty"
msgstr "Qty"

#: src/routes/_authenticated/trade/-components/ShipMetal/PackingSlipReview.tsx:36
#: src/routes/_authenticated/trade/-components/ShipMetal/ShipMetalForm.tsx:185
#: src/routes/_authenticated/trade/-components/ShipMetal/ShipMetalForm.tsx:206
#: src/routes/_authenticated/trade/-components/VaultTransfer.tsx:187
#: src/routes/_authenticated/trade/-components/VaultTransfer.tsx:304
#: src/routes/_authenticated/trade/withdraw/products/index.tsx:165
msgid "Quantity"
msgstr "Quantity"

#. placeholder {0}: draft.productName ?? metalLabel(draft.metal)
#: src/routes/_authenticated/trade/withdraw/products/index.tsx:169
msgid "Quantity of {0} products"
msgstr "Quantity of {0} products"

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:524
msgid "Quantity to sell"
msgstr "Quantity to sell"

#: src/routes/_authenticated/yield/-components/YieldTable.tsx:146
msgid "Rate"
msgstr "Rate"

#. placeholder {0}: toPercent(opportunity.net_rate)
#: src/routes/_authenticated/opportunities/-components/Opportunity.tsx:299
msgid "Rate {0}"
msgstr "Rate {0}"

#: src/routes/_authenticated/trade/withdraw/index.tsx:22
msgid "Receive physical metal as coins or bars."
msgstr "Receive physical metal as coins or bars."

#: src/shared/components/NotificationsDropdown.tsx:26
msgid "Recent Notifications"
msgstr "Recent Notifications"

#: src/shared/components/ActivityView.tsx:282
msgid "Recent statement activity for your account."
msgstr "Recent statement activity for your account."

#: src/routes/_authenticated/trade.tsx:57
#: src/routes/_authenticated/trade/-components/PendingTransactions.tsx:61
#: src/routes/_authenticated/trade/withdraw/index.tsx:34
msgid "Recent Transactions"
msgstr "Recent Transactions"

#: src/routes/_authenticated/trade/withdraw/cash/review.tsx:122
msgid "Recipient Bank"
msgstr "Recipient Bank"

#: src/routes/_authenticated/trade/-components/Purchase/PurchaseLayout.tsx:61
msgid "Recurring"
msgstr "Recurring"

#: src/routes/_authenticated/trade/-components/Purchase/PurchaseLayout.tsx:60
#: src/routes/_authenticated/trade/-components/Purchase/Recurring/RecurringPurchases.tsx:460
msgid "Recurring Purchases"
msgstr "Recurring Purchases"

#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:370
msgid "Recurring purchases are available after you have funded your account and do not require the {formattedMinAmount} minimum. After completing your first purchase, you can set up a recurring purchase schedule from the Recurring Purchases page."
msgstr "Recurring purchases are available after you have funded your account and do not require the {formattedMinAmount} minimum. After completing your first purchase, you can set up a recurring purchase schedule from the Recurring Purchases page."

#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:369
msgid "Recurring purchases are available and do not require the {formattedMinAmount} minimum. You can set up a recurring purchase schedule from the Recurring Purchases page."
msgstr "Recurring purchases are available and do not require the {formattedMinAmount} minimum. You can set up a recurring purchase schedule from the Recurring Purchases page."

#: src/routes/_authenticated/trade/withdraw/products/index.tsx:202
msgid "Reduce quantities to stay within your available metal."
msgstr "Reduce quantities to stay within your available metal."

#. placeholder {0}: formatCurrency(inputs.limits.maximum)
#: src/routes/_authenticated/trade/withdraw/cash/index.tsx:44
msgid "Reduce your sale to {0} or less. Contact Client Relations for a larger withdrawal."
msgstr "Reduce your sale to {0} or less. Contact Client Relations for a larger withdrawal."

#: src/routes/_authenticated/trade/-components/RequestStatus.tsx:141
msgid "Reference"
msgstr "Reference"

#: src/routes/_authenticated/referrals/-components/ReferralMetrics.tsx:43
msgid "Referral Activity"
msgstr "Referral Activity"

#: src/routes/_authenticated/referrals.tsx:112
#: src/routes/_authenticated/referrals/-components/ReferralInviteModal.tsx:114
msgid "Referral Code"
msgstr "Referral Code"

#: src/routes/_authenticated/referrals/-components/ReferralEarningsChartContainer.tsx:49
msgid "Referral Earnings Over Time"
msgstr "Referral Earnings Over Time"

#: src/routes/_authenticated/referrals.tsx:126
msgid "Referral Link"
msgstr "Referral Link"

#: src/routes/_authenticated/referrals.tsx:97
msgid "Referral Program"
msgstr "Referral Program"

#: src/routes/_authenticated/referrals/-components/ReferralTermsOfService.tsx:77
msgid "Referral Program Terms of Service"
msgstr "Referral Program Terms of Service"

#: src/routes/_authenticated/referrals.tsx:148
msgid "Referral Rewards"
msgstr "Referral Rewards"

#: src/shared/components/MainNavContainer.tsx:51
msgid "Referrals"
msgstr "Referrals"

#: src/shared/components/ErrorPage.tsx:28
#: src/shared/components/route-state/StaleContentFallback.tsx:47
msgid "Refresh"
msgstr "Refresh"

#: src/shared/components/route-state/StaleContentFallback.tsx:45
msgid "Refresh your page to continue your session and see the most up to date content."
msgstr "Refresh your page to continue your session and see the most up to date content."

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:100
msgid "Relationship"
msgstr "Relationship"

#: src/routes/_authenticated/opportunities/-components/ReviewPeriodAlert.tsx:85
msgid "remaining"
msgstr "remaining"

#: src/shared/components/payment-methods/ManagePaymentMethods.tsx:97
#: src/shared/components/payment-methods/ManagePaymentMethods.tsx:119
msgid "Remove"
msgstr "Remove"

#: src/routes/_authenticated/trade/-components/VaultTransfer.tsx:345
#: src/routes/_authenticated/trade/-components/VaultTransfer.tsx:348
msgid "Remove Metal"
msgstr "Remove Metal"

#: src/shared/components/payment-methods/ManagePaymentMethods.tsx:104
msgid "Remove Payment Method"
msgstr "Remove Payment Method"

#: src/routes/_authenticated/trade/withdraw/products/index.tsx:146
msgid "Remove product"
msgstr "Remove product"

#: src/shared/components/ErrorPage.tsx:41
#: src/shared/components/FeedbackDialogPrompt.tsx:25
msgid "Report Issue"
msgstr "Report Issue"

#: src/routes/_authenticated/trade/-components/RequestStatus.tsx:217
msgid "Request details"
msgstr "Request details"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:213
msgid "Required for tax purposes. Your information is encrypted and securely stored."
msgstr "Required for tax purposes. Your information is encrypted and securely stored."

#: src/routes/_unauthenticated/-components/ResetPassword.tsx:103
msgid "Resend Code"
msgstr "Resend Code"

#: src/routes/_unauthenticated/-components/EmailVerification.tsx:88
msgid "Resend Verification Code"
msgstr "Resend Verification Code"

#: src/routes/_unauthenticated/-components/ResetPassword.tsx:102
msgid "Resending"
msgstr "Resending"

#: src/routes/_authenticated/opportunities/-components/LeasesPageControls.tsx:96
msgid "Reset"
msgstr "Reset"

#: src/routes/_unauthenticated/-components/NewPassword.tsx:57
#: src/routes/_unauthenticated/-components/ResetPassword.tsx:73
msgid "Reset Password"
msgstr "Reset Password"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/RecurringPurchases.tsx:253
msgid "Resume Purchases"
msgstr "Resume Purchases"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/RecurringPurchases.tsx:261
msgid "Resume Recurring Purchases"
msgstr "Resume Recurring Purchases"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/RecurringPurchases.tsx:404
msgid "Resume Schedule"
msgstr "Resume Schedule"

#: src/routes/_authenticated/trade/-components/PendingTransaction.tsx:93
#: src/routes/_authenticated/trade/-components/PendingTransactions.tsx:40
#: src/shared/components/Authenticator.tsx:161
#: src/shared/components/payment-methods/ManagePaymentMethods.tsx:172
#: src/shared/components/route-state/ApiErrorBoundary.tsx:96
#: src/shared/components/route-state/AuthenticatedErrorBoundary.tsx:51
msgid "Retry"
msgstr "Retry"

#: src/routes/_authenticated/opportunities/-components/LeasesPageControls.tsx:28
msgid "Review"
msgstr "Review"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/clientInfo.ts:76
msgid "Review and Sign"
msgstr "Review and Sign"

#: src/routes/_authenticated/trade/withdraw/cash/review.tsx:113
#~ msgid "Review and submit"
#~ msgstr "Review and submit"

#: src/routes/_authenticated/yield.tsx:47
msgid "Review Available Leases"
msgstr "Review Available Leases"

#: src/routes/_authenticated/trade/withdraw/products/review.tsx:26
msgid "Review your products and delivery details before submitting."
msgstr "Review your products and delivery details before submitting."

#: src/routes/_authenticated/trade/withdraw/products/review.tsx:20
msgid "Review your products and delivery details."
msgstr "Review your products and delivery details."

#: src/routes/_authenticated/trade/withdraw/cash/review.tsx:113
msgid "Review your withdrawal request."
msgstr "Review your withdrawal request."

#: src/routes/_authenticated/opportunities/-components/LeasesPageControls.tsx:33
#: src/routes/_authenticated/opportunities/-components/Opportunity.tsx:272
msgid "Reviewed"
msgstr "Reviewed"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:105
msgid "Revocable"
msgstr "Revocable"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:95
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:69
msgid "Revocable Trust"
msgstr "Revocable Trust"

#: src/shared/components/AchFormSection.tsx:58
msgid "Routing Number"
msgstr "Routing Number"

#: src/routes/_authenticated/trade/-components/RequestStatus.tsx:113
msgid "Routing Number (ABA)"
msgstr "Routing Number (ABA)"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:99
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:73
msgid "S Corporation"
msgstr "S Corporation"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:232
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:256
msgid "S-Corp"
msgstr "S-Corp"

#: src/shared/components/payment-methods/ManualAchForm.tsx:69
msgid "Save Payment"
msgstr "Save Payment"

#: src/shared/components/payment-methods/WireFormSection.tsx:33
msgid "Save payment method for future transactions"
msgstr "Save payment method for future transactions"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/NewScheduleForm.tsx:59
msgid "Save Purchase Schedule Changes"
msgstr "Save Purchase Schedule Changes"

#: src/shared/components/payment-methods/UpgradePaymentMethodDialog.tsx:178
msgid "Saved account"
msgstr "Saved account"

#: src/routes/_authenticated/settings/-components/ManageCookiesForm.tsx:38
msgid "Saving Preferences..."
msgstr "Saving Preferences..."

#: src/shared/components/payment-methods/UpgradePaymentMethodDialog.tsx:225
msgid "Saving…"
msgstr "Saving…"

#: src/shared/components/AchFormSection.tsx:33
#: src/shared/components/payment-methods/ManualAchForm.tsx:43
msgid "Savings"
msgstr "Savings"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/NewScheduleForm.tsx:355
msgid "Schedule Recurring Purchase"
msgstr "Schedule Recurring Purchase"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/NewScheduleForm.tsx:201
msgid "Scheduled for the {daysLabel} of every month"
msgstr "Scheduled for the {daysLabel} of every month"

#: src/shared/components/EmulateUserDialog.tsx:86
msgid "Search by name, email, or account, or enter a Cognito ID to view the portal as that user."
msgstr "Search by name, email, or account, or enter a Cognito ID to view the portal as that user."

#: src/shared/components/EmulateUserDialog.tsx:119
msgid "Search or paste Cognito ID"
msgstr "Search or paste Cognito ID"

#: src/shared/components/payment-methods/PaymentMethodVerification.tsx:64
msgid "Second Deposit Amount"
msgstr "Second Deposit Amount"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:290
msgid "Second signatory information"
msgstr "Second signatory information"

#: src/routes/_authenticated/settings.tsx:29
msgid "Security"
msgstr "Security"

#: src/routes/_authenticated/onboarding/-components/fields/FieldRenderer.tsx:407
msgid "Select"
msgstr "Select"

#: src/routes/_authenticated/trade/withdraw/index.tsx:11
msgid "Select a cash or product withdrawal"
msgstr "Select a cash or product withdrawal"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/RecurringPurchases.tsx:192
msgid "Select a date to resume the schedule."
msgstr "Select a date to resume the schedule."

#: src/routes/_authenticated/documents.tsx:54
msgid "Select a Document Type"
msgstr "Select a Document Type"

#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:380
#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:548
#: src/routes/_authenticated/trade/-components/Purchase/Recurring/NewScheduleForm.tsx:128
msgid "Select a payment method"
msgstr "Select a payment method"

#: src/routes/_authenticated/trade/withdraw/products/index.tsx:187
msgid "Select a product for weight"
msgstr "Select a product for weight"

#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:543
#: src/routes/_authenticated/trade/-components/Purchase/Recurring/NewScheduleForm.tsx:121
msgid "Select a saved payment method"
msgstr "Select a saved payment method"

#: src/routes/_authenticated/settings.tsx:67
msgid "Select a Setting"
msgstr "Select a Setting"

#: src/routes/_authenticated/trade.tsx:88
msgid "Select a Transaction Type"
msgstr "Select a Transaction Type"

#: src/routes/_unauthenticated/-components/SignUp.tsx:235
#: src/routes/_unauthenticated/-components/SignUp.tsx:260
msgid "Select an option"
msgstr "Select an option"

#. placeholder {0}: formatCurrency(inputs.limits.minimum)
#: src/routes/_authenticated/trade/withdraw/cash/index.tsx:39
msgid "Select at least {0}, or withdraw your full available balance if it is below the minimum."
msgstr "Select at least {0}, or withdraw your full available balance if it is below the minimum."

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/EditScheduleForm.tsx:235
#: src/routes/_authenticated/trade/-components/Purchase/Recurring/RecurringPurchases.tsx:198
msgid "Select date"
msgstr "Select date"

#: src/routes/_authenticated/trade/-components/MetalAssetClassSelect.tsx:35
msgid "Select Metal"
msgstr "Select Metal"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/RecurringPurchases.tsx:144
msgid "Select one or more future purchases you would like to skip. Skipped purchases will not be processed."
msgstr "Select one or more future purchases you would like to skip. Skipped purchases will not be processed."

#: src/routes/_authenticated/trade/withdraw/products/index.tsx:119
msgid "Select the coins or bars you want to receive from your storage balance."
msgstr "Select the coins or bars you want to receive from your storage balance."

#: src/routes/_authenticated/trade/withdraw/products/index.tsx:61
msgid "Selected"
msgstr "Selected"

#: src/routes/_authenticated/trade/-components/Withdrawal/SelectedProductsTable.tsx:24
#: src/routes/_authenticated/trade/-components/Withdrawal/SelectedProductsTable.tsx:59
msgid "Selected products"
msgstr "Selected products"

#: src/routes/_authenticated/trade/-components/requestView.ts:182
msgid "Sell {lines}"
msgstr "Sell {lines}"

#: src/routes/_authenticated/trade.tsx:51
#~ msgid "Sell / Withdraw"
#~ msgstr "Sell / Withdraw"

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:450
msgid "Sell all"
msgstr "Sell all"

#: src/routes/_authenticated/trade/withdraw/cash/review.tsx:120
msgid "Sell Metal for Cash"
msgstr "Sell Metal for Cash"

#: src/routes/_authenticated/trade/-components/SellWithdraw.tsx:10
#~ msgid "Sell or withdraw your metal holdings."
#~ msgstr "Sell or withdraw your metal holdings."

#: src/routes/_authenticated/trade/withdraw/index.tsx:16
msgid "Sell your metal and receive funds by wire or ACH."
msgstr "Sell your metal and receive funds by wire or ACH."

#: src/routes/_unauthenticated/-components/ForgotPassword.tsx:46
msgid "Send Code"
msgstr "Send Code"

#: src/routes/_authenticated/referrals.tsx:141
#: src/routes/_authenticated/referrals/-components/ReferralInviteModal.tsx:121
msgid "Send Invite"
msgstr "Send Invite"

#: src/routes/_authenticated/trade/-components/SendMetal.tsx:13
msgid "Send metal to Monetary Metals to deploy in the Yield program."
msgstr "Send metal to Monetary Metals to deploy in the Yield program."

#: src/components/Trade/RequestStatus.tsx:79
#~ msgid "Send your funds using the instructions below."
#~ msgstr "Send your funds using the instructions below."

#: src/routes/_unauthenticated/-components/ForgotPassword.tsx:45
msgid "Sending"
msgstr "Sending"

#: src/routes/_authenticated/opportunities/-components/Opportunity.tsx:253
msgid "Set Desired Allocation"
msgstr "Set Desired Allocation"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/EditScheduleForm.tsx:184
#: src/routes/_authenticated/trade/-components/Purchase/Recurring/NewScheduleForm.tsx:356
msgid "Set up a monthly recurring purchase with your preferred payment method."
msgstr "Set up a monthly recurring purchase with your preferred payment method."

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:643
msgid "Set up two-factor authentication"
msgstr "Set up two-factor authentication"

#: src/shared/components/MFASetup.tsx:104
msgid "Set Up Two-Factor Authentication"
msgstr "Set Up Two-Factor Authentication"

#. placeholder {0}: opportunity.xdescr
#: src/routes/_authenticated/opportunities/-components/Opportunity.tsx:476
msgid "Set your desired allocation for {0}."
msgstr "Set your desired allocation for {0}."

#: src/routes/_authenticated/referrals/-components/ReferralInviteModal.tsx:92
msgid "Share Monetary Metals with your friends and help them get started!"
msgstr "Share Monetary Metals with your friends and help them get started!"

#: src/routes/_authenticated/referrals.tsx:106
msgid "Share your code or link with friends"
msgstr "Share your code or link with friends"

#: src/routes/_authenticated/trade/-components/SendMetal.tsx:27
msgid "Ship from Other Location"
msgstr "Ship from Other Location"

#: src/routes/_authenticated/trade/-components/SendMetal.tsx:19
msgid "Ship from US Location"
msgstr "Ship from US Location"

#: src/routes/_authenticated/trade/-components/ShipMetal/ShipMetalLayout.tsx:9
msgid "Ship Metal To Monetary Metals Vault"
msgstr "Ship Metal To Monetary Metals Vault"

#: src/routes/_authenticated/trade.tsx:33
msgid "Ship To Vault"
msgstr "Ship To Vault"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/clientFunding.tsx:35
msgid "Ship/transfer metal"
msgstr "Ship/transfer metal"

#. placeholder {0}: shipToVaultConstants?.["gold"]?.min ?? 0
#: src/routes/_authenticated/trade/-components/ShipMetal/ShipMetalForm.tsx:254
msgid "Shipment cannot be submitted. Minimum required: {0} oz Gold."
msgstr "Shipment cannot be submitted. Minimum required: {0} oz Gold."

#: src/routes/_authenticated/trade/-components/ShipMetal/ShipMetalForm.tsx:250
msgid "Shipment requires approval"
msgstr "Shipment requires approval"

#: src/routes/_authenticated/trade/-components/ShipMetal/PackingSlipReview.tsx:28
msgid "Shipment Summary"
msgstr "Shipment Summary"

#: src/routes/_authenticated/trade/-components/ShipMetal/ShipMetalForm.tsx:250
msgid "Shipment too small to submit"
msgstr "Shipment too small to submit"

#: src/routes/_authenticated/trade/-components/Withdrawal/ShippingScreen.tsx:67
#: src/routes/_authenticated/trade/withdraw/products/review.tsx:42
#: src/routes/_authenticated/trade/withdraw/products/signature.tsx:185
msgid "Shipping address"
msgstr "Shipping address"

#: src/routes/_authenticated/trade/withdraw/products/review.tsx:58
#~ msgid "Shipping and insurance are confirmed by Client Relations before fulfillment."
#~ msgstr "Shipping and insurance are confirmed by Client Relations before fulfillment."

#: src/routes/_authenticated/trade/-components/Withdrawal/ShippingScreen.tsx:215
#~ msgid "Shipping cost is deducted from your metal."
#~ msgstr "Shipping cost is deducted from your metal."

#: src/routes/_authenticated/trade/-components/Withdrawal/ShippingScreen.tsx:214
#: src/routes/_authenticated/trade/withdraw/products/review.tsx:54
#: src/routes/_authenticated/trade/withdraw/products/signature.tsx:186
#~ msgid "Shipping method"
#~ msgstr "Shipping method"

#: src/routes/_authenticated/referrals/-components/ReferralEarningsChartContainer.tsx:63
msgid "Show Chart"
msgstr "Show Chart"

#: src/shared/components/InterestEarnedChartContainer.tsx:151
msgid "Show Less"
msgstr "Show Less"

#: src/shared/components/InterestEarnedChartContainer.tsx:151
msgid "Show More"
msgstr "Show More"

#: src/routes/_authenticated/trade/withdraw/products/signature.tsx:202
#~ msgid "Sign and submit"
#~ msgstr "Sign and submit"

#: src/routes/_unauthenticated/-components/SignIn.tsx:149
msgid "Sign In"
msgstr "Sign In"

#: src/shared/components/payment-methods/UpgradePaymentMethodDialog.tsx:185
msgid "Sign in to your bank through Plaid and select this account. We'll check that it matches before making any changes."
msgstr "Sign in to your bank through Plaid and select this account. We'll check that it matches before making any changes."

#: src/routes/_unauthenticated/-components/SignIn.tsx:166
msgid "Sign up today"
msgstr "Sign up today"

#: src/routes/_authenticated/trade/withdraw/products/signature.tsx:188
msgid "Sign your withdrawal document, then verify to submit your request."
msgstr "Sign your withdrawal document, then verify to submit your request."

#: src/routes/_authenticated/onboarding/-components/config/secondarySignatory/secondarySignatory.ts:12
msgid "Signatory 2 Details"
msgstr "Signatory 2 Details"

#: src/routes/_authenticated/onboarding/-components/config/secondarySignatory/secondarySignatory.ts:18
msgid "Signatory 2 Review and Sign"
msgstr "Signatory 2 Review and Sign"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfoJointOwnerInfo.ts:16
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:179
msgid "Signatory authorization"
msgstr "Signatory authorization"

#: src/routes/_unauthenticated/-components/SignIn.tsx:144
msgid "Signing In"
msgstr "Signing In"

#: src/routes/_authenticated/balance/-components/BalanceOverviewCard.tsx:28
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/clientFunding.tsx:57
#: src/routes/_authenticated/opportunities/-components/LeasesPageControls.tsx:38
#: src/routes/_authenticated/yield/-components/YieldCard.tsx:26
#: src/shared/components/Header.tsx:40
#: src/shared/components/MetalPageControls.tsx:29
#: src/util/assetLabels.ts:18
msgid "Silver"
msgstr "Silver"

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:127
#: src/routes/_authenticated/trade/-components/Purchase/Recurring/NewScheduleForm.tsx:104
msgid "Silver Amount"
msgstr "Silver Amount"

#: src/shared/components/ActivityView.tsx:41
msgid "Since {sinceMonthYear}"
msgstr "Since {sinceMonthYear}"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:97
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:71
msgid "Single Member LLC"
msgstr "Single Member LLC"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/RecurringPurchases.tsx:401
msgid "Skip Dates"
msgstr "Skip Dates"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/RecurringPurchases.tsx:143
msgid "Skip Future Purchases"
msgstr "Skip Future Purchases"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/RecurringPurchases.tsx:155
msgid "Skip Purchases"
msgstr "Skip Purchases"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/EditScheduleForm.tsx:198
msgid "Skipped Dates"
msgstr "Skipped Dates"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:212
msgid "Social security number"
msgstr "Social security number"

#: src/GenericErrorPage.tsx:15
msgid "Something Went Wrong"
msgstr "Something Went Wrong"

#: src/routes/_authenticated/spreads.tsx:37
msgid "Spread"
msgstr "Spread"

#: src/routes/_authenticated/spreads.tsx:29
#: src/shared/components/Footer.tsx:45
msgid "Spreads"
msgstr "Spreads"

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:59
#: src/routes/_authenticated/onboarding/-components/Signatory2ReviewAndSign.tsx:67
msgid "SSN"
msgstr "SSN"

#: src/routes/_authenticated/settings/-components/StartOnboarding.tsx:34
msgid "Start Account Onboarding"
msgstr "Start Account Onboarding"

#: src/routes/_authenticated/settings/-components/StartOnboarding.tsx:31
msgid "Start the process to set up a new account in your Goldmine portfolio. This will guide you through collecting the necessary information and documentation."
msgstr "Start the process to set up a new account in your Goldmine portfolio. This will guide you through collecting the necessary information and documentation."

#: src/routes/_authenticated/settings/-components/StartOnboarding.tsx:34
msgid "Starting..."
msgstr "Starting..."

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:81
#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:91
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:395
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:473
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:291
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:362
#: src/routes/_authenticated/onboarding/-components/config/secondarySignatory/sections/signatory2Details.ts:69
#: src/routes/_authenticated/onboarding/-components/Signatory2ReviewAndSign.tsx:55
msgid "State"
msgstr "State"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:243
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:309
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:516
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:638
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:759
#: src/routes/_authenticated/trade/-components/Withdrawal/ShippingScreen.tsx:165
msgid "State or province"
msgstr "State or province"

#: src/routes/_authenticated/documents.tsx:23
#: src/routes/_authenticated/documents/statement.tsx:61
msgid "Statements"
msgstr "Statements"

#: src/routes/_authenticated/opportunities/-components/LeasesPageControls.tsx:27
msgid "Status"
msgstr "Status"

#. placeholder {0}: step.index
#. placeholder {1}: step.total
#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:268
msgid "Step {0} of {1}"
msgstr "Step {0} of {1}"

#: src/shared/components/route-state/AuthenticatedErrorBoundary.tsx:58
msgid "Stop Viewing as User"
msgstr "Stop Viewing as User"

#: src/routes/_authenticated/balance/-components/balancePayloadGenerators.tsx:27
msgid "Storage Account"
msgstr "Storage Account"

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:79
#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:89
#: src/routes/_authenticated/onboarding/-components/Signatory2ReviewAndSign.tsx:53
msgid "Street"
msgstr "Street"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:373
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:445
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:225
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:287
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:269
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:340
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:499
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:621
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:742
#: src/routes/_authenticated/onboarding/-components/config/secondarySignatory/sections/signatory2Details.ts:59
#: src/routes/_authenticated/trade/-components/Withdrawal/ShippingScreen.tsx:137
msgid "Street address"
msgstr "Street address"

#: src/routes/_authenticated/trade/-components/RequestStatus.tsx:109
msgid "Street Address"
msgstr "Street Address"

#: src/routes/_authenticated/opportunities/-components/Opportunity.tsx:519
#: src/routes/_authenticated/referrals/-components/ReferralTermsOfService.tsx:90
#: src/routes/_unauthenticated/-components/ConfirmSignIn.tsx:53
#: src/routes/_unauthenticated/-components/EmailVerification.tsx:85
#: src/routes/_unauthenticated/-components/NewPassword.tsx:77
#: src/routes/_unauthenticated/-components/RecoveryCode.tsx:54
#: src/routes/_unauthenticated/-components/ResetPassword.tsx:100
#: src/routes/_unauthenticated/-components/SignUp.tsx:365
#: src/shared/components/FeedbackDialogPrompt.tsx:35
msgid "Submit"
msgstr "Submit"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/NewScheduleForm.tsx:69
msgid "Submit Changes"
msgstr "Submit Changes"

#: src/routes/_authenticated/trade/-components/VaultTransfer.tsx:218
msgid "Submit Transfer"
msgstr "Submit Transfer"

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalReview.tsx:246
msgid "Submit Withdrawal"
msgstr "Submit Withdrawal"

#. placeholder {0}: formatDateLong(view.submittedAt)
#: src/routes/_authenticated/trade/-components/RequestStatus.tsx:174
msgid "Submitted {0}"
msgstr "Submitted {0}"

#: src/routes/_unauthenticated/-components/ConfirmSignIn.tsx:52
#: src/routes/_unauthenticated/-components/EmailVerification.tsx:84
#: src/routes/_unauthenticated/-components/NewPassword.tsx:76
#: src/routes/_unauthenticated/-components/ResetPassword.tsx:99
#: src/routes/_unauthenticated/-components/SignUp.tsx:364
msgid "Submitting"
msgstr "Submitting"

#: src/routes/_authenticated/opportunities/-components/Opportunity.tsx:519
msgid "Submitting..."
msgstr "Submitting..."

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalReview.tsx:168
#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalReview.tsx:244
msgid "Submitting…"
msgstr "Submitting…"

#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:197
#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:680
msgid "Subtotal"
msgstr "Subtotal"

#: src/routes/_authenticated/referrals/-components/ReferralMetrics.tsx:61
msgid "Successfully Funded"
msgstr "Successfully Funded"

#: src/routes/_authenticated/trade/-components/RequestStatus.tsx:121
msgid "SWIFT Code"
msgstr "SWIFT Code"

#: src/routes/_authenticated/trade/-components/PendingTransaction.tsx:368
#~ msgid "Task {0}:"
#~ msgstr "Task {0}:"

#: src/routes/_authenticated/trade/-components/PendingTransaction.tsx:254
#~ msgid "Task ID: {0}"
#~ msgstr "Task ID: {0}"

#: src/routes/_authenticated/trade/-components/RequestStatus.tsx:146
msgid "Task ID: {taskId}"
msgstr "Task ID: {taskId}"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:492
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:614
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:735
msgid "Tax ID number"
msgstr "Tax ID number"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:147
msgid "Tax ID of the trust"
msgstr "Tax ID of the trust"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:178
msgid "Tax identification number (non-US)"
msgstr "Tax identification number (non-US)"

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:61
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:207
#: src/routes/_authenticated/onboarding/-components/Signatory2ReviewAndSign.tsx:66
msgid "Tax Identification Number (non-US)"
msgstr "Tax Identification Number (non-US)"

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:70
msgid "Tax Treaty Country"
msgstr "Tax Treaty Country"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:107
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:81
msgid "Tax-exempt organization"
msgstr "Tax-exempt organization"

#: src/shared/components/Footer.tsx:40
msgid "Terms and Conditions"
msgstr "Terms and Conditions"

#: src/shared/components/FeedbackDialogResponse.tsx:20
msgid "Thank you for reporting this issue. We'll investigate and fix it as soon as possible."
msgstr "Thank you for reporting this issue. We'll investigate and fix it as soon as possible."

#: src/shared/components/FeedbackDialogResponse.tsx:21
msgid "Thank you for your feedback. We appreciate you taking the time to help us improve."
msgstr "Thank you for your feedback. We appreciate you taking the time to help us improve."

#: src/routes/_authenticated/trade/withdraw/products/signature.tsx:215
msgid "Thank you for your submission, a member of our customer support team will reach out from accounts@monetary-metals.com to provide you with a quote for the products selected. You have the opportunity to review and finalize those details before your products are sent."
msgstr "Thank you for your submission, a member of our customer support team will reach out from accounts@monetary-metals.com to provide you with a quote for the products selected. You have the opportunity to review and finalize those details before your products are sent."

#: src/routes/_authenticated/opportunities/-components/ReviewPeriodAlert.tsx:97
msgid "The Account in Review period is an initial two-week window during which you can review and adjust your preferences regarding the active and available leases in the Monetary Metals marketplace. After two weeks, or once you have clicked the \"Finalize My Choices\" button, your metal will be made available for all active leases—except the ones you have opted out of. You will not be able to change these selections again until each lease matures and is renewed.<0/><1/>You're welcome to <2>schedule a call with a Relationship Manager</2> if you have questions.<3/><4/><5>NOTE: When a new lease is being offered during your account review stage, if you'd like to participate, you will need to hit the \"Finalize My Choices\" button before the new lease closes.</5>"
msgstr "The Account in Review period is an initial two-week window during which you can review and adjust your preferences regarding the active and available leases in the Monetary Metals marketplace. After two weeks, or once you have clicked the \"Finalize My Choices\" button, your metal will be made available for all active leases—except the ones you have opted out of. You will not be able to change these selections again until each lease matures and is renewed.<0/><1/>You're welcome to <2>schedule a call with a Relationship Manager</2> if you have questions.<3/><4/><5>NOTE: When a new lease is being offered during your account review stage, if you'd like to participate, you will need to hit the \"Finalize My Choices\" button before the new lease closes.</5>"

#: src/routes/_authenticated/onboarding/-components/config/secondarySignatory/sections/signatory2Details.ts:37
msgid "The address provided for the account is:"
msgstr "The address provided for the account is:"

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalReview.tsx:84
msgid "The authenticator code is invalid or expired. Try a new code."
msgstr "The authenticator code is invalid or expired. Try a new code."

#: src/shared/components/payment-methods/UpgradePaymentMethodDialog.tsx:209
msgid "The bank connection didn't finish. Try again when you're ready."
msgstr "The bank connection didn't finish. Try again when you're ready."

#: src/shared/components/payment-methods/UpgradePaymentMethodDialog.tsx:132
msgid "The connected bank account matches your saved account."
msgstr "The connected bank account matches your saved account."

#. placeholder {0}: formatCurrency(defaultMin, { maximumFractionDigits: 0 })
#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:574
msgid "The minimum cash purchase is now just {0}."
msgstr "The minimum cash purchase is now just {0}."

#: src/routes/_unauthenticated/-components/SignUp.tsx:251
msgid "The minimum to open a Monetary Metals account is $30,000, or 10 ounces of gold, or 1,000 ounces of silver."
msgstr "The minimum to open a Monetary Metals account is $30,000, or 10 ounces of gold, or 1,000 ounces of silver."

#: src/shared/components/payment-methods/PaymentMethodVerification.tsx:66
msgid "The order of the deposits does not matter."
msgstr "The order of the deposits does not matter."

#: src/shared/components/AuthenticatedLayout.tsx:16
msgid "The site is currently under maintenance. We will be back soon!"
msgstr "The site is currently under maintenance. We will be back soon!"

#: src/routes/_authenticated/documents/notification.tsx:31
msgid "There are no notifications available."
msgstr "There are no notifications available."

#: src/routes/_authenticated/opportunities/index.tsx:58
msgid "There are no opportunities available at this time."
msgstr "There are no opportunities available at this time."

#: src/shared/components/ActivityView.tsx:203
msgid "There is no account activity for this date range."
msgstr "There is no account activity for this date range."

#: src/shared/components/ActivityView.tsx:203
msgid "There is no account activity yet."
msgstr "There is no account activity yet."

#: src/shared/components/InterestEarnedChart.tsx:66
msgid "There is no interest earned to show for your current filters. Adjust your filter settings or check back soon."
msgstr "There is no interest earned to show for your current filters. Adjust your filter settings or check back soon."

#: src/routes/_authenticated/trade/-components/Withdrawal/ShippingScreen.tsx:90
msgid "There is no shipping address on file. Enter an address for this withdrawal."
msgstr "There is no shipping address on file. Enter an address for this withdrawal."

#: src/routes/_authenticated/settings/-components/ManageCookiesForm.tsx:22
#: src/shared/components/CookiesConsentBanner.tsx:37
msgid "There was an error saving your cookie preferences. Please try again later."
msgstr "There was an error saving your cookie preferences. Please try again later."

#: src/routes/_authenticated/trade/-components/VaultTransfer.tsx:143
msgid "There was an error sending the confirmation email to your relationship manager. Please try again later or reach out to them directly."
msgstr "There was an error sending the confirmation email to your relationship manager. Please try again later or reach out to them directly."

#: src/routes/_authenticated/referrals/-components/ReferralInviteModal.tsx:71
msgid "There was an error sending your invite"
msgstr "There was an error sending your invite"

#: src/shared/components/FeedbackDialogResponse.tsx:18
msgid "There was an error submitting your feedback. Please try again later."
msgstr "There was an error submitting your feedback. Please try again later."

#: src/routes/_authenticated/documents/-components/Notification.tsx:29
#: src/shared/components/Notification.tsx:33
msgid "There was an issue archiving the notification. Please try again later."
msgstr "There was an issue archiving the notification. Please try again later."

#: src/shared/components/payment-methods/AddPaymentMethodDialog.tsx:109
#: src/shared/components/payment-methods/FinalizePlaidPaymentMethod.tsx:38
#: src/shared/components/payment-methods/PlaidOAuthCallback.tsx:85
msgid "There was an issue linking your payment method. Please try again later or contact your RM if the problem persists."
msgstr "There was an issue linking your payment method. Please try again later or contact your RM if the problem persists."

#: src/routes/_authenticated/yield.tsx:100
msgid "There was an issue loading your investments. Please try again later or contact your RM if the problem persists."
msgstr "There was an issue loading your investments. Please try again later or contact your RM if the problem persists."

#: src/routes/_authenticated/documents/notification.tsx:22
msgid "There was an issue loading your notifications. Please try again later or contact your RM if the problem persists."
msgstr "There was an issue loading your notifications. Please try again later or contact your RM if the problem persists."

#: src/routes/_authenticated/opportunities/index.tsx:132
msgid "There was an issue loading your opportunities. Please try again later or contact your RM if the problem persists."
msgstr "There was an issue loading your opportunities. Please try again later or contact your RM if the problem persists."

#: src/shared/components/payment-methods/ManagePaymentMethods.tsx:171
msgid "There was an issue loading your payment methods. Please try again later or contact your RM if the problem persists."
msgstr "There was an issue loading your payment methods. Please try again later or contact your RM if the problem persists."

#: src/routes/_authenticated/trade/-components/PendingTransaction.tsx:91
msgid "There was an issue loading your pending transaction. Please try again later or contact your RM if the problem persists."
msgstr "There was an issue loading your pending transaction. Please try again later or contact your RM if the problem persists."

#: src/routes/_authenticated/trade/-components/PendingTransactions.tsx:38
msgid "There was an issue loading your pending transactions. Please try again later or contact your RM if the problem persists."
msgstr "There was an issue loading your pending transactions. Please try again later or contact your RM if the problem persists."

#: src/routes/_authenticated/referrals.tsx:92
msgid "There was an issue loading your referral information. Please try again later or contact your RM if the problem persists."
msgstr "There was an issue loading your referral information. Please try again later or contact your RM if the problem persists."

#: src/shared/components/payment-methods/UpgradePaymentMethodDialog.tsx:134
msgid "This account is now verified through Plaid."
msgstr "This account is now verified through Plaid."

#: src/routes/_authenticated/trade/withdraw/products/signature.tsx:51
msgid "This can take a few seconds. Keep this page open."
msgstr "This can take a few seconds. Keep this page open."

#: src/routes/_authenticated/referrals/-components/ReferralInviteModal.tsx:68
msgid "This email address is already reserved"
msgstr "This email address is already reserved"

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:85
#~ msgid "This estimate reflects the metal value based on product weight and yesterday's PM fix. The final price may be higher or lower depending on the product premium when availability is confirmed."
#~ msgstr "This estimate reflects the metal value based on product weight and yesterday's PM fix. The final price may be higher or lower depending on the product premium when availability is confirmed."

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:83
#~ msgid "This estimate reflects the metal value based on product weight and yesterday's PM Fix. The final price may be higher or lower depending on the product premium when availability is confirmed."
#~ msgstr "This estimate reflects the metal value based on product weight and yesterday's PM Fix. The final price may be higher or lower depending on the product premium when availability is confirmed."

#: src/routes/_authenticated/trade/-components/SellWithdraw.tsx:13
#~ msgid "This feature is coming soon. For assistance, please reach out to Client Relations at"
#~ msgstr "This feature is coming soon. For assistance, please reach out to Client Relations at"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:334
msgid "This information is not required but can be helpful."
msgstr "This information is not required but can be helpful."

#: src/routes/_authenticated/yield/-components/YieldTable.tsx:173
msgid "This investment has restrictions"
msgstr "This investment has restrictions"

#: src/routes/_unauthenticated/-components/SignUp.tsx:228
msgid "This is non-binding and can be changed later"
msgstr "This is non-binding and can be changed later"

#: src/routes/_authenticated/opportunities/unsecured/$leaseInstance.tsx:137
msgid "This lease is no longer available."
msgstr "This lease is no longer available."

#: src/routes/_authenticated/opportunities/-components/Opportunity.tsx:151
msgid "This lease is unallocated"
msgstr "This lease is unallocated"

#: src/routes/_authenticated/balance/-components/BalanceTableContainer.tsx:60
msgid "This rate is subject to change."
msgstr "This rate is subject to change."

#. placeholder {0}: shipToVaultConstants?.["gold"]?.threshold ?? 0
#: src/routes/_authenticated/trade/-components/ShipMetal/ShipMetalForm.tsx:253
msgid "This shipment is below the recommended minimum weight ({0} oz Gold). It will require approval by our Relationship Management team before processing."
msgstr "This shipment is below the recommended minimum weight ({0} oz Gold). It will require approval by our Relationship Management team before processing."

#: src/routes/_authenticated/opportunities/unsecured/$leaseInstance.tsx:151
msgid "This unallocated lease cannot be processed yet because agreement setup is incomplete."
msgstr "This unallocated lease cannot be processed yet because agreement setup is incomplete."

#: src/shared/components/Footer.tsx:55
msgid "This website is copyright 2012-{currentYear} Monetary Metals & Co. All rights reserved. The content on this site is provided as general information and for educational purposes only and should not be taken as investment advice. We do not guarantee the accuracy and/or completeness of the charts, make no express or implied warranties with respect to the completeness of the charts, and shall have no liability for any damages, claims, losses, or expenses caused by errors in calculations we have used to generate the information presented."
msgstr "This website is copyright 2012-{currentYear} Monetary Metals & Co. All rights reserved. The content on this site is provided as general information and for educational purposes only and should not be taken as investment advice. We do not guarantee the accuracy and/or completeness of the charts, make no express or implied warranties with respect to the completeness of the charts, and shall have no liability for any damages, claims, losses, or expenses caused by errors in calculations we have used to generate the information presented."

#: src/shared/components/CookiesConsentBanner.tsx:56
msgid "This website uses cookies"
msgstr "This website uses cookies"

#: src/shared/components/AchFormSection.tsx:77
#: src/shared/components/payment-methods/WireFormSection.tsx:44
msgid "This will be used to identify your payment method in the future."
msgstr "This will be used to identify your payment method in the future."

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalReview.tsx:269
msgid "This withdrawal is already being processed. Check Recent Transactions before you try again."
msgstr "This withdrawal is already being processed. Check Recent Transactions before you try again."

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:653
msgid "Three additional beneficial owners to declare"
msgstr "Three additional beneficial owners to declare"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:417
msgid "Three additional trustees"
msgstr "Three additional trustees"

#: src/routes/_authenticated/spreads.tsx:36
msgid "Tier"
msgstr "Tier"

#: src/shared/components/route-state/ApiErrorBoundary.tsx:86
msgid "To keep things running smoothly for everyone, we pace how quickly requests can be made. Please wait a moment, then refresh to try again."
msgstr "To keep things running smoothly for everyone, we pace how quickly requests can be made. Please wait a moment, then refresh to try again."

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalReview.tsx:81
msgid "Too many verification attempts. Try again later."
msgstr "Too many verification attempts. Try again later."

#: src/routes/_authenticated/balance/-components/BalanceTable.tsx:29
#: src/routes/_authenticated/balance/premiums.tsx:223
#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:196
#: src/routes/_authenticated/trade/-components/RequestStatus.tsx:225
#: src/routes/_authenticated/trade/-components/ShipMetal/ShipMetalForm.tsx:233
#: src/shared/components/MetalPageControls.tsx:19
msgid "Total"
msgstr "Total"

#: src/routes/_authenticated/balance/-components/BalanceOverviewCard.tsx:52
msgid "Total Balances Overview"
msgstr "Total Balances Overview"

#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:200
#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:682
msgid "Total Funds Due"
msgstr "Total Funds Due"

#: src/shared/components/InterestEarnedChartContainer.tsx:124
msgid "Total Interest Earned"
msgstr "Total Interest Earned"

#: src/routes/_authenticated/referrals/-components/ReferralMetrics.tsx:50
msgid "Total number of invites sent via email or referral link."
msgstr "Total number of invites sent via email or referral link."

#: src/routes/_authenticated/referrals/-components/ReferralEarningsChart.tsx:26
#: src/routes/_authenticated/referrals/-components/ReferralEarningsChart.tsx:70
msgid "Total Ounces"
msgstr "Total Ounces"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/clientFunding.tsx:77
msgid "Total ounces (Gold)"
msgstr "Total ounces (Gold)"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/clientFunding.tsx:85
msgid "Total ounces (Silver)"
msgstr "Total ounces (Silver)"

#: src/routes/_authenticated/referrals/-components/ReferralMetrics.tsx:47
msgid "Total Referrals Sent"
msgstr "Total Referrals Sent"

#: src/routes/_authenticated/balance/-components/PremiumSummaryCard.tsx:88
msgid "Total Value"
msgstr "Total Value"

#: src/routes/_authenticated/trade/-components/ShipMetal/PackingSlipReview.tsx:55
msgid "Total Weight (Oz):"
msgstr "Total Weight (Oz):"

#: src/routes/_authenticated/trade/withdraw/cash/review.tsx:131
#~ msgid "Track the status of your withdrawal under Recent Transactions."
#~ msgstr "Track the status of your withdrawal under Recent Transactions."

#: src/shared/components/MainNavContainer.tsx:46
msgid "Trade"
msgstr "Trade"

#: src/routes/_authenticated/trade/-components/requestView.ts:165
msgid "Trade Executed"
msgstr "Trade Executed"

#: src/components/Trade/RequestStatus.tsx:57
#~ msgid "Trade Finalized"
#~ msgstr "Trade Finalized"

#: src/routes/_authenticated/trade/-components/requestView.ts:163
msgid "Trade Pending"
msgstr "Trade Pending"

#: src/shared/components/MainNavContainer.tsx:48
msgid "Trade: Buy and Sell"
msgstr "Trade: Buy and Sell"

#: src/routes/_authenticated/trade/withdraw/cash/review.tsx:120
msgid "Transaction Type"
msgstr "Transaction Type"

#. placeholder {0}: pendingFormData.transferWeight
#. placeholder {1}: pendingFormData.metalType
#. placeholder {2}: pendingFormData.fromAccount
#. placeholder {3}: pendingFormData.toAccount
#: src/routes/_authenticated/trade/-components/MetalTransfer.tsx:99
msgid "Transfer {0} oz of {1} from {2} to {3}"
msgstr "Transfer {0} oz of {1} from {2} to {3}"

#: src/routes/_authenticated/trade/-components/MetalTransfer.tsx:190
msgid "Transfer Amount"
msgstr "Transfer Amount"

#: src/routes/_authenticated/trade/-components/MetalTransfer.tsx:79
msgid "Transfer amount exceeds available balance of {availableBalanceString}"
msgstr "Transfer amount exceeds available balance of {availableBalanceString}"

#: src/routes/_authenticated/trade/-components/VaultTransfer.tsx:204
msgid "Transfer Requires Review"
msgstr "Transfer Requires Review"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/accountType.ts:37
msgid "Trust"
msgstr "Trust"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:213
msgid "Trust account signatory #2 email (cannot be the same as owner's email)"
msgstr "Trust account signatory #2 email (cannot be the same as owner's email)"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:197
msgid "Trust account signatory #2 first name"
msgstr "Trust account signatory #2 first name"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:205
msgid "Trust account signatory #2 last name"
msgstr "Trust account signatory #2 last name"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:227
msgid "Trust account signatory #2 phone"
msgstr "Trust account signatory #2 phone"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:263
msgid "Trust address"
msgstr "Trust address"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/clientInfo.ts:55
msgid "Trust Details"
msgstr "Trust Details"

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:68
msgid "Trust EIN"
msgstr "Trust EIN"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:335
msgid "Trust mailing address"
msgstr "Trust mailing address"

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:67
msgid "Trust Tax ID"
msgstr "Trust Tax ID"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:435
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:557
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:678
msgid "Trustee type"
msgstr "Trustee type"

#: src/routes/_authenticated/settings/-components/MFAManageForm.tsx:38
#: src/routes/_authenticated/trade/-components/Withdrawal/ShippingScreen.tsx:87
#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:661
#: src/shared/components/AuthenticatedView.tsx:39
#: src/shared/components/payment-methods/UpgradePaymentMethodDialog.tsx:239
msgid "Try again"
msgstr "Try again"

#: src/routes/_authenticated/trade/withdraw/products/signature.tsx:73
msgid "Try again later or contact Client Relations if the problem continues."
msgstr "Try again later or contact Client Relations if the problem continues."

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:653
msgid "Try again to confirm two-factor authentication is set up before you withdraw."
msgstr "Try again to confirm two-factor authentication is set up before you withdraw."

#: src/shared/components/Footer.tsx:31
msgid "Tutorial"
msgstr "Tutorial"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:649
msgid "Two additional beneficial owners to declare"
msgstr "Two additional beneficial owners to declare"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:413
msgid "Two additional trustees"
msgstr "Two additional trustees"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:282
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:171
msgid "Two Signers"
msgstr "Two Signers"

#: src/routes/_authenticated/settings/-components/MFAManageForm.tsx:48
msgid "Two-Factor Authentication"
msgstr "Two-Factor Authentication"

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:640
msgid "Two-factor authentication helps prevent someone else from moving your metal, even if they know your password. Set it up in order to request cash or product withdrawals."
msgstr "Two-factor authentication helps prevent someone else from moving your metal, even if they know your password. Set it up in order to request cash or product withdrawals."

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:645
#~ msgid "Two-factor authentication helps prevent someone else from moving your metal, even if they know your password. Set it up once to request cash or product withdrawals."
#~ msgstr "Two-factor authentication helps prevent someone else from moving your metal, even if they know your password. Set it up once to request cash or product withdrawals."

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:101
msgid "Type of trust:"
msgstr "Type of trust:"

#: src/routes/_authenticated/opportunities/-components/ReviewPeriodAlert.tsx:68
msgid "Unable to finalize choices at this time. Please try again later or contact our support team if the issue persists."
msgstr "Unable to finalize choices at this time. Please try again later or contact our support team if the issue persists."

#: src/routes/_authenticated/opportunities/unsecured/$leaseInstance.tsx:85
msgid "Unable to generate the unallocated lease agreement right now. Please try again later."
msgstr "Unable to generate the unallocated lease agreement right now. Please try again later."

#: src/shared/components/ActivityView.tsx:322
msgid "Unable to load account activity."
msgstr "Unable to load account activity."

#: src/routes/_authenticated/documents/statement.tsx:54
msgid "Unable to load account details"
msgstr "Unable to load account details"

#: src/routes/_authenticated/documents/-components/StatementListItem.tsx:63
msgid "Unable to load statement. Please try again later or contact our support team if the issue persists."
msgstr "Unable to load statement. Please try again later or contact our support team if the issue persists."

#: src/shared/components/EmulateUserDialog.tsx:133
msgid "Unable to load users. You can still enter a Cognito ID."
msgstr "Unable to load users. You can still enter a Cognito ID."

#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:359
msgid "Unable to proceed with purchase"
msgstr "Unable to proceed with purchase"

#: src/routes/_authenticated/trade/-components/MetalTransfer.tsx:118
#: src/routes/_authenticated/trade/-components/MetalTransfer.tsx:208
#: src/routes/_authenticated/trade/-components/MetalTransfer.tsx:212
msgid "Unable to process metal transfer. Please try again."
msgstr "Unable to process metal transfer. Please try again."

#: src/routes/_authenticated/opportunities/unsecured/$leaseInstance.tsx:164
msgid "Unable To Start Signing"
msgstr "Unable To Start Signing"

#: src/routes/_authenticated/opportunities/-components/Opportunity.tsx:140
msgid "Unable to update lease preference. Please try again later or contact our support team if the issue persists."
msgstr "Unable to update lease preference. Please try again later or contact our support team if the issue persists."

#: src/routes/_authenticated/opportunities/-components/LeasesPageControls.tsx:42
#: src/routes/_authenticated/opportunities/-components/opportunityBanners.ts:38
msgid "Unallocated"
msgstr "Unallocated"

#: src/routes/_authenticated/opportunities/unsecured/$leaseInstance.tsx:181
msgid "Unallocated Lease Agreement"
msgstr "Unallocated Lease Agreement"

#: src/routes/_authenticated/opportunities/-components/opportunityBanners.ts:30
#: src/routes/_authenticated/yield/-components/YieldTable.tsx:93
msgid "Unavailable"
msgstr "Unavailable"

#: src/util/feeSchedule.ts:11
msgid "Under $250K"
msgstr "Under $250K"

#: src/routes/_authenticated/opportunities/-components/ReviewPeriodAlert.tsx:94
msgid "Understanding the Account Review Period"
msgstr "Understanding the Account Review Period"

#: src/routes/_authenticated/trade/withdraw/products/review.tsx:34
msgid "unit"
msgstr "unit"

#: src/routes/_authenticated/trade/withdraw/products/review.tsx:34
msgid "units"
msgstr "units"

#: src/routes/_authenticated/balance/-components/BalanceOverviewCard.tsx:41
msgid "Unknown"
msgstr "Unknown"

#: src/routes/_authenticated/opportunities/-components/LeasesPageControls.tsx:36
msgid "Upcoming"
msgstr "Upcoming"

#: src/routes/_authenticated/settings/-components/PasswordForm.tsx:83
msgid "Update Password"
msgstr "Update Password"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:505
msgid "Upload company documents"
msgstr "Upload company documents"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:363
msgid "Upload government-issued photo ID"
msgstr "Upload government-issued photo ID"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:369
msgid "Upload government-issued photo ID here"
msgstr "Upload government-issued photo ID here"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:235
msgid "Upload trust documentation and identify other trustees"
msgstr "Upload trust documentation and identify other trustees"

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:57
#: src/routes/_authenticated/onboarding/-components/Signatory2ReviewAndSign.tsx:64
msgid "US Citizen"
msgstr "US Citizen"

#: src/routes/_authenticated/balance/-components/BalanceOverviewCard.tsx:29
msgid "US Dollar"
msgstr "US Dollar"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:131
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:121
msgid "US-Based"
msgstr "US-Based"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:127
msgid "US-based or foreign-based?"
msgstr "US-based or foreign-based?"

#: src/shared/components/ConversionPicker.tsx:25
#: src/shared/components/ConversionPicker.tsx:41
#: src/shared/components/ConversionPicker.tsx:56
#: src/util/assetLabels.ts:21
msgid "USD"
msgstr "USD"

#: src/routes/_authenticated/balance/-components/balancePayloadGenerators.tsx:56
msgid "USD on Deposit"
msgstr "USD on Deposit"

#: src/routes/_authenticated/trade/-components/Withdrawal/ShippingScreen.tsx:118
msgid "Use a different address"
msgstr "Use a different address"

#: src/routes/_authenticated/trade/-components/Withdrawal/ShippingScreen.tsx:78
#: src/routes/_authenticated/trade/-components/Withdrawal/ShippingScreen.tsx:104
msgid "Use my address on file"
msgstr "Use my address on file"

#: src/shared/components/EmulateUserDialog.tsx:89
msgid "User ID (Cognito ID)"
msgstr "User ID (Cognito ID)"

#: src/routes/_authenticated/referrals/-components/ReferralMetrics.tsx:64
msgid "Users who finished onboarding and funded their accounts."
msgstr "Users who finished onboarding and funded their accounts."

#: src/routes/_authenticated/referrals/-components/ReferralMetrics.tsx:57
msgid "Users who signed up but haven't completed onboarding (KYC, ID verification, etc.)."
msgstr "Users who signed up but haven't completed onboarding (KYC, ID verification, etc.)."

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:392
msgid "Utility bills, bank, and insurance statements must be dated within the last 90 days. Lease or rental agreements must be current and unexpired."
msgstr "Utility bills, bank, and insurance statements must be dated within the last 90 days. Lease or rental agreements must be current and unexpired."

#: src/routes/_authenticated/balance/premiums.tsx:180
msgid "Value (oz)"
msgstr "Value (oz)"

#: src/routes/_authenticated/balance/premiums.tsx:181
msgid "Value (USD)"
msgstr "Value (USD)"

#: src/shared/components/payment-methods/PlaidFinalizeForm.tsx:127
msgid "Vault"
msgstr "Vault"

#: src/routes/_authenticated/trade/-components/VaultTransfer.tsx:177
msgid "Vault Account Number"
msgstr "Vault Account Number"

#: src/routes/_authenticated/trade/-components/VaultTransfer.tsx:161
msgid "Vault Location"
msgstr "Vault Location"

#: src/routes/_authenticated/trade.tsx:39
#: src/routes/_authenticated/trade/-components/SendMetal.tsx:10
#: src/routes/_authenticated/trade/-components/VaultTransfer.tsx:153
msgid "Vault Transfer"
msgstr "Vault Transfer"

#. placeholder {0}: belowMinMetals[0]
#. placeholder {1}: transferConstants?.[belowMinMetals[0]]?.min ?? 0
#: src/routes/_authenticated/trade/-components/VaultTransfer.tsx:207
msgid "Vault transfers require total weight of {0} to be greater than or equal to {1} oz."
msgstr "Vault transfers require total weight of {0} to be greater than or equal to {1} oz."

#: src/routes/_authenticated/trade/-components/VaultLocationComboBox.tsx:119
msgid "Vendor"
msgstr "Vendor"

#: src/routes/_authenticated/onboarding/-components/Signatory2ReviewAndSign.tsx:71
msgid "Verification"
msgstr "Verification"

#: src/shared/components/payment-methods/PaymentMethodVerification.tsx:53
#: src/shared/components/payment-methods/PaymentMethodVerification.tsx:74
msgid "Verify"
msgstr "Verify"

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalReview.tsx:169
msgid "Verify and submit"
msgstr "Verify and submit"

#: src/routes/_unauthenticated/-components/EmailVerification.tsx:55
#: src/routes/_unauthenticated/-components/EmailVerification.tsx:70
msgid "Verify Email"
msgstr "Verify Email"

#: src/routes/_authenticated/trade/withdraw/cash/payout.tsx:45
msgid "Verify how you want to be paid."
msgstr "Verify how you want to be paid."

#: src/shared/components/payment-methods/PaymentMethodVerification.tsx:58
msgid "Verify Payment Method"
msgstr "Verify Payment Method"

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalReview.tsx:137
msgid "Verify to submit"
msgstr "Verify to submit"

#: src/routes/_authenticated/trade/withdraw/cash/payout.tsx:48
msgid "Verify your bank details"
msgstr "Verify your bank details"

#: src/routes/_unauthenticated/-components/RecoveryCode.tsx:53
msgid "Verifying"
msgstr "Verifying"

#: src/routes/_authenticated/opportunities/-components/Opportunity.tsx:153
msgid "View Agreement"
msgstr "View Agreement"

#: src/shared/components/NotificationsDropdown.tsx:47
msgid "View All"
msgstr "View All"

#: src/shared/components/MainNavContainer.tsx:53
msgid "View and manage your referrals"
msgstr "View and manage your referrals"

#: src/routes/_authenticated/opportunities/-components/Opportunity.tsx:355
#: src/routes/_authenticated/opportunities/-components/Opportunity.tsx:420
msgid "View Announcement"
msgstr "View Announcement"

#: src/shared/components/EmulateUserDialog.tsx:84
msgid "View As User"
msgstr "View As User"

#: src/routes/_authenticated/balance/-components/PremiumSummaryCard.tsx:95
msgid "View Details"
msgstr "View Details"

#: src/routes/_authenticated/trade/-components/MetalTransfer.tsx:213
msgid "View Order"
msgstr "View Order"

#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:607
msgid "View Order Details"
msgstr "View Order Details"

#: src/shared/components/ActivityView.tsx:290
msgid "View PDF statements"
msgstr "View PDF statements"

#: src/routes/_authenticated/opportunities/-components/Opportunity.tsx:366
#: src/routes/_authenticated/opportunities/-components/Opportunity.tsx:431
msgid "View Presentation"
msgstr "View Presentation"

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:381
msgid "View Recent Transactions"
msgstr "View Recent Transactions"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/NewScheduleForm.tsx:186
msgid "View Recurring Purchases"
msgstr "View Recurring Purchases"

#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:606
msgid "View Wire Instructions"
msgstr "View Wire Instructions"

#: src/shared/components/PortalTutorialButton.tsx:11
msgid "Watch the portal tutorial"
msgstr "Watch the portal tutorial"

#: src/components/Trade/RequestStatus.tsx:80
#~ msgid "We are collecting your funds. ACH takes 3 to 5 business days."
#~ msgstr "We are collecting your funds. ACH takes 3 to 5 business days."

#: src/shared/components/FeedbackDialogPrompt.tsx:28
msgid "We are committed to providing you with the best client experience possible. Your feedback helps us improve. Please share your suggestions or report any issues so our team can review."
msgstr "We are committed to providing you with the best client experience possible. Your feedback helps us improve. Please share your suggestions or report any issues so our team can review."

#: src/routes/_authenticated/trade/withdraw/products/signature.tsx:49
msgid "We are creating the document with your withdrawal details."
msgstr "We are creating the document with your withdrawal details."

#: src/components/Trade/RequestStatus.tsx:84
#~ msgid "We are executing your purchase at the next trading window."
#~ msgstr "We are executing your purchase at the next trading window."

#: src/components/Trade/RequestStatus.tsx:83
#~ msgid "We are executing your sale at the next trading window."
#~ msgstr "We are executing your sale at the next trading window."

#: src/routes/_authenticated/balance/index.tsx:83
#: src/shared/components/route-state/AuthenticatedErrorBoundary.tsx:62
msgid "We are having trouble loading your account details. Please try again later or contact our support team if the issue persists."
msgstr "We are having trouble loading your account details. Please try again later or contact our support team if the issue persists."

#: src/routes/_authenticated/balance/premiums.tsx:269
msgid "We are having trouble loading your premium products. Please try again later or contact our support team if the issue persists."
msgstr "We are having trouble loading your premium products. Please try again later or contact our support team if the issue persists."

#: src/routes/_authenticated/trade/withdraw/products/review.tsx:52
#~ msgid "We confirm product availability and pricing."
#~ msgstr "We confirm product availability and pricing."

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:650
msgid "We could not check your security settings"
msgstr "We could not check your security settings"

#: src/routes/_authenticated/settings/-components/MFAManageForm.tsx:37
#: src/shared/components/AuthenticatedView.tsx:38
msgid "We could not check your security settings. Try again."
msgstr "We could not check your security settings. Try again."

#: src/routes/_authenticated/trade/-components/Withdrawal/ShippingScreen.tsx:86
msgid "We could not load your address on file."
msgstr "We could not load your address on file."

#: src/routes/_authenticated/trade/withdraw/products/signature.tsx:71
msgid "We could not prepare your document"
msgstr "We could not prepare your document"

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalReview.tsx:270
msgid "We could not submit your withdrawal. Try again using the button below. If it still fails, contact Client Relations."
msgstr "We could not submit your withdrawal. Try again using the button below. If it still fails, contact Client Relations."

#: src/shared/components/payment-methods/UpgradePaymentMethodDialog.tsx:127
msgid "We couldn't connect your account"
msgstr "We couldn't connect your account"

#: src/shared/components/payment-methods/UpgradePaymentMethodDialog.tsx:125
msgid "We couldn't upgrade this payment method"
msgstr "We couldn't upgrade this payment method"

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:368
msgid "We have received your withdrawal request and have sent you a confirmation email."
msgstr "We have received your withdrawal request and have sent you a confirmation email."

#: src/shared/components/payment-methods/PaymentMethodVerification.tsx:59
msgid "We have sent and returned two small deposits to your bank account. Please enter the amounts below to verify your access to this account."
msgstr "We have sent and returned two small deposits to your bank account. Please enter the amounts below to verify your access to this account."

#: src/shared/components/route-state/StaleContentFallback.tsx:44
msgid "We Have Updated Our Website"
msgstr "We Have Updated Our Website"

#: src/routes/_authenticated/settings/-components/payment-methods/PlaidFinalizeForm.tsx:78
#~ msgid "We just need a few more details connect this account to our platform."
#~ msgstr "We just need a few more details connect this account to our platform."

#: src/routes/_authenticated/settings/-components/payment-methods/PlaidFinalizeForm.tsx:79
#~ msgid "We just need a few more details to connect these accounts to our platform."
#~ msgstr "We just need a few more details to connect these accounts to our platform."

#: src/components/Trade/RequestStatus.tsx:76
#~ msgid "We received your order."
#~ msgstr "We received your order."

#: src/components/Trade/RequestStatus.tsx:75
#~ msgid "We received your request. Your metal is reserved and can no longer be leased."
#~ msgstr "We received your request. Your metal is reserved and can no longer be leased."

#: src/routes/_authenticated/opportunities/unsecured/$leaseInstance.tsx:121
msgid "We received your signature, but could not finish lease opt-in. Please contact support."
msgstr "We received your signature, but could not finish lease opt-in. Please contact support."

#: src/shared/components/payment-methods/AddPaymentMethodChooser.tsx:57
msgid "We recommend Plaid. It verifies your bank account instantly, so you can use it right away. <0>Learn more</0>."
msgstr "We recommend Plaid. It verifies your bank account instantly, so you can use it right away. <0>Learn more</0>."

#: src/shared/components/payment-methods/NewPaymentMethod.tsx:53
msgid "We recommend Plaid. It verifies your bank account instantly, so you can use it right away. If you enter your details manually, verification can take up to 3 business days, and the account cannot be used for trading until it is verified."
msgstr "We recommend Plaid. It verifies your bank account instantly, so you can use it right away. If you enter your details manually, verification can take up to 3 business days, and the account cannot be used for trading until it is verified."

#: src/routes/_authenticated/settings/-components/payment-methods/NewPaymentMethod.tsx:100
#~ msgid "We recommend using Plaid to instantly verify access to your bank account. If you choose to manually enter your bank account details, it may take up to 3 business days to verify your account. Unverified accounts cannot be used for trading."
#~ msgstr "We recommend using Plaid to instantly verify access to your bank account. If you choose to manually enter your bank account details, it may take up to 3 business days to verify your account. Unverified accounts cannot be used for trading."

#: src/routes/_authenticated/settings/-components/ManageCookiesForm.tsx:30
#: src/shared/components/CookiesConsentBanner.tsx:58
msgid "We use cookies to remember your preferences and optimize your experience. By clicking \"Accept\", you consent to the use of all cookies. If you do not accept, some functionality may be limited."
msgstr "We use cookies to remember your preferences and optimize your experience. By clicking \"Accept\", you consent to the use of all cookies. If you do not accept, some functionality may be limited."

#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:360
msgid "We were unable to complete your purchase due to an existing balance in your account. Please work with a relationship manager to purchase metal using your existing balance."
msgstr "We were unable to complete your purchase due to an existing balance in your account. Please work with a relationship manager to purchase metal using your existing balance."

#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:401
#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:466
msgid "We were unable to complete your purchase. Please try again later or reach out to your RM if the problem persists."
msgstr "We were unable to complete your purchase. Please try again later or reach out to your RM if the problem persists."

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/NewScheduleForm.tsx:347
msgid "We were unable to create your purchase schedule. Please try again later or reach out to your RM if the problem persists."
msgstr "We were unable to create your purchase schedule. Please try again later or reach out to your RM if the problem persists."

#: src/shared/components/payment-methods/ManagePaymentMethods.tsx:49
msgid "We were unable to delete your payment method. Please try again later or reach out to your RM if the problem persists."
msgstr "We were unable to delete your payment method. Please try again later or reach out to your RM if the problem persists."

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/RecurringPurchases.tsx:287
msgid "We were unable to delete your schedule. Please try again later or reach out to your RM if the problem persists."
msgstr "We were unable to delete your schedule. Please try again later or reach out to your RM if the problem persists."

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/RecurringPurchases.tsx:182
msgid "We were unable to pause your schedule. Please try again later or reach out to your RM if the problem persists."
msgstr "We were unable to pause your schedule. Please try again later or reach out to your RM if the problem persists."

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/RecurringPurchases.tsx:244
msgid "We were unable to resume your schedule. Please try again later or reach out to your RM if the problem persists."
msgstr "We were unable to resume your schedule. Please try again later or reach out to your RM if the problem persists."

#: src/shared/components/payment-methods/ManualAchForm.tsx:56
msgid "We were unable to save your payment method. Please try again later or reach out to your RM if the problem persists."
msgstr "We were unable to save your payment method. Please try again later or reach out to your RM if the problem persists."

#: src/routes/_unauthenticated/-components/NewPassword.tsx:46
#: src/routes/_unauthenticated/-components/ResetPassword.tsx:52
#: src/routes/_unauthenticated/-components/SignIn.tsx:72
#: src/routes/_unauthenticated/-components/SignIn.tsx:106
#: src/routes/_unauthenticated/sign-in.tsx:67
#: src/shared/components/Authenticator.tsx:152
msgid "We were unable to sign you in to your account. Please try again later or reach out to support if the issue persists."
msgstr "We were unable to sign you in to your account. Please try again later or reach out to support if the issue persists."

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/EditScheduleForm.tsx:171
msgid "We were unable to update your purchase schedule. Please try again later or reach out to your RM if the problem persists."
msgstr "We were unable to update your purchase schedule. Please try again later or reach out to your RM if the problem persists."

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/RecurringPurchases.tsx:134
msgid "We were unable to update your schedule. Please try again later or reach out to your RM if the problem persists."
msgstr "We were unable to update your schedule. Please try again later or reach out to your RM if the problem persists."

#: src/shared/components/payment-methods/PaymentMethodVerification.tsx:41
msgid "We were unable to verify your payment method. Please try again later."
msgstr "We were unable to verify your payment method. Please try again later."

#: src/shared/components/payment-methods/UpgradePaymentMethodDialog.tsx:199
msgid "We'll keep your account name and payment history."
msgstr "We'll keep your account name and payment history."

#: src/routes/_unauthenticated/-components/SignUp.tsx:241
msgid "We'll save your details and follow up - no account will be created today."
msgstr "We'll save your details and follow up - no account will be created today."

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:23
#: src/routes/_authenticated/onboarding/-components/Signatory2ReviewAndSign.tsx:21
msgid "We've pre-filled your account documents with the information you've provided in the previous steps. The next and final step is to review and sign your account documents."
msgstr "We've pre-filled your account documents with the information you've provided in the previous steps. The next and final step is to review and sign your account documents."

#: src/routes/_authenticated/trade/-components/Withdrawal/SelectedProductsTable.tsx:66
msgid "Weight"
msgstr "Weight"

#: src/routes/_authenticated/trade/-components/MetalTypeComboBox.tsx:133
#: src/routes/_authenticated/trade/-components/VaultTransfer.tsx:188
msgid "Weight (oz)"
msgstr "Weight (oz)"

#: src/routes/_authenticated/trade/-components/ShipMetal/ShipMetalForm.tsx:207
msgid "Weight (Oz)"
msgstr "Weight (Oz)"

#: src/routes/_authenticated/trade/-components/ShipMetal/PackingSlipReview.tsx:37
msgid "Weight Each (Oz)"
msgstr "Weight Each (Oz)"

#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalReview.tsx:28
msgid "What happens next?"
msgstr "What happens next?"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:66
msgid "What is your occupation / source of income?"
msgstr "What is your occupation / source of income?"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/clientFunding.tsx:49
msgid "What type of metal would you like to send in?"
msgstr "What type of metal would you like to send in?"

#: src/routes/_authenticated/referrals/-components/ReferralInviteModal.tsx:94
msgid "When they sign up using your referral and fund their account, both you and your friend will receive {bonusAmount} as a welcome bonus."
msgstr "When they sign up using your referral and fund their account, both you and your friend will receive {bonusAmount} as a welcome bonus."

#: src/routes/_authenticated/referrals/-components/ReferralInviteModal.tsx:86
msgid "When your friend signs up and funds their account, you'll both receive a gold reward!"
msgstr "When your friend signs up and funds their account, you'll both receive a gold reward!"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:224
msgid "Which one of these four entities are you?"
msgstr "Which one of these four entities are you?"

#: src/shared/components/payment-methods/PlaidFinalizeForm.tsx:124
msgid "Which payment type(s) would you like to use with this account?"
msgstr "Which payment type(s) would you like to use with this account?"

#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:527
#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:683
#: src/routes/_authenticated/trade/-components/RequestStatus.tsx:230
#: src/routes/_authenticated/trade/withdraw/cash/payout.tsx:104
#: src/routes/_authenticated/trade/withdraw/cash/review.tsx:109
#: src/shared/components/payment-methods/PlaidFinalizeForm.tsx:127
msgid "Wire"
msgstr "Wire"

#: src/shared/components/payment-methods/WireFormSection.tsx:26
msgid "Wire Payment Details"
msgstr "Wire Payment Details"

#: src/routes/_authenticated/trade.tsx:51
#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:290
#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:635
#: src/routes/_authenticated/trade/-components/Withdrawal/WithdrawalFlow.tsx:648
msgid "Withdraw"
msgstr "Withdraw"

#: src/routes/_authenticated/trade/withdraw/products/index.tsx:108
msgid "Withdraw physical coins and bars."
msgstr "Withdraw physical coins and bars."

#: src/routes/_authenticated/trade/-components/PendingTransaction.tsx:160
#: src/routes/_authenticated/trade/withdraw/cash/review.tsx:102
msgid "Withdrawal"
msgstr "Withdrawal"

#: src/routes/_authenticated/trade/withdraw/products/signature.tsx:132
msgid "Withdrawal authorization"
msgstr "Withdrawal authorization"

#: src/routes/_authenticated/trade/-components/RequestStatus.tsx:217
#: src/routes/_authenticated/trade/withdraw/products/review.tsx:24
msgid "Withdrawal details"
msgstr "Withdrawal details"

#: src/routes/_authenticated/trade/-components/RequestStatus.tsx:171
msgid "Withdrawal status"
msgstr "Withdrawal status"

#: src/routes/_authenticated/trade/-components/requestView.ts:158
msgid "Withdrawal Submitted"
msgstr "Withdrawal Submitted"

#: src/routes/_authenticated/trade/withdraw/cash/payout.tsx:123
#: src/routes/_authenticated/trade/withdraw/cash/review.tsx:117
msgid "Withdrawal summary"
msgstr "Withdrawal summary"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/clientFunding.tsx:99
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:161
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:356
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:429
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:628
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:724
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:799
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:875
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:951
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/foreignCorpDocs.ts:126
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/foreignCorpDocs.ts:162
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/foreignCorpDocs.ts:198
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/foreignCorpDocs.ts:234
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:157
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:273
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:379
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfoJointOwnerInfo.ts:36
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:255
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:325
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:397
#: src/routes/_authenticated/onboarding/-components/config/secondarySignatory/sections/signatory2Details.ts:46
#: src/routes/_authenticated/onboarding/-components/config/secondarySignatory/sections/signatory2Details.ts:88
#: src/routes/_authenticated/onboarding/-components/config/secondarySignatory/sections/signatory2Details.ts:135
#: src/routes/_authenticated/onboarding/-components/config/secondarySignatory/sections/signatory2Details.ts:155
msgid "Yes"
msgstr "Yes"

#: src/shared/components/payment-methods/FinalizePlaidPaymentMethod.tsx:89
msgid "Yes, cancel connection"
msgstr "Yes, cancel connection"

#: src/routes/_unauthenticated/-components/SignUp.tsx:306
msgid "Yes, I'd like to receive updates from Monetary Metals"
msgstr "Yes, I'd like to receive updates from Monetary Metals"

#: src/routes/_authenticated/trade/-components/Purchase/PendingTransactionDiaog.tsx:43
msgid "Yes, Proceed with Purchase"
msgstr "Yes, Proceed with Purchase"

#: src/routes/_authenticated/balance/-components/BalanceTable.tsx:35
#: src/shared/components/MainNavContainer.tsx:30
#: src/shared/components/payment-methods/PlaidFinalizeForm.tsx:127
msgid "Yield"
msgstr "Yield"

#: src/shared/components/MainNavContainer.tsx:32
msgid "Yield: See your yield summary"
msgstr "Yield: See your yield summary"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/clientFunding.tsx:22
msgid "You can fund your Monetary Metals account by purchasing gold and silver or by sending in metal you already own. If you want to send metal, our Relationship Team will assist you in securely shipping or transferring it into our network of vault partners."
msgstr "You can fund your Monetary Metals account by purchasing gold and silver or by sending in metal you already own. If you want to send metal, our Relationship Team will assist you in securely shipping or transferring it into our network of vault partners."

#: src/routes/_authenticated/opportunities/-components/ReviewPeriodAlert.tsx:88
msgid "You can review and change your preferences at any time during this period. Once the review period has ended, you will join any active leases you have opted into. Should you want to join leases early, you can end the review period early to finalize all choices."
msgstr "You can review and change your preferences at any time during this period. Once the review period has ended, you will join any active leases you have opted into. Should you want to join leases early, you can end the review period early to finalize all choices."

#: src/routes/_authenticated/settings/-components/payment-methods/UpgradePaymentMethodDialog.tsx:190
#~ msgid "You can still add a bank account through Plaid from Manage payment methods."
#~ msgstr "You can still add a bank account through Plaid from Manage payment methods."

#: src/routes/_authenticated/trade/withdraw/cash/review.tsx:131
msgid "You can track the status of your withdrawal under Recent Transactions."
msgstr "You can track the status of your withdrawal under Recent Transactions."

#: src/routes/_authenticated/trade/withdraw/cash/review.tsx:150
#~ msgid "You can track this request from Recent Transactions."
#~ msgstr "You can track this request from Recent Transactions."

#: src/routes/_authenticated/trade/withdraw/cash/review.tsx:150
msgid "You can track this request in Recent Transactions."
msgstr "You can track this request in Recent Transactions."

#: src/routes/_authenticated/balance/index.tsx:42
msgid "You do not have any balances currently. To initiate a purchase of metal to fund your account, click here."
msgstr "You do not have any balances currently. To initiate a purchase of metal to fund your account, click here."

#: src/routes/_authenticated/onboarding/-components/config/accreditedInvestorDescription.tsx:8
msgid "You do not need to be an <0>accredited investor</0> to open an account."
msgstr "You do not need to be an <0>accredited investor</0> to open an account."

#: src/routes/_authenticated/yield.tsx:43
msgid "You don't currently have any metal in yield. Join a lease now to start earning interest."
msgstr "You don't currently have any metal in yield. Join a lease now to start earning interest."

#: src/routes/_authenticated/balance/premiums.tsx:51
msgid "You don't currently have any premium products on account."
msgstr "You don't currently have any premium products on account."

#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:560
msgid "You have a pending ACH purchase. Please wait for it to complete before submitting another ACH order."
msgstr "You have a pending ACH purchase. Please wait for it to complete before submitting another ACH order."

#: src/routes/_authenticated/trade/-components/Purchase/PendingTransactionDiaog.tsx:29
msgid "You have a purchase that is still being processed. Submitting another purchase may result in duplicate orders."
msgstr "You have a purchase that is still being processed. Submitting another purchase may result in duplicate orders."

#: src/shared/components/IdleTimer.tsx:45
msgid "You have been inactive for a while"
msgstr "You have been inactive for a while"

#: src/routes/_authenticated/settings/-components/PasswordForm.tsx:57
msgid "You have entered an incorrect username or password."
msgstr "You have entered an incorrect username or password."

#: src/routes/_authenticated/trade/-components/PendingTransactions.tsx:49
msgid "You have no recent transactions."
msgstr "You have no recent transactions."

#: src/routes/_authenticated/opportunities/index.tsx:138
msgid "You have successfully signed and submitted your unallocated lease agreement and are now opted in to this lease."
msgstr "You have successfully signed and submitted your unallocated lease agreement and are now opted in to this lease."

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/EditScheduleForm.tsx:280
msgid "You have unsaved changes to your purchase schedule. If you do not save them before leaving, the existing purchase schedule will continue to be used as is."
msgstr "You have unsaved changes to your purchase schedule. If you do not save them before leaving, the existing purchase schedule will continue to be used as is."

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/EditScheduleForm.tsx:134
#: src/routes/_authenticated/trade/-components/Purchase/Recurring/NewScheduleForm.tsx:312
msgid "You may only have one recurring purchase schedule with this account and payment method. Please modify the existing schedule with this payment method or use an alternate form of payment."
msgstr "You may only have one recurring purchase schedule with this account and payment method. Please modify the existing schedule with this payment method or use an alternate form of payment."

#: src/routes/_authenticated/trade/withdraw/products/review.tsx:53
msgid "You review and finalize the quote before we ship."
msgstr "You review and finalize the quote before we ship."

#: src/routes/_authenticated/trade/withdraw/cash/review.tsx:130
msgid "You will receive a trade confirmation by email."
msgstr "You will receive a trade confirmation by email."

#: src/routes/_authenticated/yield/-components/YieldCard.tsx:72
msgid "Your {commodityCapitalized} yield is the weighted average rate that you are earning on all your allocated {commodityCapitalized} to both leases and bonds."
msgstr "Your {commodityCapitalized} yield is the weighted average rate that you are earning on all your allocated {commodityCapitalized} to both leases and bonds."

#: src/routes/_authenticated/yield/-components/YieldCard.tsx:67
msgid "Your {commodityCapitalized} Yield: {formattedYield}%"
msgstr "Your {commodityCapitalized} Yield: {formattedYield}%"

#: src/routes/_authenticated/yield/-components/YieldTable.tsx:71
msgid "Your {typeLabel} Yield: {formattedYield}"
msgstr "Your {typeLabel} Yield: {formattedYield}"

#: src/routes/_authenticated/trade/-components/LockoutAlert.tsx:16
msgid "Your account has been restricted due to unusual transaction activity. Please contact your Relationship Manager to regain trading access for your account. <0>Contact Us</0>"
msgstr "Your account has been restricted due to unusual transaction activity. Please contact your Relationship Manager to regain trading access for your account. <0>Contact Us</0>"

#: src/routes/_authenticated/trade/withdraw/products/signature.tsx:68
#~ msgid "Your account has no address on file. Contact Client Relations to add one before withdrawing."
#~ msgstr "Your account has no address on file. Contact Client Relations to add one before withdrawing."

#: src/routes/_authenticated/trade/withdraw/products/signature.tsx:60
msgid "Your account has no address on file. Go back to the shipping step and enter an address."
msgstr "Your account has no address on file. Go back to the shipping step and enter an address."

#: src/routes/_authenticated/settings/-components/MFAManageForm.tsx:49
msgid "Your account is currently enrolled in two-factor authentication."
msgstr "Your account is currently enrolled in two-factor authentication."

#: src/routes/_unauthenticated/-components/SignIn.tsx:98
msgid "Your account is not verified and there was an error resending the email verification code. Please try logging in again"
msgstr "Your account is not verified and there was an error resending the email verification code. Please try logging in again"

#: src/routes/_unauthenticated/-components/SignIn.tsx:61
#: src/routes/_unauthenticated/-components/SignIn.tsx:93
msgid "Your account is not verified. Please check your email for the verification code."
msgstr "Your account is not verified. Please check your email for the verification code."

#: src/routes/_authenticated/trade/withdraw/products/signature.tsx:61
msgid "Your address on file changed. Go back to the shipping step and confirm it again."
msgstr "Your address on file changed. Go back to the shipping step and confirm it again."

#: src/routes/_authenticated/yield/-components/YieldTable.tsx:61
msgid "Your bond yield is the weighted average rate that you are earning on all the {commodityCapitalized} you have invested in bonds."
msgstr "Your bond yield is the weighted average rate that you are earning on all the {commodityCapitalized} you have invested in bonds."

#: src/routes/_authenticated/trade/withdraw/products/signature.tsx:48
msgid "Your document is ready. The signing form is loading now."
msgstr "Your document is ready. The signing form is loading now."

#: src/components/Trade/RequestStatus.tsx:92
#~ msgid "Your funds have been sent."
#~ msgstr "Your funds have been sent."

#: src/routes/_authenticated/referrals/-components/ReferralInviteModal.tsx:64
msgid "Your invite has been sent successfully!"
msgstr "Your invite has been sent successfully!"

#: src/routes/_authenticated/yield/-components/YieldTable.tsx:60
msgid "Your lease yield is the weighted average rate that you are earning on all the {commodityCapitalized} you have deployed in leases."
msgstr "Your lease yield is the weighted average rate that you are earning on all the {commodityCapitalized} you have deployed in leases."

#: src/components/Trade/RequestStatus.tsx:92
#~ msgid "Your metal is in your account."
#~ msgstr "Your metal is in your account."

#: src/routes/_authenticated/trade/withdraw/cash/review.tsx:129
msgid "Your metal will be sold at the next trading window."
msgstr "Your metal will be sold at the next trading window."

#: src/routes/_authenticated/trade/withdraw/products/review.tsx:54
msgid "Your metals are shipped with insurance, and we send you the tracking information."
msgstr "Your metals are shipped with insurance, and we send you the tracking information."

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/personalInfo.ts:17
msgid "Your name"
msgstr "Your name"

#: src/shared/components/payment-methods/AddPaymentMethodDialog.tsx:102
msgid "Your payment method has been linked and is ready to use."
msgstr "Your payment method has been linked and is ready to use."

#: src/shared/components/payment-methods/FinalizePlaidPaymentMethod.tsx:55
msgid "Your payment method has been linked successfully."
msgstr "Your payment method has been linked successfully."

#: src/shared/components/payment-methods/NewPaymentMethod.tsx:27
msgid "Your payment method has been saved successfully."
msgstr "Your payment method has been saved successfully."

#: src/shared/components/payment-methods/AddPaymentMethodDialog.tsx:101
msgid "Your payment method has been saved. Two small deposits will arrive in your account within 3 business days. Return to Payment Methods in Settings to enter the amounts and finish verification."
msgstr "Your payment method has been saved. Two small deposits will arrive in your account within 3 business days. Return to Payment Methods in Settings to enter the amounts and finish verification."

#: src/routes/_authenticated/settings/-components/payment-methods/AddPaymentMethodDialog.tsx:96
#~ msgid "Your payment method has been saved. Verification can take up to 3 business days; we will email you when it is ready to use."
#~ msgstr "Your payment method has been saved. Verification can take up to 3 business days; we will email you when it is ready to use."

#: src/routes/_authenticated/trade/-components/Purchase/PurchaseMetal.tsx:596
msgid "Your purchase order has been submitted successfully! You will receive an email confirmation shortly."
msgstr "Your purchase order has been submitted successfully! You will receive an email confirmation shortly."

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/NewScheduleForm.tsx:53
msgid "Your purchase schedule has been created successfully!"
msgstr "Your purchase schedule has been created successfully!"

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/NewScheduleForm.tsx:54
msgid "Your purchase schedule has been updated successfully!"
msgstr "Your purchase schedule has been updated successfully!"

#: src/routes/_authenticated/trade/-components/Purchase/TimedOutTransactionsDialog.tsx:59
msgid "Your purchase transaction has been confirmed."
msgstr "Your purchase transaction has been confirmed."

#: src/routes/_authenticated/trade/-components/Purchase/TimedOutTransactionsDialog.tsx:70
msgid "Your purchase transaction has expired. Please try again."
msgstr "Your purchase transaction has expired. Please try again."

#: src/routes/_authenticated/trade/-components/Purchase/Recurring/RecurringPurchases.tsx:281
msgid "Your recurring purchase schedule has been deleted successfully."
msgstr "Your recurring purchase schedule has been deleted successfully."

#: src/routes/_authenticated/referrals.tsx:105
msgid "Your Referral Information"
msgstr "Your Referral Information"

#: src/components/Trade/RequestStatus.tsx:86
#~ msgid "Your sale is complete."
#~ msgstr "Your sale is complete."

#: src/shared/components/payment-methods/UpgradePaymentMethodDialog.tsx:138
msgid "Your saved account has not changed."
msgstr "Your saved account has not changed."

#: src/shared/components/payment-methods/UpgradePaymentMethodDialog.tsx:203
msgid "Your saved account has not changed. You can add the selected accounts to your profile instead."
msgstr "Your saved account has not changed. You can add the selected accounts to your profile instead."

#. placeholder {0}: needsApprovalMetals[0]
#. placeholder {1}: transferConstants?.[needsApprovalMetals[0]]?.threshold ?? 0
#: src/routes/_authenticated/trade/-components/VaultTransfer.tsx:208
msgid "Your vault transfer can be requested, but {0} transfers under {1} oz require review by a relationship manager."
msgstr "Your vault transfer can be requested, but {0} transfers under {1} oz require review by a relationship manager."

#: src/routes/_authenticated/trade/-components/VaultTransfer.tsx:132
msgid "Your vault transfer has been successfully submitted. A confirmation email has been sent to your relationship manager."
msgstr "Your vault transfer has been successfully submitted. A confirmation email has been sent to your relationship manager."

#: src/routes/_authenticated/trade/withdraw/cash/review.tsx:149
#: src/routes/_authenticated/trade/withdraw/products/signature.tsx:214
msgid "Your withdrawal is in process"
msgstr "Your withdrawal is in process"

#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:82
#: src/routes/_authenticated/onboarding/-components/ClientReviewAndSignView.tsx:92
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:403
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/companyDetails.ts:483
#: src/routes/_authenticated/onboarding/-components/config/secondarySignatory/sections/signatory2Details.ts:73
#: src/routes/_authenticated/onboarding/-components/Signatory2ReviewAndSign.tsx:56
msgid "ZIP"
msgstr "ZIP"

#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:299
#: src/routes/_authenticated/onboarding/-components/config/clientInfo/sections/trustDetails.ts:370
msgid "Zip code"
msgstr "Zip code"
